import { ViewChild, Input, Component, OnInit, ElementRef } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';
import { ClientService } from '../create-client/client.service';
import { Router } from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import Utils from '../shared/utility';
import * as cloneDeep from 'lodash/cloneDeep';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { start } from 'repl';

import Util from '../shared/utility';

import { DecimalPipe } from '@angular/common';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CostProjectionDetailsComponent } from '../shared/modal/cost-projection-details/cost-projection-details.component'
import { CostOfWaitingComponent } from '../shared/modal/cost-of-waiting/cost-of-waiting.component'
import { FundingSourceComponent } from '../shared/modal/funding-source/funding-source.component';
import { MatRadioChange } from '@angular/material';
import { SidebarService } from '../services/sidebar.service';
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';
import { investmentGrowthDecumation } from '../dummy-data/data'
import { ProfileNotEligibleComponent } from 'app/shared/modal/profile-not-eligible/profile-not-eligible.component';

@Component({
  selector: 'app-combined-hc-ltc',
  templateUrl: './combined-hc-ltc.component.html',
  styleUrls: ['./combined-hc-ltc.component.css'],
  //providers: [LoadingService],
  host: {
    '[@fadeInAnimation]': ''
  },
  animations: [
    trigger('fadeInAnimation', [
      transition(':enter', [
        style({
          opacity: 0,
        }),
        animate('1000ms', style({
          opacity: 1,
        }))
      ]),
    ])
  ]
})
export class CombinedHealthCareLTCComponent implements OnInit {
  public pHospMessage: string = "There is no premium cost for Medicare Part A, which covers hospitalization. The premium for Medicare Part B covers doctor visits and test costs.";
  public pDrug: string = "The premium for Medicare Part D covers prescription drug costs.";
  public pSupp: string = "The premium for MediGap covers coinsurance, co-payment and deductible out-of-pocket costs which are not covered by Medicare Parts A and B. MediGap coverage can no longer be purchased to cover Part D prescription drug costs. This coverage is provided through private insurers.";
  public pDental: string = "The premium for dental insurance will cover the standard dental care coverage. Medicare does not cover any routine dental or denture costs.";

  public oopHosp: string = "This represents the annual out-of-pocket costs for doctor visits, tests, etc. which are not covered by the Medicare Part B premium. These costs will be higher if you do not buy MediGap insurance.";
  public oopDrug: string = "This represents the annual out-of-pocket costs which will not be covered by the Medicare Part D premium. This can include the costs which must be paid by an individual if their annual drug costs are between $2750 and $4750 (the 2013 “donut hole” amounts.)";
  public oopHearing: string = "This represents the annual out-of-pocket costs for hearing and vision tests, eyeglasses, etc. which are not covered by Medicare Part B.";
  public oopDental: string = "This represents the annual out-of-pocket costs for dental care, dentures, etc. which are not covered by the standard Dental Insurance policy.";
  public fsMessage: string = "Add any expected income which is earmarked to healthcare cost funding in the inputs below. Values entered will reduce projected unfunded costs, and the investment solution to address that amount.";
  //public ssMMessage: string = "Medicare Part B premiums and Medicare Parts B and D surcharges are automatically deducted out of one’s Social Security benefit.";
  public investmentSolnMessage: string = "Select up to three unique rates of return throughout the client’s lifetime to produce multiple savings solutions for unfounded future health expenses: a one time investment, annual payments, or weekly payments.";
  public ssMMessage: string = "By law, Medicare deducts the cost of Medicare Part B, as well as potential means testing surcharges on Parts B and D, from Social Security checks.";

  public premiumsInfo: string = "Standard, baseline costs for health coverage, paid either to the government, or the insurance provider.";
  public additionalOOPInfo: string = "Costs not covered by premiums. May include copays, deductibles, and more.";

  public investmentToFundInfo: string = 'Based on rates of return indicated at bottom-center of this page, the one-time lumpsum investment required today to cover projected retirement health costs, after additional funding sources are accounted for.';
  public estimatedFutureInfo: string = 'Projected retirement healthcare costs, based on checkboxes below, shown in future dollars (otherwise known as "future value")';
  public estimatedTodayInfo: string = 'Projected retirement healthcare costs, based on checkboxes below, shown in today`s dollars (otherwise known as "net present value")';

  public futureCostMessage: string = `Selecting "Today's Dollars" will show costs in the net present value, assuming an annual inflation rate of 3%. Selecting "Future Dollars" will show projected future costs in the given year.`;
  public currentHouseholdIncomeMessage: string = "This amount is pre-populated based on user inputs but may be overridden.";
  public householdIncomeYearOneMessage: string = "This amount is calculated based on the values to the left but may be overridden.";
  //public currentGrossMonthlyBenefit: string = "Please enter the monthly benefit the client receives before taxes and Medicare withholdings. If the client is impacted by the Earnings Test, Windfall Elimination Provision and/or Government Pension Offset, please enter the entitled benefit amount before these withholdings take place.";
  public incomeInflationRateMessage: string = "The annual rate at which household income is projected to grow in future pre-retirement years.";
  public incomeReplacementRatioMessage: string = "The percentage of pre-retirement income that the household will require in retirement. For example, those earning $100,000 entering retirement age with an 80% IRR would need $80,000 per year to maintain their standard of living.";
  

  public hcData: any;
  public hcDataV2: any;
  public p1CostsV2: any;
  public p2CostsV2: any;
  public tempCostsV2: any;
  public spouseHCOptionsVisible: boolean = false;
  public previousSpouse: any;

  public beginningBalance: 0;

  public tempHCData: any;
  public error: string;

  public client: any;

  public projectedFutureLifetimeCosts: number;
  public totalSocialSecurity: number = 0;
  public totalRemainingGap: number = 0;
  public ssRemaining: number = 0;


  public currentRemainingTotal: number = 0;

  public fundingItems: any[] = [];
  public partnerActive: boolean = false;

  public coverageTotal: number = 0;
  public premiumCoverageTotal: number = 0;
  public outOfPocketCoverageTotal: number = 0;
  public FrmPV: number = 1;
  public spouseHC: number = 0;
  public investmentOptionValue: 0;
  spouseRetirementYear: number = 0;
  clientIndex = 0;
  spouseIndex = 0;

  public lineChartData: any[];
  public pieChartData: any[];
  public barChartData: any[];
  public rOROptions: any[] = [
    {
      text: 'Option 1',
      value: '6%'
    },
    {
      text: 'Option 2',
      value: '7%',
      selected: true
    },
    {
      text: 'Option 3',
      value: '8%'
    }
  ];
  phaseOneYear: string = '2030';
  phaseTwoYear: string = '2040';

  public fundingSource: any;
  public startAge: any;
  public endAge: any;
  public inflationRate: any;
  public annContribution: any;
  showFundingBorder: boolean;
  showStartAgeBorder: boolean;
  showEndAgeBorder: boolean;
  showInflationBorder: boolean;
  showAnnContrBorder: boolean;
  clientSpouseFullName;
  selectedIRMAABracket: any = "1";
  selectedIRMAABracketDisplay: any = "";
  clientLTCMetroRegions;
  spouseLTCMetroRegions;

  public allStates: any[] = Utils.allStates;
  public allHealthcareCoverages: any[] = Utils.allHealthcareCoverageTypes;
  public allHealthcarePremiumTypes: any[] = Utils.allHealthcarePremiumTypes;
  public qrIncomeSection: any[] = Utils.qrIncomeSection;
  public isIncomeChange: boolean = false;
  // public isMedicareCoverageChange: boolean = false; // we need after NC release

  showTable: boolean;

  tabs = [];// tabs = ['Alternate'];
  selected = new FormControl(0);

  //Social Security data table
  displayedColumns: string[] = ['Strategy', 'ClaimAge', 'TotalBenefit', 'MedicareDeduction', 'NetAfterMedicare'];
  columnsToDisplay: string[] = this.displayedColumns.slice();
  ssData = [];
  ssDataAlt = [];
  hasAdjustedFRAScenario: boolean = false;
  hasAlternateScenario: boolean = false;
  incomeSubTitle: string;

  @ViewChild('FundingSource') fundingSourceInput: any;
  @ViewChild('AnnContribution') annContributionInput: any;
  @ViewChild('StartAge') startAgeInput: any;
  @ViewChild('EndAge') endAgeInput: any;
  @ViewChild('InflationRate') inflationRateInput: any;

  @ViewChild('rate2') rate2: any;

  @ViewChild('totalRemainingGapEl') totalRemainingGapEl: ElementRef;
  @ViewChild('totalFutureEstimatedCostsEl') totalFutureEstimatedCostsEl: ElementRef;
  @ViewChild('totalEstimatedCostsEl') totalEstimatedCostsEl: ElementRef;

  @ViewChild('p1Percent') p1Percent: ElementRef;
  @ViewChild('p1EndAge') p1EndAge: ElementRef;
  @ViewChild('p2Percent') p2Percent: ElementRef;
  @ViewChild('p2EndAge') p2EndAge: ElementRef;
  @ViewChild('p3Percent') p3Percent: ElementRef;

  @ViewChild('annualEl') annualEl: ElementRef;
  @ViewChild('weeklyEl') weeklyEl: ElementRef;


  @ViewChild('pcheck') pcheck: ElementRef;
  @ViewChild('oopcheck') oopcheck: ElementRef;

  @ViewChild('hdt') hdt: ElementRef;
  @ViewChild('pd') pd: ElementRef;
  @ViewChild('si') si: ElementRef;
  @ViewChild('di') di: ElementRef;
  @ViewChild('hd') hd: ElementRef;
  @ViewChild('pdrg') pdrg: ElementRef;
  @ViewChild('hvc') hvc: ElementRef;
  @ViewChild('dins') dins: ElementRef;
  @Input() percentageFormatting: (value: number) => any;
  investmentGrowthDecumation: any[];

  isPre65: boolean = false;
  isSpousePre65: boolean = false;
  year1Total: number = 0;
  spouseYear1Total: number = 0;

  public premiumExpenses: any = {
    partB: true,
    partD: true,
    medigap: true,
    dental: true
  };

  public outOfPocketExpenses: any = {
    hospitalization: true,
    docsTests: true,
    rx: true,
    dental: true,
    hearingServices: true,
    vision: true,
    commercial: true
  };

  public lineChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: true,
    xAxisLabel: '',
    yAxisLabel: '',
    roundDomains: false,
    timeline: false,
    curve: false,
    tooltipDisabled: false,
    colorScheme: {
      domain: ['#bad052', '#bad052', '#bad052']
    },
    autoScale: true
  }

  public pieChartOptions = {
    showLegend: false,
    //'#c0d465', '#c7d976', '#cede87', '#d5e298', '#dce7a9', '#e3ecba', '#eaf0cb'
    colorScheme: { domain: ['#bad054', '#eaf0cb', '#e3ecba', '#dce7a9', '#d5e298', '#cede87', '#c7d976', '#c0d465'] },
    showLabels: false,
    explodeSlices: false,
    doughnut: false,
    view: [500, 250],
    autoScale: true
  }

  public barChartOptions = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    xAxisLabel: 'Country',
    showYAxisLabel: false,
    yAxisLabel: 'Population',
    roundEdges: false,
    colorScheme: {
      domain: ['#e8f0c7', '#d3e08e', '#bad054']
    }
  }
  
  public barVerticalStackedChartOption = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,

    showYAxisLabel: false,


    roundEdges: false,
    colorScheme: {
      domain: ['#3385C5', '#E58931', '#20a59f']
    },
    autoScale: true

  }

  //MAGI Slider stuff
  autoTicks = false;
  disabled = false;
  invert = false;
  maxMAGI = 100;
  minMAGI = 0;
  showTicks = false;
  step = 1;
  thumbLabel = false;
  valueMAGISlider = 0;
  vertical = false;
  tickInterval = 1;
  orgFrmIncome = null;
  // totalNetHCCost;
  // totalSpouseNetHCCost;

  getSliderTickInterval(): number | 'auto' {
    if (this.showTicks) {
      return this.autoTicks ? 'auto' : this.tickInterval;
    }

    return 0;
  }

  public colas: any[] = [
    { Cola: 1.3, Year: 0 },
    { Cola: 2.6, Year: 0 },
    { Cola: 2.6, Year: 0 },
    { Cola: 2.6, Year: 0 },
  ];

  spouseProfileInfo: FormGroup;
  profileInfo: FormGroup;
  //medicareCoverageForm: FormGroup;
  //spouseMedicareCoverageForm: FormGroup;
  retirementAreaForm: FormGroup;

  medicareTitle = "Traditional Medicare";
  spouseMedicareTitle = "Traditional Medicare";

  constructor(public sidebarService: SidebarService, private clientService: ClientService, private currencyPipe : CurrencyPipe, private decimalPipe: DecimalPipe, private globalService: GlobalService, private modalService: ModalService, private snackBarService: SnackBarService, private router: Router, private loadingService: LoadingService, public dialog: MatDialog) {
    localStorage.setItem('isCreateClient', "False");
    const yearlyColas = JSON.parse(localStorage.getItem('yearlyValues')) || { BaseYear: 2020, Year1: 1.3, Year2: 2.6, Year3: 2.6, Year4: 2.6 };
    this.colas[0] = { Year: yearlyColas.BaseYear, Cola : yearlyColas.Year1 };
    this.colas[1] = { Year: yearlyColas.BaseYear + 1, Cola : yearlyColas.Year2 };
    this.colas[2] = { Year: yearlyColas.BaseYear + 2, Cola : yearlyColas.Year3 };
    this.colas[3] = { Year: yearlyColas.BaseYear + 3, Cola : yearlyColas.Year4 };

    Object.assign(this, { investmentGrowthDecumation });
    modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getClient();
      }
    });
    

    //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    sidebarService.clientUpdated.subscribe(()=>{
      if (this.isAlreadyInitializeComponent && !sidebarService.ignorePageRefresh) {
        console.log('this.client.clientProfile.PremiumType',this.client.clientProfile.PremiumType);
        console.log('sidenav adj');
        if (this.client.clientProfile.PremiumType && (window.location.href.indexOf("healthcare") > -1)) {
          this.router.navigate(['/clients/edit/healthcare/options/hcq']);
        } else if (window.location.href.indexOf("long-term-care") > -1) {
          this.router.navigate(['/clients/edit/long-term-care/options/ltcq']);
        } else if (window.location.href.indexOf("medicare-means-testing") > -1) {
          this.router.navigate(['/clients/edit/medicare-means-testing/options/mmtq']);
        } else {
          this.router.navigate(['/clients/edit/combined/options/hcltc']);
        }

        // this.router.navigate(['/clients/edit/healthcare/options/hcq']);
      }

      sidebarService.ignorePageRefresh = false;
    });
  }
  generateLineChartData(data: any) {   

    if (this.hcDataV2) {

      let currentYear = new Date().getFullYear();
      let retirementYear = this.hcDataV2.RetirementYear < currentYear ? currentYear : this.hcDataV2.RetirementYear;

      this.lineChartData = [
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({ 'name': (retirementYear + i).toString(), 'value': this.formatNumber(expense) });
          return acc;

        }, { name: 'Cost', series: []}),
        this.hcDataV2.Expenses.slice(Math.abs(currentYear - retirementYear)).reduce((acc, expense, i) => {
          acc.series.push({'name': (retirementYear +1+ i).toString(), 'value': this.formatNumber(expense)});
          return acc;
        }, { name: 'Cost', series: []})];
        
    }
  }

  generatePieChartData() {
    // tempTotal =  tempTotal + this.fundingItems.reduce((item, acc) => { console.log(acc); return acc + item.remainingUnfunded}, 0);
    var tempTotal = this.futureTotalCost - (this.hcDataV2.FundingOptions.PartB.replace(/,/g,"").replace("$",""));

    if (this.fundingItems.length) {
      tempTotal = this.fundingItems[this.fundingItems.length - 1].remainingUnfunded;
    }

    
    this.pieChartData = [
      { "name": "Unfunded", "value": tempTotal },
      { "name": "Medicare Deduction from Social Security", "value": this.totalSocialSecurity }
    ]

    this.fundingItems.forEach((item) => { this.pieChartData.push({ "name": item.fundingSource, "value": item.contributionAmount }) });
  }

  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value) {
    return Utils.formatToCurrency(value);
  }

  generateBarChartData() {

    this.cowValues.one = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.three = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.five = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)) : 0;

    this.barChartData = [
      {
        "name": "Today",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)
      },
      {
        "name": "5 Years",
        "value": this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)
      }
    ]
  }
 
  
  generateInvestGrowthBarChartData() {

    this.cowValues.one = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.three = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)) : 0;
    this.cowValues.five = this.hcDataV2.Illustrations[0].BeginningBalance ? Utils.formatToCurrency(this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)) : 0;
    

    this.barChartData = [
      {
        "name": "Today",
        "value": this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0)
      },
      {
        "name": "3 Years",
        "value": this.hcDataV2.Illustrations[2].BeginningBalance.toFixed(0)
      },
      {
        "name": "5 Years",
        "value": this.hcDataV2.Illustrations[4].BeginningBalance.toFixed(0)
      }
    ]
  }

  reDirectModal(modalName): void {
    if (modalName == 'costExplained') {
      const dialogRef = this.dialog.open(CostProjectionDetailsComponent, {
        width: '1000px',
        height: '700px',
        data: {hcDataV2: this.hcDataV2, partnerActive: this.partnerActive, FrmPV: this.FrmPV }
      });
    }
    if (modalName == 'costOfWaiting') {
      const dialogRef = this.dialog.open(CostOfWaitingComponent, {
        width: '1000px',
        height: '700px',
        data: {hcDataV2: this.hcDataV2 }
      });
    }
    if (modalName == 'addFundingSource') {
      const dialogRef = this.dialog.open(FundingSourceComponent, {
        width: '1000px',
        height: '700px',
        data: {hcDataV2: this.hcDataV2, modalName: modalName }
      });
    }


  }
  onBlur(event) {
    if (event.target.value !== '')
      event.target.value = parseFloat(event.target.value).toFixed(2)
  }

  title;
  displayHC = false;
  displayLTC = false;
  displayMMT = false;
  displaySS = false;
  isAlreadyInitializeComponent = false;

  //pageTitle = "";
  ngOnInit() {
    //TODO: need to check on what kind of report this is from url
    if (this.router.url.includes("options/hcq")) {
      this.displayHC = true;
      this.title = "Healthcare Report";
      this.incomeRangeSelectionForm = new FormGroup({
        IncomeOption: new FormControl(1),
        BracketValue: new FormControl(1),
        IncomeValue: new FormControl(), //HouseHoldIncome or YearOneRetirementIncome
        IncomeInflationRate: new FormControl(),
        IncomeReplacementRatio: new FormControl()
        //IncomeReplacementRatio: new FormControl([Validators.min(50), Validators.max(200)]),//min 50 - max 200
      });
    } else if (this.router.url.includes("options/ltcq")) {
      this.displayLTC = true;  
      this.title = "Long Term Care Report" ;
      this.incomeRangeSelectionForm = new FormGroup({
        IncomeOption: new FormControl(1),
        BracketValue: new FormControl(1),
        IncomeValue: new FormControl()
      });
    }  else if (this.router.url.includes("options/mmtq")) {
      this.displayMMT = true;
      this.title = "Medicare Means Testing Report"
      this.incomeRangeSelectionForm = new FormGroup({
        IncomeOption: new FormControl(1),
        BracketValue: new FormControl(1),
        IncomeValue: new FormControl()
      });
    }  else if (this.router.url.includes("options/ssq")) {
      this.displaySS = true;
      this.title = "Social Security Report"
      this.socialSecurityRetirementAgeForm = new FormGroup({
        clientClaimAge: new FormControl(),
        clientClaimMonths: new FormControl(),
        //spouseClaimAge: new FormControl(),
        //spouseClaimMonths: new FormControl()
      });
    } else{ //if nothing else, default to combined '/hcltc'
      this.displayHC = true;
      this.displayLTC = true;
      this.title = "Retirement Healthcare Costs &amp; Long-Term Care Report";
      this.incomeRangeSelectionForm = new FormGroup({
        IncomeOption: new FormControl(1),
        BracketValue: new FormControl(1),
        IncomeValue: new FormControl(), //HouseHoldIncome or YearOneRetirementIncome
        IncomeInflationRate: new FormControl(),
        IncomeReplacementRatio: new FormControl()
      });
    }

    this.isAlreadyInitializeComponent = true;
    /* this.profileInfo = new FormGroup({
      privateHealthInsurance: new FormControl(),
      preRetirementCoverageType: new FormControl(),
      inRetirementCoverageType: new FormControl(),

      //Traditional Medicare (TM)
      medicarePartB: new FormControl(),
      medicarePartD: new FormControl(),
      supplemental: new FormControl(),

      //Medicare Adv HMO
      medicareAdvHMO: new FormControl(),

      //Medicare Adv PPO
      medicareAdvPPO: new FormControl(),

      //always avail
      dental: new FormControl(),
      hospitalDocsTestsOOP: new FormControl(),
      prescriptionDrugsOOP: new FormControl(),  
      hearingVisionOOP: new FormControl(),    
      dentalOOP: new FormControl(),    
      //TODO: need to save this new value
      //if runReportWithSpouse is set to TRUE, ignore form spouseProfileInfo
      runReportWithSpouse: new FormControl(),
      maritalStatus: new FormControl()
    }); */

    this.profileInfo = new FormGroup({
      privateHealthInsurance: new FormControl(),
      preRetirementCoverageType: new FormControl(),
      inRetirementCoverageType: new FormControl(),

      HealthCarePremiumType: new FormControl(''),
      MedicarePartB: new FormControl(false),
      MedicarePartD: new FormControl(false),
      SupplimentalInsurance: new FormControl(false),
      MedicareAdvantageHMO: new FormControl(false),
      MedicareAdvantagePPO: new FormControl(false),
      DentalInsurance: new FormControl(false),
      HospitalAndTest: new FormControl(false),
      PrescriptionDrugs: new FormControl(false),
      HearingAndVisionCosts: new FormControl(false),
      DentalCosts: new FormControl(false),
      IsSpouseSameHCSelection: new FormControl(false),
      maritalStatus: new FormControl(),
      incomeOption: new FormControl(1),
    });

    this.spouseProfileInfo = new FormGroup({
      privateHealthInsurance: new FormControl(),
      preRetirementCoverageType: new FormControl(),
      inRetirementCoverageType: new FormControl(),

      HealthCarePremiumType: new FormControl(''),
      MedicarePartB: new FormControl(false),
      MedicarePartD: new FormControl(false),
      SupplimentalInsurance: new FormControl(false),
      MedicareAdvantageHMO: new FormControl(false),
      MedicareAdvantagePPO: new FormControl(false),
      DentalInsurance: new FormControl(false),
      HospitalAndTest: new FormControl(false),
      PrescriptionDrugs: new FormControl(false),
      HearingAndVisionCosts: new FormControl(false),
      DentalCosts: new FormControl(false),
      IsSpouseSameHCSelection: new FormControl(false),
      incomeOption: new FormControl(1),
    });

    this.retirementAreaForm = new FormGroup({
      clientRetirementState: new FormControl(''),
      spouseRetirementState: new FormControl(''),
      clientMetroRegion: new FormControl(''),
      spouseMetroRegion: new FormControl(''),
      applySameMetroRegionForSpouse: new FormControl(false) //default on page load
    });

    //this.getAdvisor(); //<== avail is needed
    //HACK: no matter whether it is HC or LTC or both, we just call both...
    this.loadingService.isLoading(true);
    this.getClient();
  }

  removeFundingItem(item) {
    this.fundingItems.splice(this.fundingItems.indexOf(item), 1);
    this.onRateChange(0);
    this.fundingTableCount();
  }

  public futureTotalCost: number;

  public sample: any = {
    ExpenseProjectionBody: "",
    FrmIncome: "",
    FullHorizonYears: "",
    FundingOptions: {},
    Illustrations: [],
    IncomeCompareAnalysis: {},
    P1Age: "",
    P1FullHorizonYears: "",
    P1Gender: "",
    P1HealthCareExpenses: "",
    P1HealthCareExpensesDiscounted: "",
    P1LifeTimeTotalsForComparison: "",
    P2Age: "",
    P2FullHorizonYears: "",
    P2Gender: "",
    P2HealthCareExpenses: "",
    P2HealthCareExpensesDiscounted: "",
    P2LifeTimeTotalsForComparison: "",
    PlanUntil1: "",
    PlanUntilYear: "",
    RetireYear: null,
    RetirementYear: 0,
    State: "",
    TotalProjectedCost: "",
    TotalProjectedCostPv: "",
    TotalYear1Cost: "",
    TotalYear1OOP: "",
    TotalYear1Premiums: "",
    YearOneTotal: "",
    YearsInRetirement: "",
    YearsToRetirement: "",
    hq: null,
    partners: null
  }

  public cowValues: any = {
    one: 0,
    three: 0,
    five: 0,
  };

  currentScenario: any;
  altScenario: any;
  orgScenario: any;

  setScenarioObj(isAlt, isFirsTime){
    console.log('is alt', isAlt);
    console.log('is first', isFirsTime);
  

    if(isAlt){
      console.log('this.retirementAreaForm.value.clientMetroRegion', this.clientLTCMetroRegions);
      //set client
      //TODO: need to figure out what to do if client/spouse are already retired
      this.altScenario = {
        clientTotalHCC: (this.displayHC) ? this.hcDataV2.P1HealthCareExpensesTotal : 0,//this.futureTotalCost,
        clientTotalNetHCC: (this.displayHC) ? this.hcDataV2.P1NetRetirementHCCost : 0,
        clientTotalAvgHCC: (this.displayHC) ? this.hcDataV2.P1HealthCareExpensesAvgTotal : 0,
        clientTotalNetAvgHCC: (this.displayHC) ? this.hcDataV2.P1NetRetirementHCCost : 0,
        clientRetirementHorizon: (this.displayHC) ? this.hcDataV2.PlanUntilYear : ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge),
        clientRetirementYears: this.getRetirementHorizon(),
        clientRetirementAge: this.clientModelV2.generalInformation.retirementAge,
        clientRetirementState: this.retirementAreaForm.value.clientRetirementState,
        clientLifeExpectancy: this.clientModelV2.healthInformation.lifeExpectancy,

        //Client Long Term Care
        clientLTCBeginYear: (this.displayLTC) ? this.responseLTC.LTCYear : 0,
        clientLTCAnnualHHC: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.HHC) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal) : 0,
        clientLTCAnnualALF: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.ALF) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal) : 0,
        clientLTCAnnualNHC: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.SNF) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal) : 0,
        clientLTCAnnualIC: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.IC) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal) : 0,
        clientLTCTotal: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.FutureCostTotal) : 0,
        clientMetroArea: (this.displayLTC) ? this.selfRegion : '',
        clientMetroAreaName: (this.displayLTC) ? this.clientRegions.MetroRegion : '',

        //Client Means Testing
        clientMedicarePartBAndPremiums: (this.displayMMT) ? this.medicarePremiumsMMT : 0,
        clientLifetimeIRMAASurcharges: (this.displayMMT) ? this.surchargesMMT : 0,
        clientLifetimeIRMAASurchargesAvgPerYear: (this.displayMMT) ? this.surchargesAvgCostPerYearMMT : 0,

        spouseTotalHCC: (this.displayHC) ? this.hcDataV2.P2HealthCareExpensesTotal : 0,//this.futureTotalCost,
        spouseTotalNetHCC: (this.displayHC) ? this.hcDataV2.P2NetRetirementHCCost : 0,
        spouseTotalAvgHCC: (this.displayHC) ? this.hcDataV2.P2HealthCareExpensesAvgTotal : 0,
        spouseTotalNetAvgHCC: (this.displayHC) ? this.hcDataV2.P2NetRetirementHCCost : 0,
        //spouseRetirementHorizon: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) + ' to ' + (this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
        spouseRetirementHorizon: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? (this.displayHC) ? this.hcDataV2.PlanUntil1 : ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
        // spouseRetirementYears: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) + 1 : 0,
        spouseRetirementYears: this.getSpouseRetirementHorizon(),
        spouseRetirementAge: this.clientModelV2.maritalStatus.retirementAge,
        spouseRetirementState: this.retirementAreaForm.value.spouseRetirementState,
        spouseLifeExpectancy: this.clientModelV2.maritalStatus.lifeExpectancy,
        
        //Spouse Long term care
        spouseLTCBeginYear: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.responseLTC.LTCYear1 : 0,
        spouseLTCAnnualHHC: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.HHC) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
        spouseLTCAnnualALF: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.ALF) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
        spouseLTCAnnualNHC: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.SNF) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
        spouseLTCAnnualIC: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.IC) : 0,//Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
        spouseLTCTotal: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
        spouseMetroArea: (this.displayLTC) ? this.spouseRegion : '',
        spouseMetroAreaName: (this.displayLTC) ? this.spouseRegions.MetroRegion : '',

        //Spouse Means Testing
        //TODO: this is not being returned from the API (i think...)
        spouseMedicarePartBAndPremiums: (this.displayMMT && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.medicarePremiumsMMT : 0,
        spouseLifetimeIRMAASurcharges: (this.displayMMT && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.surchargesMMT : 0,
        spouseLifetimeIRMAASurchargesAvgPerYear: (this.displayMMT && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.surchargesAvgCostPerYearMMT : 0,

        clientRetirementStartYear: (this.displayHC) ? this.hcDataV2.RetirementYear : 0,
        spouseRetirementStartYear: (this.displayHC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.hcDataV2.SpouseRetirementYear : 0,
        //Medicare Means Testing
        //householdIncomeBracket: (this.displayMMT) ? this.incomeRangeSelectionForm.value.BracketValue : 0,
        //householdIncomeBracket: (this.incomeRangeSelectionForm.value.BracketValue) ? this.incomeRangeSelectionForm.value.BracketValue : 0,
        householdIncomeBracket: (this.selectedIRMAABracket) ? this.selectedIRMAABracket : 0,

        //Social Security
        //NOTE: SS is handled differently because of the table it is in
        //socialSecurityInvestment: (this.displaySS) ? this.responseSS.lumpsumCost : (this.totalSocialSecurity) ? this.totalSocialSecurity : 0,
        socialSecurityInvestment: (this.displaySS) ? this.responseSS.lumpsumCost : (this.totalSocialSecurity) ? this.totalSocialSecurity : 0,

        //totalCombinedHCC: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.currentScenario.spouseTotalHCC + this.currentScenario.clientTotalHCC : this.currentScenario.clientTotalHCC,
        // totalCombinedHCC: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.futureTotalCost + this.futureTotalCost : this.futureTotalCost,
        totalCombinedHCC: this.displayHC && this.displayLTC ? Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", "")) : this.futureTotalCost,

        remainingUnfunded: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.depositedToday) : 0,
        //totalCombinedHCYears: ((this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) + (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear())) 
        //  : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()))) + 1
      };

      // this.altScenario.totalCombinedHCYears = (this.partnerActive) ? (((this.altScenario.clientRetirementYears > this.altScenario.spouseRetirementHorizon) ? this.altScenario.clientRetirementYears : this.altScenario.spouseRetirementHorizon) - ((this.hcDataV2.RetirementYear > this.hcDataV2.SpouseRetirementYear) ? this.hcDataV2.SpouseRetirementYear : this.hcDataV2.RetirementYear)) : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear())) + 1;
      //this.altScenario.totalCombinedHCYears = ((this.partnerActive) ? (((this.altScenario.clientRetirementHorizon > this.altScenario.spouseRetirementHorizon) ? this.altScenario.clientRetirementHorizon : this.altScenario.spouseRetirementHorizon) - ((this.hcDataV2.RetirementYear > this.hcDataV2.SpouseRetirementYear) ? this.hcDataV2.SpouseRetirementYear : this.hcDataV2.RetirementYear)) : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()))) + 1;

      if(this.displayHC){
        // this.currentScenario.totalCombinedHCYears = (this.partnerActive) ? (((this.currentScenario.clientRetirementYears > this.currentScenario.spouseRetirementHorizon) ? this.currentScenario.clientRetirementYears : this.currentScenario.spouseRetirementHorizon) - ((this.hcDataV2.RetirementYear > this.hcDataV2.SpouseRetirementYear) ? this.hcDataV2.SpouseRetirementYear : this.hcDataV2.RetirementYear)) : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear())) + 1;
        this.altScenario.totalCombinedHCYears = ((this.partnerActive) ? (((this.altScenario.clientRetirementHorizon > this.altScenario.spouseRetirementHorizon) ? this.altScenario.clientRetirementHorizon : this.altScenario.spouseRetirementHorizon) - ((this.hcDataV2.RetirementYear > this.hcDataV2.SpouseRetirementYear) ? this.hcDataV2.SpouseRetirementYear : this.hcDataV2.RetirementYear)) : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()))) + 1;
        this.altScenario.clientTotalNetAvgHCC = Math.round(this.altScenario.clientTotalNetHCC/this.altScenario.clientRetirementYears);
        this.altScenario.spouseTotalNetAvgHCC = Math.round(this.altScenario.spouseTotalNetHCC/this.altScenario.spouseRetirementYears);
      }
    } else {
      //set client
      //TODO: need to figure out what to do if client/spouse are already retired
      console.log('client', this.client);
      console.log('hcDataV2 check', this.hcDataV2);
      // console.log('clientRetirementYears 02', this.orgScenario.clientRetirementYears)
      this.currentScenario = {
        clientRetirementAge: this.clientModelV2.generalInformation.retirementAge,
        clientRetirementState: this.retirementAreaForm.value.clientRetirementState,
        clientLifeExpectancy: this.clientModelV2.healthInformation.lifeExpectancy,
        clientMedicareCoverage: this.medicareTitle,
        clientTotalHCC: (this.displayHC) ? this.hcDataV2.P1HealthCareExpensesTotal : 0,//this.futureTotalCost,
        clientTotalNetHCC: (this.displayHC) ? this.hcDataV2.P1NetRetirementHCCost : 0,
        clientTotalAvgHCC: (this.displayHC) ? this.hcDataV2.P1HealthCareExpensesAvgTotal : 0,
        clientTotalNetAvgHCC: (this.displayHC) ? this.hcDataV2.P1NetRetirementHCCost : 0,
        clientRetirementHorizon: (this.displayHC) ? this.hcDataV2.PlanUntilYear : ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge),
        clientRetirementYears: this.getRetirementHorizon(),
        clientRetirementStartYear: (this.displayHC) ? this.hcDataV2.RetirementYear : 0,
        clientCurrentIncome: this.client.clientProfile.CurrentIncome,

        //Client Long Term Care
        clientLTCBeginYear: (this.displayLTC) ? this.responseLTC.LTCYear : 0,
        clientLTCAnnualHHC: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.HHC) : 0,//Utils.formatToNumber(this.clientRegions.HHCHealthCare) : 0,
        clientLTCAnnualALF: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.ALF) : 0,//Utils.formatToNumber(this.clientRegions.ALF) : 0,
        clientLTCAnnualNHC: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.SNF) : 0,//Utils.formatToNumber(this.clientRegions.SNFPrivate) : 0,
        clientLTCAnnualIC: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts.IC) : 0,//Utils.formatToNumber(this.clientRegions.SNFPrivate) : 0,
        clientLTCTotal: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.FutureCostTotal) : 0,
        clientMetroArea: (this.displayLTC) ? this.client.clientProfile.ClientMetroArea : '',
        clientMetroAreaName: (this.displayLTC) ? this.clientRegions.MetroRegion : '',

        //Client Means Testing
        clientMedicarePartBAndPremiums: (this.displayMMT) ? this.medicarePremiumsMMT : 0,
        clientLifetimeIRMAASurcharges: (this.displayMMT) ? this.surchargesMMT : 0,
        clientLifetimeIRMAASurchargesAvgPerYear: (this.displayMMT) ? this.surchargesAvgCostPerYearMMT : 0,

        spouseRetirementAge: this.clientModelV2.maritalStatus.retirementAge,
        spouseRetirementState: this.retirementAreaForm.value.spouseRetirementState,
        spouseLifeExpectancy: this.clientModelV2.maritalStatus.lifeExpectancy,
        sposeMedicareCoverage: this.spouseMedicareTitle,
        spouseTotalHCC:  (this.displayHC) ? this.hcDataV2.P2HealthCareExpensesTotal : 0,//this.futureTotalCost,
        spouseTotalNetHCC: (this.displayHC) ? this.hcDataV2.P2NetRetirementHCCost : 0,
        spouseTotalAvgHCC: (this.displayHC) ? this.hcDataV2.P2HealthCareExpensesAvgTotal : 0,
        spouseTotalNetAvgHCC: (this.displayHC) ? this.hcDataV2.P2NetRetirementHCCost : 0,
        //spouseRetirementHorizon: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) + ' to ' + (this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
        spouseRetirementHorizon: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? (this.displayHC) ? this.hcDataV2.PlanUntil1 : ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
        // spouseRetirementYears: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) + 1 : 0,
        spouseRetirementYears: this.getSpouseRetirementHorizon(),
        spouseRetirementStartYear: (this.displayHC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.hcDataV2.SpouseRetirementYear : 0,
        spouseLTCTotal: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,

        //Long Term Care
        spouseLTCBeginYear: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.responseLTC.LTCYear1 : 0,
        spouseLTCAnnualHHC: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.HHC) : 0,//Utils.formatToNumber(this.spouseRegions.HHCHealthCare || 0) : 0,
        spouseLTCAnnualALF: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.ALF) : 0,//Utils.formatToNumber(this.spouseRegions.ALF || 0) : 0,
        spouseLTCAnnualNHC: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.SNF) : 0,//Utils.formatToNumber(this.spouseRegions.SNFPrivate || 0) : 0,
        spouseLTCAnnualIC: (this.displayLTC && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.YearOneLTCCosts1.IC) : 0,//Utils.formatToNumber(this.spouseRegions.SNFPrivate || 0) : 0,
        spouseMetroArea: (this.displayLTC) ? this.client.clientProfile.SpouseMetroArea : '',
        spouseMetroAreaName: (this.displayLTC) ? this.spouseRegions.MetroRegion : '',

        //Spouse Means Testing
        //TODO: this is not being returned from the API (i think...)
        spouseMedicarePartBAndPremiums: (this.displayMMT && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.medicarePremiumsMMT : 0,
        spouseLifetimeIRMAASurcharges: (this.displayMMT && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.surchargesMMT : 0,
        spouseLifetimeIRMAASurchargesAvgPerYear: (this.displayMMT && this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.surchargesAvgCostPerYearMMT : 0,

        //Medicare Means Testing
        //householdIncomeBracket: (this.displayMMT) ? this.client.clientProfile.Bracket : 0,
        householdIncomeBracket: (this.client.clientProfile.Bracket) ? this.client.clientProfile.Bracket : 0,

        //Social Security
        //NOTE: SS is handled differently because of the table it is in
        socialSecurityInvestment: (this.displaySS) ? this.responseSS.lumpsumCostOptimal : (this.totalSocialSecurity) ? this.totalSocialSecurity : 0,

        //totalCombinedHCC: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.currentScenario.spouseTotalHCC + this.currentScenario.clientTotalHCC : this.currentScenario.clientTotalHCC,
        //totalCombinedLTC: this.futureTotalCost,
        totalCombinedHCC: this.displayHC && this.displayLTC ? Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", "")) : this.futureTotalCost,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.futureTotalCost + this.futureTotalCost : this.futureTotalCost,
        remainingUnfunded: (this.displayLTC) ? Utils.formatToNumber(this.responseLTC.depositedToday) : 0,
        householdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome
        /* totalCombinedHCYears: ((this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) + (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear())) 
          : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()))) + 1 */
          
      };

      console.log(this.currentScenario);

      //if(!this.displayLTC || (this.displayHC && this.displayLTC)){
      if(this.displayHC){
        // this.currentScenario.totalCombinedHCYears = (this.partnerActive) ? (((this.currentScenario.clientRetirementYears > this.currentScenario.spouseRetirementHorizon) ? this.currentScenario.clientRetirementYears : this.currentScenario.spouseRetirementHorizon) - ((this.hcDataV2.RetirementYear > this.hcDataV2.SpouseRetirementYear) ? this.hcDataV2.SpouseRetirementYear : this.hcDataV2.RetirementYear)) : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear())) + 1;
        this.currentScenario.totalCombinedHCYears = ((this.partnerActive) ? (((this.currentScenario.clientRetirementHorizon > this.currentScenario.spouseRetirementHorizon) ? this.currentScenario.clientRetirementHorizon : this.currentScenario.spouseRetirementHorizon) - ((this.hcDataV2.RetirementYear > this.hcDataV2.SpouseRetirementYear) ? this.hcDataV2.SpouseRetirementYear : this.hcDataV2.RetirementYear)) : (((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()))) + 1;
        this.currentScenario.clientTotalNetAvgHCC = Math.round(this.currentScenario.clientTotalNetHCC/this.currentScenario.clientRetirementYears);
        this.currentScenario.spouseTotalNetAvgHCC = Math.round(this.currentScenario.spouseTotalNetHCC/this.currentScenario.spouseRetirementYears);
      }

      if(isFirsTime){
        console.log('first time, reset objects');
        this.altScenario = this.currentScenario;
        this.orgScenario = this.currentScenario;
      }
      
    }
    console.log('this.altScenario', this.altScenario)
    if(this.editingScenario == 'Alternate' || this.editingScenario == 'What If'){
      this.editingScenario = '';
    }    
  }

  getRetirementHorizon() {
    let retireAgeOrAge = this.client.clientProfile.RetirementAge > this.client.clientProfile.CurrentAge ? this.client.clientProfile.RetirementAge : this.client.clientProfile.CurrentAge;
    // return (((retireAgeOrAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) + (this.client.clientProfile.LifeExpectancy - retireAgeOrAge) - ((retireAgeOrAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear())) + 1;
    return Math.max(0, this.client.clientProfile.LifeExpectancy - retireAgeOrAge > 0 ? (this.client.clientProfile.LifeExpectancy - retireAgeOrAge) + 1 : this.client.clientProfile.LifeExpectancy - retireAgeOrAge)
  }

  getSpouseRetirementHorizon() {
    let spouseAge = this.calculateAge(this.client.clientProfile.Spouses[0].dob);
    let retireAgeOrAge = this.client.clientProfile.Spouses[0].retirementAge > spouseAge ? this.client.clientProfile.Spouses[0].retirementAge : spouseAge;
    // (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) + 1 : 0,
    return Math.max(0, this.client.clientProfile.Spouses[0].LifeExpectancy - retireAgeOrAge > 0 ? (this.client.clientProfile.Spouses[0].LifeExpectancy - retireAgeOrAge) + 1 : this.client.clientProfile.Spouses[0].LifeExpectancy - retireAgeOrAge)
  }

  public investmentOption: number = 1;
  currentYear = new Date().getFullYear();
  getHCDataAlt(){
   //TODO: create new object to grab the alt scenario and then recall getHCData ??
    this.setScenarioObj(true, false);
  }

  getHCData(client: any, includeSpouse?: any, isFromGetClient = false) {
    var currentAge = this.calculateAge(client.client.DOB);
    this.client.clientProfile.CurrentAge = currentAge;

    var currentYear = new Date().getFullYear();

    var spouse = {};

    var investmentItems = [];

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        Ends: this.fundingItems[item].endAge,
        StartAmount: this.fundingItems[item].annContribution,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    if (this.client.clientProfile.Spouses
      && this.client.clientProfile.Spouses.length > 0
      && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      this.partnerActive = true;
    } else {
      this.partnerActive = false;
    }

    
    console.log('this.profileInfo.value.MedicareAdvHMO', this.profileInfo.value.MedicareAdvantageHMO);
    console.log('this.profileInfo.value.HealthCarePremiumType', this.profileInfo.value.HealthCarePremiumType );
    console.log('this.incomeRangeSelectionForm', this.incomeRangeSelectionForm);
    console.log('this.profileInfo.value.privateHealthInsurance', this.profileInfo.value.privateHealthInsurance)

    let spouseDOB = this.includeSpouse ? this.client.clientProfile.Spouses[0].dob : '1/1/1960';
      
    var retirementAge = this.client.clientProfile.RetirementAge < 65 && (!this.profileInfo.value.privateHealthInsurance || this.profileInfo.value.privateHealthInsurance == 'false') ? 65 : this.client.clientProfile.RetirementAge;
    var spouseRetirementAge = this.client.clientProfile.Spouses[0].retirementAge < 65 && (!this.spouseProfileInfo.value.privateHealthInsurance || this.spouseProfileInfo.value.privateHealthInsurance == 'false') && this.partnerActive ? 65 : this.client.clientProfile.Spouses[0].retirementAge;

    var HCReport = {
      //NOTE: removed the 'nativeElement' functionality since this is going to be driven by the new client object
        //pull data from the client 

      InvestmentItems: JSON.stringify({ investmentItems }),

      //client
      P_Part_A_And_B: this.profileInfo.controls['MedicarePartB'].disabled ? 1 :  this.profileInfo.value.MedicarePartB ? 1 : 0,//this.profileInfo.value.MedicarePartB && !this.isPre65 ? 1 : 0,//this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: this.profileInfo.controls['MedicarePartD'].disabled ? 1 : this.profileInfo.value.MedicarePartD ? 1 : 0,//this.profileInfo.value.MedicarePartD && !this.isPre65 ? 1 : 0,//this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.profileInfo.controls['SupplimentalInsurance'].disabled ? 1 : this.profileInfo.value.SupplimentalInsurance ? 1 : 0,//this.profileInfo.value.SupplimentalInsurance && !this.isPre65 ? 1 : 0,//this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.profileInfo.controls['DentalInsurance'].disabled ? 1 : this.profileInfo.value.DentalInsurance ? 1 : 0,//this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      // P_Advantage: ((this.profileInfo.value.MedicareAdvantageHMO && this.profileInfo.value.HealthCarePremiumType == 'HMO') || (this.profileInfo.value.MedicareAdvantagePPO && this.profileInfo.value.HealthCarePremiumType == 'PPO'))? 1 : 0,
      P_Advantage: (this.profileInfo.value.HealthCarePremiumType == 'HMO' || this.profileInfo.value.HealthCarePremiumType == 'PPO')? 1 : 0,
      OOP_Hosp_Docs: this.profileInfo.controls['HospitalAndTest'].disabled ? 1 : this.profileInfo.value.HospitalAndTest ? 1 : 0,//this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.profileInfo.controls['PrescriptionDrugs'].disabled ? 1 : this.profileInfo.value.PrescriptionDrugs ? 1 : 0,//this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.profileInfo.controls['HearingAndVisionCosts'].disabled ? 1 : this.profileInfo.value.HearingAndVisionCosts ? 1 : 0,//this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.profileInfo.controls['DentalCosts'].disabled ? 1 : this.profileInfo.value.DentalCosts ? 1 : 0,//this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,

      //spouse/partner
      P_Part_A_And_B1: this.partnerActive ? this.spouseProfileInfo.controls['MedicarePartB'].disabled ? 1 : this.spouseProfileInfo.value.MedicarePartB ? 1 : 0 : 0,//this.spouseProfileInfo.value.MedicarePartB && !this.isSpousePre65 ? 1 : 0 : 0,
      P_Part_D1: this.partnerActive ? this.spouseProfileInfo.controls['MedicarePartD'].disabled ? 1 : this.spouseProfileInfo.value.MedicarePartD ? 1 : 0 : 0,//this.spouseProfileInfo.value.MedicarePartD && !this.isSpousePre65 ? 1 : 0 : 0,
      P_MediGap1: this.partnerActive ? this.spouseProfileInfo.controls['SupplimentalInsurance'].disabled ? 1 : this.spouseProfileInfo.value.SupplimentalInsurance ? 1 : 0 : 0,//this.spouseProfileInfo.value.SupplimentalInsurance && !this.isSpousePre65 ? 1 : 0 : 0,
      P_Dental1: this.partnerActive ? this.spouseProfileInfo.controls['DentalInsurance'].disabled ? 1 : this.spouseProfileInfo.value.DentalInsurance ? 1 : 0 : 0,
      // P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.MedicareAdvantageHMO && this.spouseProfileInfo.value.HealthCarePremiumType == 'HMO') || (this.spouseProfileInfo.value.MedicareAdvantagePPO && this.spouseProfileInfo.value.HealthCarePremiumType == 'PPO')) ? 1 : 0 : 0,
      P_Advantage1: this.partnerActive ? (this.spouseProfileInfo.value.HealthCarePremiumType == 'HMO' || this.spouseProfileInfo.value.HealthCarePremiumType == 'PPO') ? 1 : 0 : 0,
      OOP_Hosp_Docs1: this.partnerActive ? this.spouseProfileInfo.controls['HospitalAndTest'].disabled ? 1 : this.spouseProfileInfo.value.HospitalAndTest ? 1 : 0 : 0,
      OOP_Presc_Drug1: this.partnerActive ? this.spouseProfileInfo.controls['PrescriptionDrugs'].disabled ? 1 : this.spouseProfileInfo.value.PrescriptionDrugs ? 1 : 0 : 0,
      OOP_Hearing_Vision1: this.partnerActive ? this.spouseProfileInfo.controls['HearingAndVisionCosts'].disabled ? 1 : this.spouseProfileInfo.value.HearingAndVisionCosts ? 1 : 0 : 0,
      OOP_Dental1: this.partnerActive ? this.spouseProfileInfo.controls['DentalCosts'].disabled ? 1 : this.spouseProfileInfo.value.DentalCosts ? 1 : 0 : 0,

      CoverageType: this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
      CoverageType1: (this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
      PremiumType: this.profileInfo.value.HealthCarePremiumType == 'TM' ? 0 : this.profileInfo.value.HealthCarePremiumType == 'HMO' ? 1 : 2,
      PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.HealthCarePremiumType == 'TM' ? 0 : this.spouseProfileInfo.value.HealthCarePremiumType == 'HMO' ? 1 : 2 : 0,
      PrivateInsurance: this.profileInfo.value.privateHealthInsurance || false,
      PrivateInsurance1: (this.partnerActive) ? this.spouseProfileInfo.value.privateHealthInsurance || false : false,

      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      FrmHasPartner: this.partnerActive,
      FrmQType: this.client.clientProfile.HCT1D,
      FrmQExcercise: 1,
      FrmGender: this.client.client.GenderID,
      FrmQTypeII: this.client.clientProfile.HCT2D,
      FrmQTobacco: this.client.clientProfile.HCT,
      FrmQCancer: this.client.clientProfile.HCC,
      FrmQHistory: this.client.clientProfile.HCFHDC,
      FrmQCardio: this.client.clientProfile.HCCD,
      FrmQPhysical: 1,
      FrmQHighColesterol: this.client.clientProfile.HCHC,
      FrmQDiet: 1,
      FrmQHBP: this.client.clientProfile.HCHBP,
      FrmQMS: this.client.clientProfile.HCMS,
      FrmQDCW: this.client.clientProfile.HCDCW,

      FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,

      FrmCurrentAge: this.calculateAge(this.client.client.DOB),

      // FrmPlanUntil: 0,
      // FrmPlanUntil0: 0,
      // FrmPlanUntil1: 0,
      // SpouseFrmPlanUntil: 0,
      selfConditions: JSON.stringify({
        HCHBP: this.client.clientProfile.HCHBP,
        HCHC: this.client.clientProfile.HCHC,
        HCT2D: this.client.clientProfile.HCT2D,
        HCCD: this.client.clientProfile.HCCD,
        HCC: this.client.clientProfile.HCC,
        HCT: this.client.clientProfile.HCT,
        HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
        HCMS: this.client.clientProfile.HCMS ? 1 : 0,
        HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
        HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
        HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag ? 1 : 0,
        HCCYrsDiag: this.client.clientProfile.HCCYrsDiag ? 1 : 0,

        HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
        HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
        HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
        HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
        HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,
      }),

      spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.partnerActive ? JSON.stringify({
        HCHBP: this.client.clientProfile.Spouses[0].HCHBP,
        HCHC: this.client.clientProfile.Spouses[0].HCHC,
        HCT2D: this.client.clientProfile.Spouses[0].HCT2D,
        HCCD: this.client.clientProfile.Spouses[0].HCCD,
        HCC: this.client.clientProfile.Spouses[0].HCC,
        HCT: this.client.clientProfile.Spouses[0].HCT,
        HCT1D: this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0,
        HCMS: this.client.clientProfile.Spouses[0].HCMS ? 1 : 0,
        HCDCW: this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0,
        HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0,
        HCCDYrsDiag: this.client.clientProfile.Spouses[0].HCCDYrsDiag ? 1 : 0,
        HCCYrsDiag: this.client.clientProfile.Spouses[0].HCCYrsDiag ? 1 : 0,

        HCALZ: this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0,
        HCPARK: this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0,
        HCAMP: this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0,
        HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0,
        HCOBS: this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0,
      }) : "",

      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,

      SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
      SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
      SpouseFrmQDiet: 1,
      SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
      SpouseFrmQPhysical: 1,
      SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
      SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
      SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
      SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      SpouseQExcercise: 1,
      SpouseQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,
      SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
      SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
      SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,
      SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
      
      SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
      SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
      SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
      SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
      SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,
      SpouseFrmQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

      PaymentTotal: 0,
      PaymentYears: 10,

      FrmPhase1Rate: this.p1Percent ? 6 : 6,
      FrmPhase1Periods: this.p1EndAge ? 65 - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.p2Percent ? 6 : 6,
      FrmPhase2Periods: this.p2EndAge ? (75 - 65) : 10,
      FrmPhase3Rate: this.p3Percent ? 6 : 6,
      
      //FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Math.max(currentYear,this.getRetirementYear(spouseRetirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
      FrmPV: this.FrmPV,
      
      //FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB)),
      FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(retirementAge, this.client.client.DOB)),

      FrmState: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,      
      FrmState1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
            
      //TODO: set/add household income? Is this in call?
      HouseholdYearOneIncome: (this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 3) ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) : (this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 2) ? 0 : this.client.clientProfile.HouseholdYearOneIncome,
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.incomeRangeSelectionForm.value.IncomeOption != 1 
        ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) / 2 : 0,
      //? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
      // SelfCurrentIncome: (this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 2 || this.incomeRangeSelectionForm.value.IncomeOption == 3) ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) : (this.client.clientProfile.CurrentIncome != null && this.incomeRangeSelectionForm.value.IncomeOption != 1) ? this.client.clientProfile.CurrentIncome : 0,

      SelfCurrentIncome: (this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 2 || this.incomeRangeSelectionForm.value.IncomeOption == 3) 
        ? (this.partnerActive) ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) / 2 : Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) 
        : ((this.client.clientProfile.HouseholdYearOneIncome) 
        ? this.client.clientProfile.HouseholdYearOneIncome 
        : (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) 
        ? this.client.clientProfile.CurrentIncome : 0),
      Bracket: (!this.client.clientProfile.CurrentIncome || this.incomeRangeSelectionForm.value.IncomeOption == 1) ? (this.incomeRangeSelectionForm.value.IncomeOption == 1) ? this.selectedIRMAABracket : this.client.clientProfile.Bracket : null,
      // SelfIRR: (this.incomeRangeSelectionForm.value.IncomeReplacementRatio && this.incomeRangeSelectionForm.value.IncomeOption == 2) ? Utils.removePercentageFormatting(this.incomeRangeSelectionForm.value.IncomeReplacementRatio) : (this.client.clientProfile.IRR != null && this.incomeRangeSelectionForm.value.IncomeOption == 3) ? this.client.clientProfile.IRR : (this.incomeRangeSelectionForm.value.IncomeOption == 3) ? 75 : 0,
      SelfIRR: (this.incomeRangeSelectionForm.value.IncomeReplacementRatio && this.incomeRangeSelectionForm.value.IncomeOption == 2) ? Utils.removePercentageFormatting(this.incomeRangeSelectionForm.value.IncomeReplacementRatio) :((this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0),
      InvestmentOption: this.investmentOption || 1,
      ClientPIA: this.client.clientProfile.PIA,      
      SelfPIA: (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0,
      SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,

      //TODO: set up for different plans for different clients
      //SelfSupplementalPlan: (this.client.clientProfile.SelfSupplementalPlan) ? this.client.clientProfile.SelfSupplementalPlan : "G",
      //SpouseSupplementalPlan:  (this.client.clientProfile.SpouseSupplementalPlan) ? this.client.clientProfile.SpouseSupplementalPlan : "G"
      SelfSupplementalPlan: (this.profileInfo.value.supplementalPlanType) ? this.profileInfo.value.supplementalPlanType : (this.client.clientProfile.SelfSupplementalPlan) ? this.client.clientProfile.SelfSupplementalPlan : "G",
      SpouseSupplementalPlan:  (this.partnerActive) ? (this.spouseProfileInfo.value.supplementalPlanType) ? this.spouseProfileInfo.value.supplementalPlanType : (this.client.clientProfile.SpouseSupplementalPlan) ? this.client.clientProfile.SpouseSupplementalPlan : "G" : "",
      
      // PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate,
      PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 0.03 : this.client.clientProfile.InflationRate / 100,
      InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 0.03 : this.client.clientProfile.InRetirementInflationRate / 100,   
      UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
      SpouseDOB: spouseDOB,
      MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,
      SelfDOB: this.client.client.DOB,

      SelfRetirementAge: retirementAge,// this.client.clientProfile.RetirementAge,
      IsClientRetireEarly: (this.client.clientProfile.RetirementAge < 65),

      SpouseRetirementAge: spouseRetirementAge,//this.client.clientProfile.Spouses[0].retirementAge,
      IsSpouseRetireEarly: (this.client.clientProfile.Spouses[0].retirementAge < 65),

      MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,

      MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year || 0 : 0,
      MidRetRedDollar: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
      MidRetRedPer: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,
      MidRetIncomeInflationRate: this.client.midRetirementAdj ? this.client.midRetirementAdj.IncomeInflationRate || null : null,
    }

    if (includeSpouse)
      spouse = client.clientProfile.Spouses[0];

    this.client.retirementState = this.client.state;
    // to get the commercial insurance
    /* HCReport.P_Part_A_And_B = this.isPre65 && ((this.profileInfo.value.preRetirementCoverageType == 'HMO') || (this.profileInfo.value.preRetirementCoverageType == 'PPO'))  ? 1 : HCReport.P_Part_A_And_B;
    if (includeSpouse) {
      HCReport.P_Part_A_And_B1 = this.isSpousePre65 && ((this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO')) ? 1 : HCReport.P_Part_A_And_B1;
    } */

    if(this.profileInfo.value.HealthCarePremiumType != 'TM'){
      HCReport.P_Part_A_And_B = 1;
    }

    if (includeSpouse) {
      console.log('here i am 01')
      if(this.spouseProfileInfo.value.HealthCarePremiumType != 'TM'){
        console.log('here i am 02')
        HCReport.P_Part_A_And_B1 = 1;
      }
    }

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient'),
      reportType: (this.displayHC && this.displayLTC) ? 13 : 9
    }
    
    console.log('HC obj before', HCReport);
    console.log('user obj before', user);

    /* if(this.incomeRangeSelectionForm.value.IncomeOption == 1){
      this.bracketChange(this.selectedIRMAABracket);
      this.displayClientBracket(this.selectedIRMAABracket);
    } */

    this.globalService.getHCDataV2(HCReport, user)
      .subscribe(
        data => {
          console.log('hc data 1', data);
          this.hcDataV2 = data;
          this.orgFrmIncome = isFromGetClient ? this.hcDataV2.FrmIncome: this.orgFrmIncome;
          this.hcDataV2.IllustrationEntriesWithFunding = JSON.parse(this.hcDataV2.IllustrationEntriesWithFunding);
          this.p1CostsV2 = JSON.parse(this.FrmPV == 0 ? data.P1HealthCareExpensesDiscounted : data.P1HealthCareExpenses);
          // this.totalNetHCCost = (data.P1NetRetirementHCCost ? Math.round(data.P1NetRetirementHCCost ): 0).toString();
          // this.totalSpouseNetHCCost = (data.P2NetRetirementHCCost && this.partnerActive ? Math.round(data.P2NetRetirementHCCost ): 0).toString();
          console.log("Check the Martial Status",this.partnerActive);
          this.p2CostsV2 = this.partnerActive ? JSON.parse(this.FrmPV == 0 ? data.P2HealthCareExpensesDiscounted : data.P2HealthCareExpenses) : {};
          this.tempCostsV2 = this.p1CostsV2;
          //console.log("Check Display HC", this.p1CostsV2[0]);
          /* if(this.displayHC){
          if (!this.p1CostsV2[0].Total) {
              var tempCosts = [];

              for (var item in this.p2CostsV2) {
                if (this.p2CostsV2[item].Total != 0) {
                  tempCosts.push(this.p2CostsV2[item]);
                }
              }

              this.p1CostsV2 = tempCosts;
            }
          } */

          if (this.partnerActive) {
            let date = new Date();
            let spouseRetirementAge = Number(this.client.clientProfile.Spouses[0].retirementAge);
            let spouseAge =  Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob));
            console.log('date.getFullYear()', date.getFullYear());
            console.log('spouseRetirementAge', spouseRetirementAge);
            this.spouseRetirementYear = Number(date.getFullYear()) + (spouseRetirementAge > spouseAge ? (spouseRetirementAge - spouseAge): 0);
            // spouseRetirementAge > spouseAge ? (spouseRetirementAge - spouseAge) : 0;
            //this.onCheckBoxChange('spouse');
          }

          var clientIndex = 0;
          var spouseIndex = 0;

          this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));

          // check index for client is spouse retires earlier
          if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            //this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
            if(this.spouseRetirementYear < this.hcDataV2.RetirementYear){
              clientIndex = (this.hcDataV2.RetirementYear - this.spouseRetirementYear);
              this.clientIndex = clientIndex;
              console.log('clientIndex', this.clientIndex);
            } else {
              spouseIndex = (this.spouseRetirementYear - this.hcDataV2.RetirementYear);
              this.spouseIndex = spouseIndex;
              console.log('spouseIndex', this.spouseIndex);
            }       
          }

          this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
          if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {

            //this.hcDataV2.RetirementYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
            //this.hcDataV2.RetirementYear = Math.max(currentYear, this.hcDataV2.RetirementYear);

            this.hcDataV2.SpouseRetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));

          }

          //this.bracketChange(this.selectedIRMAABracket);
          if(this.displayHC){
            this.hcDataV2.TotalYear1OOP = Utils.formatToCurrency((this.p1CostsV2[clientIndex].AdditionalOOP[0] 
              + this.p1CostsV2[clientIndex].AdditionalOOP[1] 
              + this.p1CostsV2[clientIndex].AdditionalOOP[2] 
              + this.p1CostsV2[clientIndex].AdditionalOOP[3]).toFixed(0));//this.partnerActive ? (this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3] + this.p2CostsV2[0].AdditionalOOP[0] + this.p2CostsV2[0].AdditionalOOP[1] + this.p2CostsV2[0].AdditionalOOP[2] + this.p2CostsV2[0].AdditionalOOP[3]).toFixed(0) : (this.p1CostsV2[0].AdditionalOOP[0] + this.p1CostsV2[0].AdditionalOOP[1] + this.p1CostsV2[0].AdditionalOOP[2] + this.p1CostsV2[0].AdditionalOOP[3]).toFixed(0);
            this.hcDataV2.TotalYear1Premiums = Utils.formatToCurrency((this.p1CostsV2[clientIndex].Premiums[0] 
              + this.p1CostsV2[clientIndex].Premiums[1] 
              + this.p1CostsV2[clientIndex].Premiums[2] 
              + this.p1CostsV2[clientIndex].Premiums[3]).toFixed(0));//this.partnerActive ? (this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3] + this.p2CostsV2[0].Premiums[0] + this.p2CostsV2[0].Premiums[1] + this.p2CostsV2[0].Premiums[2] + this.p2CostsV2[0].Premiums[3]).toFixed(0) : (this.p1CostsV2[0].Premiums[0] + this.p1CostsV2[0].Premiums[1] + this.p1CostsV2[0].Premiums[2] + this.p1CostsV2[0].Premiums[3]).toFixed(0);
          

            if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {

              //this.hcDataV2.RetirementYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
              //this.hcDataV2.RetirementYear = Math.max(currentYear, this.hcDataV2.RetirementYear);
  
              this.hcDataV2.RetireYear = Math.min(this.hcDataV2.RetirementYear, this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob));
              this.hcDataV2.RetireYear = Math.max(currentYear, this.hcDataV2.RetireYear);
  
              this.hcDataV2.TotalYear1OOP1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].AdditionalOOP[0] + this.p2CostsV2[spouseIndex].AdditionalOOP[1] + this.p2CostsV2[spouseIndex].AdditionalOOP[2] + this.p2CostsV2[spouseIndex].AdditionalOOP[3]).toFixed(0));
              this.hcDataV2.TotalYear1Premiums1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].Premiums[0] + this.p2CostsV2[spouseIndex].Premiums[1] + this.p2CostsV2[spouseIndex].Premiums[2] + this.p2CostsV2[spouseIndex].Premiums[3]).toFixed(0));
              //console.log('13');      
              
              this.hcDataV2.YearOneTotal1 = Utils.formatToCurrency((this.p2CostsV2[spouseIndex].AdditionalOOP[0] 
                + this.p2CostsV2[spouseIndex].AdditionalOOP[1] 
                + this.p2CostsV2[spouseIndex].AdditionalOOP[2] 
                + this.p2CostsV2[spouseIndex].AdditionalOOP[3]
                + this.p2CostsV2[spouseIndex].Premiums[0] 
                + this.p2CostsV2[spouseIndex].Premiums[1] 
                + this.p2CostsV2[spouseIndex].Premiums[2] 
                + this.p2CostsV2[spouseIndex].Premiums[3]).toFixed(0));
  
            }

            if(this.hcDataV2.IncomeCompareAnalysis != null){
              this.hcDataV2.IncomeCompareAnalysis = JSON.parse(this.hcDataV2.IncomeCompareAnalysis);
              this.hcDataV2.IncomeCompareAnalysis.incomeCompareRows.shift();
            }

            this.futureTotalCost = Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", ""));
            this.projectedFutureLifetimeCosts = Number(this.hcDataV2.TotalProjectedCostPv.toString().replace(/,/g, "").replace("$", ""));


            this.totalSocialSecurity = Number(this.hcDataV2.FundingOptions.PartB.toString().replace(/,/g, "").replace("$", ""));

            this.hcDataV2.Illustrations = JSON.parse(this.hcDataV2.Illustrations);


            this.totalRemainingGap = Number(this.hcDataV2.Illustrations[0].BeginningBalance); //Number(this.hcDataV2.FundingOptions.InvestmentAmountCoverage.toString().replace(",","").replace("$",""));

            this.currentRemainingTotal = Utils.formatToCurrency(this.futureTotalCost - this.totalSocialSecurity);

            if (this.fundingItems.length > 0) {
              var tempTotal = this.futureTotalCost - this.totalSocialSecurity;

              for (var i = 0; i < this.fundingItems.length; i++) {
                this.fundingItems[i].remainingUnfunded = this.fundingItems[i - 1] ? this.fundingItems[i - 1].remainingUnfunded - this.fundingItems[i].contributionAmount : tempTotal - this.fundingItems[i].contributionAmount;
              }

            }

            this.futureYearlyCost = this.annualEl ? this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * this.annualEl.nativeElement.value : this.hcDataV2.FundingOptions.CalcPayments.AnnualPaymentAmount.toString().replace(/,/g, "").replace("$", "") * 10;
            this.weeklyCost = Utils.formatToCurrency(this.annualEl ? Number(((Number(this.futureYearlyCost) / this.annualEl.nativeElement.value) / 52).toFixed(0)) : Number(((Number(this.futureYearlyCost) / 10) / 52).toFixed(0)));



            this.futureYearlyCost = Utils.formatToCurrency(this.futureYearlyCost);
            this.beginningBalance = Utils.formatToCurrency(this.hcDataV2.Illustrations[0].BeginningBalance.toFixed(0));
          }
         /*  if(this.displayMMT){
            this.getMMTData();
          } else if (this.displaySS){
            this.getSSData(false);
          } else {
            this.getLTCData(client);
          } */
          //if(this.client.ClientProfile.Bracket && this.displayHC){
          if(this.displayHC){
            //this.getMMTData();
            this.getMMTBracket();
            // this.calculatTotalNetHCAmount();
          }
          
          //for combined report
          if(this.displayLTC){
            console.log('calling LTC now');
            this.getLTCData(client);
            /* if(this.editingScenario == 'Alternate' || this.editingScenario == 'What If'){
              this.editingScenario = '';
            } */
          } else {        
            console.log('setting scenario now');  
            this.setScenarioObj(this.hasClickedAltSaveButton, !this.hasClickedAltSaveButton);
            /* if(this.editingScenario == 'Alternate' || this.editingScenario == 'What If'){
              this.editingScenario = '';
            } */

            this.loadingService.isLoading(false);
          }

          //console.log('made to end of HC value set');
        },
        error => this.error = <any>error);
        //console.log('error', this.error);
  }

  desiredRetirementAgeAdjustment(isClient){
    if(isClient){
      if(this.clientModelV2.generalInformation.retirementAge < 65) {
        this.isPre65 = true;
        if (this.profileInfo.value.privateHealthInsurance) {
          this.profileInfo.controls['privateHealthInsurance'].setValue(true);
        }
      } else {
        this.isPre65 = false;
        this.profileInfo.controls['privateHealthInsurance'].setValue(false);
      }
    } else {
      if(this.clientModelV2.maritalStatus.retirementAge < 65){
        this.isSpousePre65 = true;
        if (this.profileInfo.value.privateHealthInsurance) {
          this.spouseProfileInfo.controls['privateHealthInsurance'].setValue(true);
        }
      } else {
        this.isSpousePre65 = false;
        this.spouseProfileInfo.controls['privateHealthInsurance'].setValue(false);
      }
    }
  }

  isSelectAllPremiums: boolean = false;
  isSelectAllOOP: boolean = false;
  isSpouseSelectAllPremiums: boolean = false;
  isSpouseSelectAllOOP: boolean = false;
  selectOptions(isClient, isPremiums, selectAll = false, premiumType = "TM"){
    if(isClient){
        
        if(isPremiums){
          this.isSelectAllPremiums = selectAll;
        //Premiums        
        if(premiumType == "TM"){
          this.profileInfo.controls['MedicarePartB'].setValue(selectAll);
          this.profileInfo.controls['MedicarePartD'].setValue(selectAll);
          this.profileInfo.controls['SupplimentalInsurance'].setValue(selectAll);
        } else if(premiumType == "HMO"){
          //this.profileInfo.controls['MedicareAdvantageHMO'].setValue(selectAll);
        } else if(premiumType == "PPO"){
          //this.profileInfo.controls['MedicareAdvantagePPO'].setValue(selectAll);
        }

        this.profileInfo.controls['DentalInsurance'].setValue(selectAll);
      } else {
        //OOP
        this.isSelectAllOOP = selectAll;
        this.profileInfo.controls['HospitalAndTest'].setValue(selectAll);
        this.profileInfo.controls['PrescriptionDrugs'].setValue(selectAll);
        this.profileInfo.controls['HearingAndVisionCosts'].setValue(selectAll);
        this.profileInfo.controls['DentalCosts'].setValue(selectAll);
        
      }

      //for TM - if there are no Premiums and no OOPs, default to Part B and Part D (toggled off Select All)
      if(premiumType == "TM" && !this.isSelectAllOOP && !this.isSelectAllPremiums){
        this.profileInfo.controls['MedicarePartB'].setValue(true);
        //this.profileInfo.controls['MedicarePartD'].setValue(true);
      }
    } else {
      if(isPremiums){
        this.isSpouseSelectAllPremiums = selectAll;
        //Premiums        
        if(premiumType == "TM"){
          this.spouseProfileInfo.controls['MedicarePartB'].setValue(selectAll);
          this.spouseProfileInfo.controls['MedicarePartD'].setValue(selectAll);
          this.spouseProfileInfo.controls['SupplimentalInsurance'].setValue(selectAll);
        } else if(premiumType == "HMO"){
          //this.spouseProfileInfo.controls['MedicareAdvantageHMO'].setValue(selectAll);
        } else if(premiumType == "PPO"){
          //this.spouseProfileInfo.controls['MedicareAdvantagePPO'].setValue(selectAll);
        }

        this.spouseProfileInfo.controls['DentalInsurance'].setValue(selectAll);
      } else {
        this.isSpouseSelectAllOOP = selectAll;
        //OOP
        this.spouseProfileInfo.controls['HospitalAndTest'].setValue(selectAll);
        this.spouseProfileInfo.controls['PrescriptionDrugs'].setValue(selectAll);
        this.spouseProfileInfo.controls['HearingAndVisionCosts'].setValue(selectAll);
        this.spouseProfileInfo.controls['DentalCosts'].setValue(selectAll);
        
      }

      //for TM - if there are no Premiums and no OOPs, default to Part B and Part D (toggled off Select All)
      if(premiumType == "TM" && !this.isSpouseSelectAllOOP && !this.isSpouseSelectAllPremiums){
        this.spouseProfileInfo.controls['MedicarePartB'].setValue(true);
        //this.spouseProfileInfo.controls['MedicarePartD'].setValue(true);
      }
    }
  }

  public selfPeriods: number = 12;
  public selfRegion: number = 0;
  public selfType: number = 1;
  public selfTypeList: any[] = [{ careType: 1, lengthOfCare: 12 }];
  public spouseTypeList: any[] = [{ careType: 1, lengthOfCare: 12 }];

  public spousePeriods: number = 12;
  public spouseRegion: number = 0;
  public spouseType: number = 1;
  responseLTC: any = {};

  public clientRegions: any;
  public spouseRegions: any = [];
  public expectedLE: any;
  includeSpouse = false;

  getLTCData(client) {
    this.includeSpouse = client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    this.selfRegion = this.retirementAreaForm.value.clientMetroRegion;//this.client.clientProfile.ClientMetroArea || 0;
    this.spouseRegion = this.retirementAreaForm.value.spouseMetroRegion;//this.client.clientProfile.SpouseMetroArea || 0;

    var investmentItems = [];
    var currentAge = this.calculateAge(client.client.DOB);
    var currentYear = new Date().getFullYear();

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: (this.fundingItems[item].startAge - currentAge) + currentYear,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: (this.fundingItems[item].endAge - currentAge) + currentYear,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }

    const ltc = {
      investmentItems: JSON.stringify({ investmentItems }),
      FrmHasPartner: this.includeSpouse,
      FrmName0: client.client.FirstName + ' ' + client.client.LastName,
      FrmName1: this.includeSpouse ? client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName : '',
      FrmGender0: client.client.GenderID,
      FrmCurrentAge0: this.calculateAge(client.client.DOB),
      FrmGender1: this.includeSpouse ? Number(client.clientProfile.Spouses[0].gender) : 0,
      FrmCurrentAge1: this.includeSpouse ? this.calculateAge(client.clientProfile.Spouses[0].dob) : 0,
      
      FrmLTCState0: client.clientProfile.UseNationalAverage ? '' : (client.clientProfile.RetirementState == "NA") ? "" : client.clientProfile.RetirementState,
      FrmLTCState1: this.includeSpouse ? (client.clientProfile.UseNationalAverage ? '' : (client.clientProfile.Spouses[0].state == "NA") ? "" : client.clientProfile.Spouses[0].state) : '',

      FrmHealth0: 0,
      FrmHealth1: 0,
      
      FrmPhase1Rate: this.p1Percent ? 6 : 6,
      FrmPhase1Periods: this.p1EndAge ? 65 - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: this.p2Percent ? 6 : 6,
      FrmPhase2Periods: this.p2EndAge ? (75 - 65) : 10,
      FrmPhase3Rate: this.p3Percent ? 6 : 6,

      FrmLTCMonths0: this.selfPeriods,
      FrmLTCMonths1: this.spousePeriods,

      FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
      FrmPlanningAge1: this.includeSpouse ? Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,

      MetroRegion0: this.selfRegion, // here
      MetroRegion1: this.spouseRegion,

      //MetroRegionDesc0: this.clientRegions.MetroRegion,//this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
      //MetroRegionDesc1: (this.spouseRegions) ? this.spouseRegions.MetroRegion : "",//this.includeSpouse ? this.getRegionDescription(this.includeSpouse ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false) : '',
  
      //PHX Defaults this to 10 in prod
      InvestmentYears: 10, //(Number(this.annualEl.nativeElement.value || 0)),
      InvestmentOption: this.investmentOption,

      //TODO: API needs to change to get all data returned for all care types
      CareType: this.selfType,
      CareType1: this.spouseType,

      //these lists have both type and periods/length of time
      ClientCareTypes: this.selfTypeList,
      SpouseCareTypes: this.spouseTypeList,
      SelfDOB: this.client.client.DOB,
      SpouseDOB: this.partnerActive ? this.client.clientProfile.Spouses[0].dob : "",

      isQuickReport: true
    }

    const queryInfo = {
      reportType: (this.displayHC && this.displayLTC) ? 13 : 10,
      clientID: client.client.ID,
      userID: client.client.AdvisorID,
      orgID: client.client.OrganizationID,
      clientRetirementAge: client.clientProfile.RetirementAge,
      partnerRetirementAge: this.includeSpouse ? this.client.clientProfile.Spouses[0].retirementAge : 0
    }

    console.log('ltc obj before', ltc);

    this.globalService.getLTCData(ltc, queryInfo)
      .subscribe(
        data => {
          console.log('ltc data', data);
          this.responseLTC = data;
          console.log(this.displayLTC)
          this.futureTotalCost = Utils.removeCurrencyFormatting(this.responseLTC.FutureCostTotal) 
            + (this.includeSpouse && this.responseLTC.FutureCostTotal1 ? Utils.removeCurrencyFormatting(this.responseLTC.FutureCostTotal1) : 0);
          
          this.responseLTC.depositedToday = Utils.formatToCurrency(this.responseLTC.depositedToday.toFixed(0));
          this.responseLTC.annualNumber = Utils.formatToCurrency(this.responseLTC.annualNumber.toFixed(0));
          this.responseLTC.weeklyNumber = Utils.formatToCurrency(this.responseLTC.weeklyNumber.toFixed(0));
          this.responseLTC.totalFutureNumber = Utils.formatToCurrency(this.responseLTC.totalFutureNumber.toFixed(0));

          let clientMetroArea = this.responseLTC.regionExpenses.Rows;//this.responseLTC.regionExpenses.Rows.splice(1, this.responseLTC.regionExpenses.Rows.length);//this.clientLtcStateRegions.find(o  => o.MetroRegionCode == this.client.clientProfile.ClientMetroArea);
          console.log('client metro', clientMetroArea);
          if(this.client.clientProfile.ClientMetroArea){
            this.clientRegions = clientMetroArea.find(o  => o.MetroRegionCode == this.client.clientProfile.ClientMetroArea);//this.responseLTC.regionExpenses.Rows.splice(1, this.responseLTC.regionExpenses.Rows.length);
            console.log('client regions', this.clientRegions);
          } else {
            this.clientRegions = "";
          }

          if(this.includeSpouse){
            let spouseMetroArea = this.responseLTC.regionExpenses1.Rows;//this.responseLTC.regionExpenses1.Rows.splice(1, this.responseLTC.regionExpenses1.Rows.length);
            if(this.client.clientProfile.SpouseMetroArea){
              this.spouseRegions = spouseMetroArea.find(o  => o.MetroRegionCode == this.client.clientProfile.SpouseMetroArea);
              //this.includeSpouse ? this.responseLTC.regionExpenses1.Rows.splice(1, this.responseLTC.regionExpenses1.Rows.length) : [];
            } else {
              this.spouseRegions = "";
            }
          }

          this.client && this.client.clientProfile ? this.client.clientProfile.LifeExpectancy : '--'

          this.expectedLE = this.client.clientProfile.LifeExpectancy;

          if (this.includeSpouse) {
            this.expectedLE = this.client.clientProfile.LifeExpectancy > this.client.clientProfile.Spouses[0].LifeExpectancy ? this.client.clientProfile.LifeExpectancy : this.client.clientProfile.Spouses[0].LifeExpectancy;
          }

          if(this.displayHC){
            //total up LTC and HC
            //this.futureTotalCost += Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", ""));
            //this.hcDataV2.TotalProjectedCost = Utils.formatToCurrency(Number(this.hcDataV2.TotalProjectedCost.toString().replace(/,/g, "").replace("$", "")) + this.futureTotalCost);
          }
          
          console.log('this.editingScenario', this.editingScenario);
          //this.setScenarioObj((this.editingScenario == 'Alternate' || this.editingScenario == 'What If'), (this.editingScenario != 'Alternate' && this.editingScenario != 'What If'));
          this.setScenarioObj(this.hasClickedAltSaveButton, !this.hasClickedAltSaveButton);
          /* if(this.editingScenario == 'Alternate' || this.editingScenario == 'What If'){
            this.editingScenario = '';
          } */

          this.loadingService.isLoading(false);
        },
        error => this.error = <any>error);

  }

  //TODO: do we need all these variables for SS ???
 /*  socialSecurityForm = new FormGroup({
    futureValue: new FormControl('false'),
    inflationRate: new FormControl('1.3%'),
    colaFirst: new FormControl('1.6%'),
    colaSecond: new FormControl('2.6%'),
    colaThird: new FormControl('2.6%'),
    colaFourth: new FormControl('2.6%'),
    selfRetirementYears: new FormControl('60'),
    selfRetirementMonths: new FormControl('1'),
    selfAlreadyClaiming: new FormControl('false'),
    spouseRetirementYears: new FormControl('60'),
    spouseRetirementMonths: new FormControl('1'),
    spouseAlreadyClaiming: new FormControl('false'),
    selfLifeExpectancy: new FormControl('90'),
    spouseLifeExpectancy: new FormControl('90'),
    illustrationCashFlow: new FormControl({})
  }); */

  public selectedIllustration: any;
  public selectedIllustrationIdx: number = 0;
  public comparisonIllustration: any;
  public discountRate: number = 3;
  public clientMonthlyBenefitAmount: number = 0;
  public spouseMonthlyBenefitAmount: number = 0;
  public startPIA;
  public endPIA;
  public spouseStartPIA;
  public spouseEndPIA;
  public clientSurvivorSwitchYears: number = 0;//70
  public clientSurvivorSwitchMonths: number = 0;
  public clientPIA: Number = 1250;
  public clientClaimStatus: string = "False";
  public clientRetirementYears: any = 67;
  public clientRetirementMonths: Number = 0;
  public spousePIA: Number = 0;//1250
  public spouseClaimStatus: string = "False";
  public spouseRetirementYears: any = 67;
  public spouseRetirementMonths: Number = 0;
  public presentValue: string = "True";

  public clientClaimStatusDisabled: boolean = false;
  public spouseClaimStatusDisabled: boolean = false;

  clientAgeMonth: Number = 0;
  spouseAgeMonth: Number = 0;

  socialSecurityRetirementAgeForm: FormGroup;

  ssObject;
  swappedClaim;
  isSurvAndFirstLoadSwapped;
  isPageReloadOtherThanFRACall;
  storedOriginalSSObject;
  hasClientSidebarBeenUpdated;
  getSocialSecurityObjectV2(isAlt){
    if(isAlt){
      this.socialSecurityRetirementAgeForm.controls['clientClaimAge'].enable();
      this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].enable();
      if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
        this.socialSecurityRetirementAgeForm.controls['spouseClaimAge'].enable();
        this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].enable();
      }
    }

        var tempChildren = [];
        var tempChild = {};    
        
        /* if (this.client.clientProfile.Children && this.client.clientProfile.Children.length) {
          for (var k in this.client.clientProfile.Children) {
            tempChild = {};
            tempChild["CurrentAge"] =  Number(this.client.clientProfile.Children[k].DependentChildAge);//this.getNumber(this.editClientModel.clientProfile.Spouses[k].currentIncome);
            tempChild['isDisabled'] = false;
            tempChild['IsStudentAt19'] = false; //this.client.clientProfile.Children[k].DependentChildStudent == "Yes" ? true : false;
            tempChildren.push(tempChild);
          }
        } */
    
        if (this.client.clientProfile.Children && this.client.clientProfile.Children.length) {
          for (var k in this.client.clientProfile.Children) {
            if (this.client.clientProfile.Children[k].DependentChildAge) {
              tempChild = {};
              tempChild["CurrentAge"] = Number(this.client.clientProfile.Children[k].DependentChildAge);
              tempChild['isDisabled'] = !!this.client.clientProfile.Children[k].isDisabled;
              tempChild['dacAnticipateEnd'] = !!this.client.clientProfile.Children[k].dacAnticipateEnd;
              tempChild['StopBenefitsAge'] = this.client.clientProfile.Children[k].dacEndAge || null;
              tempChild['IsStudentAt19'] = false;
              tempChildren.push(tempChild);
            }
          }
        }
    
        var investmentItems = [];
    
        for (var item in this.fundingItems) {
    
          var contribution = {
            Description: this.fundingItems[item].fundingSource,
            Begins: this.fundingItems[item].startAge,
            Ends: this.fundingItems[item].endAge,
            StartAmount: this.fundingItems[item].annContribution,
            Cola: this.fundingItems[item].inflationRate,
          }
    
          investmentItems.push(contribution);
        }
        console.log('this.includeSpouse', this.includeSpouse);
        let spousePIA = this.includeSpouse ? (((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') && this.client.clientProfile.Spouses[0].tenyears)?this.client.clientProfile.Spouses[0].pia: this.spousePIA.toString().replace(/,/g,"").replace("$","")) : 0;
        let spouseLifeExpectancy = this.includeSpouse? ((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')? (this.client.clientProfile.Spouses[0].exSpouseLifeExpectancy || 0):this.client.clientProfile.Spouses[0].LifeExpectancy) : 0;
        console.log('spouseLifeExpectancy 001', spouseLifeExpectancy);
        let spouseAlreadyCollecting = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing ? true : false) : this.client.clientProfile.SpouseAlreadyCollecting ? this.client.clientProfile.SpouseAlreadyCollecting: false;
        //console.log('asdff', this.client.clientProfile.Spouses[0].pia);
        console.log('this.client.clientProfile.PIAYears', this.client.clientProfile.PIAYears);
        console.log('hasAdjustedFRAScenario', this.hasAdjustedFRAScenario);
    
        let spouseGovtPension = Number(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g,"").replace("$","") || 0 : 0);
    
        let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : "1/1/1960");
        if (!this.hasAdjustedFRAScenario) {
          //if(!this.isPageReloadOtherThanFRACall){
            console.log('here i am');
            this.ssObject = {
              InvestmentItems: investmentItems,//JSON.stringify({ investmentItems }),
              InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value) : 0,
              InvestmentOption: this.investmentOption,
    
              FrmPhase1Rate: 6,
              FrmPhase1Periods: Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
              FrmPhase2Rate: 6,
              FrmPhase2Periods: 10,
              FrmPhase3Rate: 6,
    
              FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
              SelfCurrentMonthlyBenefit: (this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 ? this.client.clientProfile.MonthlyBenefitAmount : this.clientMonthlyBenefitAmount,
              SpouseAlreadyCollecting: spouseAlreadyCollecting, //(this.client.clientProfile.Spouses) ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing : "False" : "False",
              //this.client.clientProfile.SpouseAlreadyCollecting == 1 ? 'True': 'False', //'False',//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseClaimStatus : "False",
              SelfGovPensionAmount: this.client.clientProfile.Pension,// "", // --> Needs to be updated, but how is this calculated?
              // Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? tempChildren : [],
              Children: tempChildren,//this.client.clientProfile.Children || tempChildren,
              SelfAlreadyCollecting: this.client.clientProfile.SelfAlreadyCollecting == 1 ? 'True' : 'False', //'False',//this.clientClaimStatus,
              // SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 89 : 0, // make this part of ssData output
              selfConditions: JSON.stringify({
                HCHBP: this.client.clientProfile.HCHBP || 0,
                HCHC: this.client.clientProfile.HCHC || 0,
                HCT1D: this.client.clientProfile.HCT1D || 0,
                HCT2D: this.client.clientProfile.HCT2D || 0,
                HCCD: this.client.clientProfile.HCCD || 0,
                HCC: this.client.clientProfile.HCC || 0,
                HCT: this.client.clientProfile.HCT || 0,
                HCMS: this.client.clientProfile.HCMS || 0,
                HCDCW: this.client.clientProfile.HCDCW || 0,
                HCFHDC: this.client.clientProfile.HCFHDC || 0,
    
                HCALZ: this.client.clientProfile.HCALZ || 0,
                HCPARK: this.client.clientProfile.HCPARK || 0,
                HCAMP: this.client.clientProfile.HCAMP || 0,
                HCPTSD: this.client.clientProfile.HCPTSD || 0,
                HCOBS: this.client.clientProfile.HCOBS || 0,
              }),
              spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? JSON.stringify({
                HCHBP: this.client.clientProfile.Spouses[0].HCHBP || 0,
                HCHC: this.client.clientProfile.Spouses[0].HCHC || 0,
                HCT1D: this.client.clientProfile.Spouses[0].HCT1D || 0,
                HCT2D: this.client.clientProfile.Spouses[0].HCT2D || 0,
                HCCD: this.client.clientProfile.Spouses[0].HCCD || 0,
                HCC: this.client.clientProfile.Spouses[0].HCC || 0,
                HCT: this.client.clientProfile.Spouses[0].HCT || 0,
                HCMS: this.client.clientProfile.Spouses[0].HCMS || 0,
                HCDCW: this.client.clientProfile.Spouses[0].HCDCW || 0,
                HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC || 0,
    
                HCALZ: this.client.clientProfile.Spouses[0].HCALZ || 0,
                HCPARK: this.client.clientProfile.Spouses[0].HCPARK || 0,
                HCAMP: this.client.clientProfile.Spouses[0].HCAMP || 0,
                HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD || 0,
                HCOBS: this.client.clientProfile.Spouses[0].HCOBS || 0,
              }) : "",
    
              includeSpouse: this.includeSpouse,
    
              selfGender: this.client.client.GenderID,
              spouseGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].gender || 1 : 1,
              // Finish validating fields below this --------
    
              BendPointInflation: 2, // make this part of ssData ?
              SelfCurrentAge: this.calculateAge(this.client.client.DOB),
              SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.calculateAge(spouseDOB) || 30 : 30,
              IsPresentValue: false,//this.presentValue,// == "True" ? true : false,
              SpouseCurrentMonthlyBenefit: (this.client.clientProfile.Spouses[0].monthlyBenefits) ? Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits) : this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g, "").replace("$", "") || 0 : 0,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 0 : 0,
              FrmIncome: "Ind1", // make this part of ssData output
              SelfPensionStartMonth: this.client.clientProfile.PensionMonths, // ??
              isSelfSuspendable: "False", // ??
              SpouseBenefitAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseRetirementYears : 0,
              selfCanRestrict: "False", // ??
              SpousePIA: spousePIA || 0,
              /* SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0, //87, // make this part of ssData output
              SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0, */
              SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy,//this.socialSecurityForm.get('selfLifeExpectancy').value,
              SpouseLifeExpectancy: spouseLifeExpectancy || 0,
    
              StrategyDropDown: "AutoSelect",
              SelfPensionFrequency: "Monthly",
              SelfPensionStartYear: this.client.clientProfile.PensionYears, // ??
              SelfPensionInfl: (this.client.clientProfile.PensionInfl == null) ? 3.00 : this.client.clientProfile.PensionInfl, //default is null
              SelfPIA: this.clientPIA,
              COLA: this.colas,
              FrmColaXml: this.colas,
              SpousePensionStartMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionMonth : 3,
              SpouseGovPensionAmount: spouseGovtPension,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g, "").replace("$", "") || 0 : 0,
              SpouseGovPension: spouseGovtPension > 0 ? true : false,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].IncludePension == 1) ? "True" : "False" : "False",
              SpousePensionInfl: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].PensionInfl == null) ? 3 : this.client.clientProfile.Spouses[0].PensionInfl : 3,
              PIAIncomeYears1: 0, // ??
              SelfAlreadyClaimedAge: 0, // ??
              spouseCanRestrict: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
              SelfSubstantialEarningsYears: (this.client.clientProfile.SubstantialEarningYears) ? this.client.clientProfile.SubstantialEarningYears : 0,//this.client.clientProfile.SubstantialEarningYears || 30, // ??
              SelfBenefitAge: this.clientRetirementYears,// 67,
              FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
              SpouseAlreadyClaimedAge: 0, // ??
    
              // MaritalState: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].maritalStatus : (this.client.clientProfile.Spouses.length > 1) ? this.client.clientProfile.Spouses[1].maritalStatus : "Single",
              MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,
    
              SpousePensionStartYear: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionYear : "",
              SpousePensionFrequency: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "Monthly" : "",
              RetirementStrategy: "FileForBenefits", // get in ssData ??
              PIAIncomeYears2: 0, // ??
              SpouseSubstantialEarningsYears: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].IncludePension ? (this.client.clientProfile.Spouses[0].substantialEarningYears) ? this.client.clientProfile.Spouses[0].substantialEarningYears : 0 : 0,
              SelfGovPension: this.client.clientProfile.IncludePension == 1 ? true : false,//"False",
              isSpouseSuspendable: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
    
              //TODO: If between sessions, a user ages past their entered “Alternate 2” claim age (even if it’s just one of two spouses), then it reverts back to FRA automatically (unless already older than FRA).
              selfRetirementYears: (isAlt) ? this.socialSecurityRetirementAgeForm.value.clientClaimAge : this.clientRetirementYears,
              selfRetirementMonths: (isAlt) ? this.client.clientProfile.SelfAlreadyCollecting > 0 ? (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.client.DOB) : (this.socialSecurityRetirementAgeForm.value.clientClaimMonths) ? this.socialSecurityRetirementAgeForm.value.clientClaimMonths : 0 : this.clientRetirementMonths,
              spouseRetirementYears: (isAlt && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') ? this.socialSecurityRetirementAgeForm.value.spouseClaimAge : ((this.includeSpouse) ? this.spouseRetirementYears : 0),//this.spouseRetirementYears,
              spouseRetirementMonths: (isAlt && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') ? this.client.clientProfile.SpouseAlreadyCollecting > 0 ? (new Date().getMonth()) - this.getBirthdayMonth(spouseDOB) : (this.socialSecurityRetirementAgeForm.value.spouseClaimMonths) ? this.socialSecurityRetirementAgeForm.value.spouseClaimMonths : 0 :  ((this.includeSpouse) ? this.spouseRetirementMonths : 0),//this.spouseRetirementMonths || 0,
    
              SelfFilingRestrictedYear: (this.ssObject) ? (this.ssObject.SelfFilingRestrictedYear) ? this.ssObject.SelfFilingRestrictedYear : 0 : 0,
              SelfFilingRestrictedMonth: (this.ssObject) ? (this.ssObject.SelfFilingRestrictedMonth) ? this.ssObject.SelfFilingRestrictedMonth : 0 : 0,
              SpouseFilingRestrictedYear: (this.ssObject) ? (this.ssObject.SpouseFilingRestrictedYear) ? this.ssObject.SpouseFilingRestrictedYear : 0 : 0,
              SpouseFilingRestrictedMonth: (this.ssObject) ? (this.ssObject.SpouseFilingRestrictedMonth) ? this.ssObject.SpouseFilingRestrictedMonth : 0 : 0,
        
              clientSurvivorSwitchYears: this.clientSurvivorSwitchYears,
              clientSurvivorSwitchMonths: this.clientSurvivorSwitchMonths,
              SurvivorSwitchYears: this.clientSurvivorSwitchYears,
              SurvivorSwitchMonths: this.clientSurvivorSwitchMonths,
    
              SelfDOB: this.client.client.DOB,
              SpouseDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? spouseDOB || '1/1/1960':'1/1/1960',
              SpouseHasDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? true : Date.parse(this.client.clientProfile.Spouses[0].dob) ? true : false) : false,
              SelfCurrentIncome: this.client.clientProfile.CurrentIncome,
              SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].currentIncome : 0,
              SelfIRR: (this.client.clientProfile.IRR) ? this.client.clientProfile.IRR : (this.client.clientProfile.HouseholdYearOneIncome / (this.client.clientProfile.CurrentIncome + (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].currentIncome) ? this.client.clientProfile.Spouses[0].currentIncome : 0 : 0))),
    
              //FrmDiscountRate: parseFloat((this.discountRate / 100).toString()),      
              FrmDiscountRate: 0.034,//this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100,
              SelfRetirementAge: this.client.clientProfile.RetirementAge,
              // SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.client.clientProfile.Spouses[0].retirementAge) ? this.client.clientProfile.Spouses[0].retirementAge : 0 : 0 : 0,
              SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? 0 : (this.client.clientProfile.Spouses[0].retirementAge ? this.client.clientProfile.Spouses[0].retirementAge : 0)  : 0,
              SpousePreviousSpouses: JSON.stringify(this.previousSpouse),
              FrmState: this.client.clientProfile.RetirementState == 'NA' ? '  ' : this.client.clientProfile.RetirementState,
              FrmState1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
              SelfWorkingInRetirement: this.client.clientProfile.InRetStopWorkAge > 0 && this.client.clientProfile.InRetFirstYearIncome != null ? this.client.clientProfile.InRetStopWorkAge : 0,
              SpouseWorkingInRetirement: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetStopWork : 0,
              SelfWorkingInRetirementIncome: this.client.clientProfile.InRetFirstYearIncome > 0 ? this.client.clientProfile.InRetFirstYearIncome : 0,
              SpouseWorkingInRetirementIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetFirstYearIncome : 0,
              InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 2.40 : this.client.clientProfile.InRetirementInflationRate, //default if null
              MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome, //default if null
    
              //TODO: not sure I need these...leave for now
              SelfKnownBenefitClaiming: (this.client.clientProfile.SelfKnownBenefitClaiming) ? this.client.clientProfile.SelfKnownBenefitClaiming : 0,
              SpouseKnownBenefitClaiming: (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : 0 : 0,
    
              //earnsInRetStartAge: this.client.clientProfile.RetirementAge,
              //earnsInRetEndAge: this.client.clientProfile.InRetStopWorkAge
    
              SelfYearOfStatement: this.client.clientProfile.YearOfStatement || this.currentYear,
              SpouseYearOfStatement: this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : this.currentYear : this.currentYear,
              SelfSpouses: this.client.clientProfile.Spouses,
    
              SelfDateOfClaimMonth: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimMonth || 0 : 0,
              SelfDateOfClaimYear: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimYear || 0 : 0,
              SpouseDateOfClaimMonth: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimMonth : 0,
              SpouseDateOfClaimYear: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimYear : 0,
              HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome || 0,
              PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate, //default if null
              MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year || 0 : 0,
              MidRetRedDollar: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
              MidRetRedPer: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,
              MidRetIncomeInflationRate: this.client.midRetirementAdj ? this.client.midRetirementAdj.IncomeInflationRate || null : null,
              SelfSubEarningYears: this.client.clientProfile.SubstantialEarningYearsDetails ? this.client.clientProfile.SubstantialEarningYearsDetails : null,
              SpouseSubEarningYears: this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].SubstantialEarningYearsDetails ? JSON.stringify(this.client.clientProfile.Spouses[0].PIAYears) : null,
              invertSurvivorSwitch: !this.swappedClaim ? 0 : 1, //this.swappedClaim && this.adjSurvivorModal ? 0 : 1,
              SelfWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
              SelfWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].yearAtTimeOfPassing : 0 : 0,
              
              //TODO: issues with setting/calculating PIA in Alt when no PIA is set
              SelfFRAAge: this.clientRetirementYears,
              SelfFRAMonth: this.clientRetirementMonths,
              SpouseFRAAge: this.spouseRetirementYears,
              SpouseFRAMonth: this.spouseRetirementMonths,
    
              //TODO: the below is needed for Spouses of Spouses....or we could just use the SpousePreviousSpouses field
              //SpouseWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
              //SpouseWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0
            //}
          }
        } else {
          //this.ssObjectFRA.isPresentValue = this.isPresentValue;
        }
    
        // console.log('set up for p1', this.clientRetirementYears + ' ' + this.clientRetirementMonths);
    
       /*  if (!this.hasAdjustedFRAScenario && this.changedAlt2BackToFRA) {
          this.ssObject.invertSurvivorSwitch = 0;
          this.changedAlt2BackToFRA = false;
        } */
    
    
        //TODO ZSS: talk to Dustin about the updates below (04/01)
        if (this.ssObject.MaritalState == 'Divorced') { 
          this.ssObject.SpouseBenefitAge = 62;
          //this.ssObject.spouseRetirementYears = 62;
          //this.ssObject.spouseRetirementMonths = 0;
          this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears : 62;
          this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths : 0;
          //if (this.hasAdjustedFRAScenario && this.ssObjectFRA) {
            //this.ssObjectFRA.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears : 62;
            //this.ssObjectFRA.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths : 0;
          //}
        } else if (this.ssObject.MaritalState == 'Widowed') {      
          this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears : 62;
          this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths : 0;
          //if (this.hasAdjustedFRAScenario && this.ssObjectFRA) {
          //  this.ssObjectFRA.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears : 62;
          //  this.ssObjectFRA.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths : 0;
         // }
        } else {
          //optimize FRA on page load
          if(this.ssObject.SpouseRetirementAge < this.ssObject.spouseRetirementYears
            && this.ssObject.SpouseLifeExpectancy < this.ssObject.spouseRetirementYears
          ){
            this.ssObject.spouseRetirementYears = (this.ssObject.SpouseRetirementAge < 62) ? 62 : this.ssObject.SpouseRetirementAge;
            this.spouseRetirementYears = this.ssObject.spouseRetirementYears;
            //if (this.hasAdjustedFRAScenario && this.ssObjectFRA) {
            //  this.ssObjectFRA.spouseRetirementYears = this.ssObject.spouseRetirementYears;
            //  this.ssObjectFRA.SpouseFRAAge = this.ssObject.spouseRetirementYears;
              //this.spouseRetirementYears = this.ssObject.spouseRetirementYears;
            //}
          }
        } 
    
        var user = {
          UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
          CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
          ClientID: localStorage.getItem('selectedClient')
        }
        
        this.ssObject.spouseRetirementMonths = this.ssObject.spouseRetirementMonths || 0;
        
        if (isAlt)
          this.ssObject.IsAltRequest = true;
        else
          this.ssObject.IsAltRequest = false;
           
        /* if(this.hasAdjustedFRAScenario){
          this.ssObjectFRA.IsAltRequest = true;
          this.ssObjectFRA.IsFRAAltRequest = true;
        } else {
          if(this.ssObjectFRA){
            this.ssObjectFRA.IsAltRequest = false;
            this.ssObjectFRA.IsFRAAltRequest = false;
          }
        } */
    
        if (this.isSurvAndFirstLoadSwapped) {
          this.ssObject.invertSurvivorSwitch = 0
          // this.ssObjectFRA.invertSurvivorSwitch = 0
        }
    
        /* if(this.hasClientSidebarBeenUpdated){
          if(this.hasAdjustedFRAScenario && this.ssObjectFRA){
            this.ssObjectFRA.selfConditions = JSON.stringify({
              HCHBP: this.client.clientProfile.HCHBP || 0,
              HCHC: this.client.clientProfile.HCHC || 0,
              HCT1D: this.client.clientProfile.HCT1D || 0,
              HCT2D: this.client.clientProfile.HCT2D || 0,
              HCCD: this.client.clientProfile.HCCD || 0,
              HCC: this.client.clientProfile.HCC || 0,
              HCT: this.client.clientProfile.HCT || 0,
              HCMS: this.client.clientProfile.HCMS || 0,
              HCDCW: this.client.clientProfile.HCDCW || 0,
              HCFHDC: this.client.clientProfile.HCFHDC || 0,
    
              HCALZ: this.client.clientProfile.HCALZ || 0,
                HCPARK: this.client.clientProfile.HCPARK || 0,
                HCAMP: this.client.clientProfile.HCAMP || 0,
                HCPTSD: this.client.clientProfile.HCPTSD || 0,
                HCOBS: this.client.clientProfile.HCOBS || 0,
            });
            this.ssObjectFRA.spouseConditions = this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? JSON.stringify({
              HCHBP: this.client.clientProfile.Spouses[0].HCHBP || 0,
              HCHC: this.client.clientProfile.Spouses[0].HCHC || 0,
              HCT1D: this.client.clientProfile.Spouses[0].HCT1D || 0,
              HCT2D: this.client.clientProfile.Spouses[0].HCT2D || 0,
              HCCD: this.client.clientProfile.Spouses[0].HCCD || 0,
              HCC: this.client.clientProfile.Spouses[0].HCC || 0,
              HCT: this.client.clientProfile.Spouses[0].HCT || 0,
              HCMS: this.client.clientProfile.Spouses[0].HCMS || 0,
              HCDCW: this.client.clientProfile.Spouses[0].HCDCW || 0,
              HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC || 0,
    
              HCALZ: this.client.clientProfile.Spouses[0].HCALZ || 0,
                HCPARK: this.client.clientProfile.Spouses[0].HCPARK || 0,
                HCAMP: this.client.clientProfile.Spouses[0].HCAMP || 0,
                HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD || 0,
                HCOBS: this.client.clientProfile.Spouses[0].HCOBS || 0,
            }) : "";
    
            this.ssObjectFRA.SelfLifeExpectancy = this.client.clientProfile.LifeExpectancy;
            this.ssObjectFRA.SpouseLifeExpectancy = spouseLifeExpectancy || 0;
          } else {
            //this.ssObject.SelfLifeExpectancy = this.client.clientProfile.LifeExpectancy;
            //this.ssObject.SpouseLifeExpectancy = spouseLifeExpectancy || 0;
          }
        } */
    
        console.log('ss object', this.ssObject);    
    
        if(!this.isPageReloadOtherThanFRACall){
          this.storedOriginalSSObject = { ...this.ssObject };
          //this.storedOriginalSSObject = (this.hasAdjustedFRAScenario) ? { ...this.ssObjectFRA } : { ...this.ssObject };
          console.log('ss storedOriginalSSObject', this.storedOriginalSSObject);
        } else {
          this.ssObject = { ...this.storedOriginalSSObject };
          console.log('ss object after adj 01', this.ssObject);  
          //if(this.hasDurationBeenToggled){
            //this.ssObject.isPresentValue = this.isPresentValue;
          //}
                  
          if(this.hasClientSidebarBeenUpdated){
            console.log('side bar has been updated');  
            this.ssObject.SelfLifeExpectancy = this.client.clientProfile.LifeExpectancy;
            this.ssObject.SelfRetirementAge = this.client.clientProfile.RetirementAge;
            this.ssObject.selfGender = this.client.client.GenderID;
            this.ssObject.SelfCurrentAge = this.calculateAge(this.client.client.DOB);
            this.ssObject.SelfDOB = this.client.client.DOB
    
            if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" &&  this.includeSpouse) {
              this.ssObject.SpouseLifeExpectancy = spouseLifeExpectancy || 0;
              console.log('spouseLifeExpectancy 003', spouseLifeExpectancy);
              if(this.client.clientProfile.Spouses[0].LifeExpectancy){
                this.ssObject.SpouseLifeExpectancy = this.client.clientProfile.Spouses[0].LifeExpectancy || 0;
              }
              console.log('spouseLifeExpectancy 004', this.client.clientProfile.Spouses[0].LifeExpectancy);
              this.ssObject.SpouseCurrentAge = this.calculateAge(spouseDOB) || 30;
              this.ssObject.SpouseDOB = spouseDOB;
              
              if (this.ssObject.spouseGender)
                this.ssObject.spouseGender = this.client.clientProfile.Spouses[0].gender || 1;
            }
          }
        }
    
        this.ssObject.FrmDiscountRate = 0.034;//this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;
    
        console.log('ss object 01', this.ssObject);    
        /* if(!this.previousSSObject){
          //  console.log('setting previous obj');
          this.previousSSObject = { ...this.ssObject };
        } */

      if(!isAlt){
        //reset the form for edit
        this.socialSecurityRetirementAgeForm.controls['clientClaimAge'].setValue(this.clientRetirementYears);
        this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].setValue(this.clientRetirementMonths);

        //need to check is the SSDesiredAgeYears is saved to profile - if so, prepopulate with the Alt they would have on full on-screen
        if(this.client.clientProfile.SSDesiredAgeYears){
          this.socialSecurityRetirementAgeForm.controls['clientClaimAge'].setValue(this.client.clientProfile.SSDesiredAgeYears);
          this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].setValue(this.client.clientProfile.SSDesiredAgeMonths);
        }

        //set validation
        this.setSSDCAValidation(true);

        if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
          //reset the form for edit
          if(this.spouseRetirementYears){
            //console.log('spouse retirement', this.spouseRetirementYears);
            this.socialSecurityRetirementAgeForm.controls['spouseClaimAge'].setValue(this.spouseRetirementYears);
            this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].setValue(this.spouseRetirementMonths);
          }

          //need to check is the SSDesiredAgeYears is saved to profile - if so, prepopulate with the Alt they would have on full on-screen
          if(this.client.clientProfile.Spouses[0].sSDesiredAgeYears){
            this.socialSecurityRetirementAgeForm.controls['spouseClaimAge'].setValue(this.client.clientProfile.Spouses[0].sSDesiredAgeYears);
            this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].setValue(this.client.clientProfile.Spouses[0].sSDesiredAgeMonths);
          }

          //set validation
          this.setSSDCAValidation(false);
        }
      } else {
        this.setSSDCAValidation(true);
        if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
          this.setSSDCAValidation(false);
        }
      }


    return this.ssObject;
  }

  getSocialSecurityObject(isAlt) {
    var tempChildren = [];
    var tempChild = {};

    //this.includeSpouse = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;

    if (this.client.clientProfile && this.client.clientProfile.Children && this.client.clientProfile.Children.length) {
      for (var k in this.client.clientProfile.Children) {
        tempChild = {};
        tempChild["CurrentAge"] = Number(this.client.clientProfile.Children[k].DependentChildAge) || 0;
        tempChild['isDisabled'] = !!this.client.clientProfile.Children[k].isDisabled;
        tempChild['dacAnticipateEnd'] = !!this.client.clientProfile.Children[k].dacAnticipateEnd;
        tempChild['StopBenefitsAge'] = this.client.clientProfile.Children[k].dacEndAge || null;
        tempChild['IsStudentAt19'] = false;
        //tempChild['isDisabled'] = false;
        //tempChild['IsStudentAt19'] = false;
        tempChildren.push(tempChild);
      }
    }

    //SET FRA
    var clientFRA = this.getFRAv2(this.client.client.DOB);
    this.clientRetirementYears = clientFRA.age;
    this.clientRetirementMonths = clientFRA.month;

    var clientMonths = 0;
    var spouseMonths = 0;

    // Past FRA, past retirement
    /* if (this.clientRetirementYears <= this.calculateAge(this.client.client.DOB)) {
      this.clientRetirementYears = this.calculateAge(this.client.client.DOB);

      clientMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.client.DOB);

      if (clientMonths > 0) {
        this.clientRetirementMonths = clientMonths;
      } else if (clientMonths < 0) {
        this.clientRetirementMonths = 12 + clientMonths;
      } else {
        this.clientRetirementMonths = 0;
      }
    } */


    // Past FRA, past retirement
    // already collected
    let isSelfAlreadyCollected = this.client.clientProfile.SelfAlreadyCollecting == 1 ? true : false;
    clientMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.client.DOB);
    // console.log('this.getBirthdayMonth(this.client.client.DOB)',this.getBirthdayMonth(this.client.client.DOB));
    // console.log('new Date().getMonth() + 1', new Date().getMonth());
    if (clientMonths > 0) {
      this.clientAgeMonth = clientMonths;
    } else if (clientMonths < 0) {
      this.clientAgeMonth = 12 + clientMonths;
    } else {
      this.clientAgeMonth = 0;
    }
    const birthDate = new Date(this.client.client.DOB);
    const startYear = new Date();
    let currentExactAge = this.calculateAge(birthDate);
    console.log('currentExactAge', currentExactAge);
    console.log('isSelfAlreadyCollected', isSelfAlreadyCollected);
    console.log('this.clientRetirementYears', this.clientRetirementYears);
    if (this.clientRetirementYears < currentExactAge || (this.clientRetirementYears == currentExactAge && this.clientRetirementMonths < this.clientAgeMonth)  || isSelfAlreadyCollected) {
      this.clientRetirementYears = currentExactAge;
      if(this.clientRetirementYears >= 70){
        if (currentExactAge >= 70) {
          this.clientRetirementMonths = this.clientAgeMonth;
        } else {
          this.clientRetirementMonths = 0;
        }
      } else {
        this.clientRetirementMonths = this.clientAgeMonth;
      }
    }

    if(!isAlt){
      //reset the form for edit
      this.socialSecurityRetirementAgeForm.controls['clientClaimAge'].setValue(this.clientRetirementYears);
      this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].setValue(this.clientRetirementMonths);

      //need to check is the SSDesiredAgeYears is saved to profile - if so, prepopulate with the Alt they would have on full on-screen
      if(this.client.clientProfile.SSDesiredAgeYears){
        this.socialSecurityRetirementAgeForm.controls['clientClaimAge'].setValue(this.client.clientProfile.SSDesiredAgeYears);
        this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].setValue(this.client.clientProfile.SSDesiredAgeMonths);
      }

      //set validation
      this.setSSDCAValidation(true);
    }

    if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus != 'Married') {
      let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : null) ;
          
      if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced'){
        //this.spouseRetirementYears = this.calculateAge(this.client.clientProfile.Spouses[0].dob) > 67 ? Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : 67;
        this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;              
        this.spouseRetirementMonths = 1;
      } else {
        if(this.includeSpouse){
          //console.log('this is setting the spouseRetirementYears');
          //this.spouseRetirementYears = this.calculateAge(this.client.clientProfile.Spouses[0].dob) > 67 ? Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : 67;
          this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;                
          this.spouseRetirementMonths = 1;
        }
      }
      //console.log('zss in here 08', this.client.clientProfile.Spouses);
      if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive) {
        //console.log('zss in here 09', this.client.clientProfile.Spouses[0].alive);
        this.client.clientProfile.Spouses[0].maritalStatus = 'Widowed';              
        this.spouseRetirementMonths = 1;
      } 
      
     /*  else if((this.client.clientProfile.Spouses.length > 1 && this.client.clientProfile.Spouses[0].maritalStatus == 'Single')){
        console.log('zss in here 09', this.client.clientProfile.Spouses[0].alive);
        if(this.client.clientProfile.Spouses[1].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[1].alive){
          this.client.clientProfile.Spouses[1].maritalStatus = 'Widowed'
        }
      } */

    }

    let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : "1/1/1960");
    
    console.log('client FRA', clientFRA);
    if(this.includeSpouse){
      if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' || this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced'){
        this.spouseClaimStatus = this.calculateAge(spouseDOB) >= 70 ? "True" : "False";
        this.spouseClaimStatusDisabled = this.calculateAge(spouseDOB) < 62 || this.calculateAge(spouseDOB) >= 70;

        
        var spouseFRA = this.getFRAv2(this.client.clientProfile.Spouses[0].dob);
        this.spouseRetirementYears = spouseFRA.age;
        this.spouseRetirementMonths = spouseFRA.month;

        spouseMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(spouseDOB);
            if (spouseMonths > 0) {
              this.spouseAgeMonth = spouseMonths;
            } else if (spouseMonths < 0) {
              this.spouseAgeMonth = 12 + spouseMonths;
            } else {
              this.spouseAgeMonth = 0;
            }
            let isSpouseAlreadyCollected = this.client.clientProfile.SpouseAlreadyCollecting == 1 ? true : false;
            let spouseAge = this.calculateAge(spouseDOB);
            if (this.spouseRetirementYears < spouseAge  
              || (this.spouseRetirementYears == spouseAge && this.spouseRetirementMonths < this.spouseAgeMonth ) 
              || isSpouseAlreadyCollected) {
              //console.log('set spouse in this if statment');
              this.spouseRetirementYears = spouseAge ;
              // this.spouseRetirementMonths = this.getBirthdayMonth(spouseDOB);

              // this.spouseRetirementMonths = spouseAgeMonth;

              if(this.spouseRetirementYears >= 70){
                if (spouseAge >= 70) {
                  this.spouseRetirementMonths = this.spouseAgeMonth;
                } else {
                  this.spouseRetirementMonths = 0;
                }
              } else {
                this.spouseRetirementMonths = this.spouseAgeMonth;
              }

            }
            

            // this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;
            this.spouseMonthlyBenefitAmount = (this.client.clientProfile.Spouses[0].pia) ? this.client.clientProfile.Spouses[0].pia : 0;

            this.spouseStartPIA = (70/100) * this.spouseMonthlyBenefitAmount;
            this.spouseEndPIA = (132/100) * this.spouseMonthlyBenefitAmount;

        if(!isAlt && this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
          //reset the form for edit
          if(this.spouseRetirementYears){
            //console.log('spouse retirement', this.spouseRetirementYears);
            this.socialSecurityRetirementAgeForm.controls['spouseClaimAge'].setValue(this.spouseRetirementYears);
            this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].setValue(this.spouseRetirementMonths);
          }

          //need to check is the SSDesiredAgeYears is saved to profile - if so, prepopulate with the Alt they would have on full on-screen
          if(this.client.clientProfile.Spouses[0].sSDesiredAgeYears){
            this.socialSecurityRetirementAgeForm.controls['spouseClaimAge'].setValue(this.client.clientProfile.Spouses[0].sSDesiredAgeYears);
            this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].setValue(this.client.clientProfile.Spouses[0].sSDesiredAgeMonths);
          }

          //set validation
          this.setSSDCAValidation(false);
        }
      }

      if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') {
        this.spouseMonthlyBenefitAmount = this.client.clientProfile.Spouses[0].monthlyBenefitAtPassing;
        if(this.client.clientProfile.Spouses[0].monthlyBenefitAtPassing){
          this.spouseClaimStatus = "True";
        }
      }
    }

    //this.spouseRetirementYears = 65;
    var SpouseRetirementAge = this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? 0 : (this.client.clientProfile.Spouses[0].retirementAge ? this.client.clientProfile.Spouses[0].retirementAge : 0)  : 0;
    let spouseLifeExpectancy = this.includeSpouse? ((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')? (this.client.clientProfile.Spouses[0].exSpouseLifeExpectancy || 0):this.client.clientProfile.Spouses[0].LifeExpectancy) : 0;
    if(SpouseRetirementAge < this.spouseRetirementYears
      && spouseLifeExpectancy < this.spouseRetirementYears
    ){
      this.spouseRetirementYears = (SpouseRetirementAge < 62) ? 62 : SpouseRetirementAge;
      this.spouseRetirementYears = this.spouseRetirementYears;
    }
    //this.includeSpouse = this.includeSpouse;
    console.log('spouse FRA', spouseFRA);

    let previousSpouseWidowSpouse;          
    for (let spousesSpouse in this.client.clientProfile.Spouses) {
      for (let previousSpouse in this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse) {
        if (this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse].maritalStatus == 'Widowed')
          previousSpouseWidowSpouse = this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse];
      }
    }

    var previousSpouse = previousSpouseWidowSpouse || { pia: "$0"};
    
    //let spouseAlreadyCollecting = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing ? true : false) : this.client.clientProfile.SpouseAlreadyCollecting ? this.client.clientProfile.SpouseAlreadyCollecting: false;

    //TODO: setup
    var investmentItems = [];
    var swappedClaim = false;

    if (this.client.clientProfile.Spouses.length) {
      this.spousePIA = typeof this.client.clientProfile.Spouses[0].pia === 'string' 
        ? this.client.clientProfile.Spouses[0].pia.replace(/,/g,"").replace("$","") 
        : (this.client.clientProfile.Spouses[0].pia) 
        ? this.client.clientProfile.Spouses[0].pia : 0;
    }

    //let spousePIA = this.includeSpouse ? (((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') && this.client.clientProfile.Spouses[0].tenyears)?this.client.clientProfile.Spouses[0].pia: this.spousePIA.toString().replace(/,/g,"").replace("$","")) : 0;
    this.clientMonthlyBenefitAmount = (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0;


    this.spousePIA = this.includeSpouse ? (((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') && this.client.clientProfile.Spouses[0].tenyears)?this.client.clientProfile.Spouses[0].pia: this.spousePIA.toString().replace(/,/g,"").replace("$","")) : 0;
    //let spouseLifeExpectancy = this.includeSpouse? ((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')? (this.client.clientProfile.Spouses[0].exSpouseLifeExpectancy || 0):this.client.clientProfile.Spouses[0].LifeExpectancy) : 0;
    //console.log('spouseLifeExpectancy 001', spouseLifeExpectancy);
    let spouseAlreadyCollecting = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing ? true : false) : this.client.clientProfile.SpouseAlreadyCollecting ? this.client.clientProfile.SpouseAlreadyCollecting: false;
    //console.log('asdff', this.client.clientProfile.Spouses[0].pia);
    console.log('this.client.clientProfile.PIAYears', this.client.clientProfile.PIAYears);
    console.log('hasAdjustedFRAScenario', this.hasAdjustedFRAScenario);

    let spouseGovtPension = Number(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g,"").replace("$","") || 0 : 0);

    return {
      InvestmentItems: investmentItems,
      InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value) : 0,
      InvestmentOption: this.investmentOption,

      //defaulted vales for rates on quick
      FrmPhase1Rate: 6,
      FrmPhase1Periods: Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
      FrmPhase2Rate: 6,
      FrmPhase2Periods: 10,
      FrmPhase3Rate: 6,

      FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
      //SelfCurrentMonthlyBenefit: this.clientMonthlyBenefitAmount,
      //SelfCurrentMonthlyBenefit: (this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 ? this.client.clientProfile.MonthlyBenefitAmount : this.clientMonthlyBenefitAmount,
      SelfCurrentMonthlyBenefit: (this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 ? this.client.clientProfile.MonthlyBenefitAmount : this.clientMonthlyBenefitAmount,
      SpouseAlreadyCollecting: spouseAlreadyCollecting,
      SelfGovPensionAmount: this.client.clientProfile.Pension,
      Children: [],//this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? this.client.clientProfile.Children : null,
      SelfAlreadyCollecting: this.client.clientProfile.SelfAlreadyCollecting == 1 ? 'True' : 'False',
      selfConditions: JSON.stringify({
        HCHBP: this.client.clientProfile.HCHBP || 0,
        HCHC: this.client.clientProfile.HCHC || 0,
        HCT1D: this.client.clientProfile.HCT1D || 0,
        HCT2D: this.client.clientProfile.HCT2D || 0,
        HCCD: this.client.clientProfile.HCCD || 0,
        HCC: this.client.clientProfile.HCC || 0,
        HCT: this.client.clientProfile.HCT || 0,
        HCMS: this.client.clientProfile.HCMS || 0,
        HCDCW: this.client.clientProfile.HCDCW || 0,
        HCFHDC: this.client.clientProfile.HCFHDC || 0,

        HCALZ: this.client.clientProfile.HCALZ || 0,
        HCPARK: this.client.clientProfile.HCPARK || 0,
        HCAMP: this.client.clientProfile.HCAMP || 0,
        HCPTSD: this.client.clientProfile.HCPTSD || 0,
        HCOBS: this.client.clientProfile.HCOBS || 0,
      }),
      spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? JSON.stringify({
        HCHBP: this.client.clientProfile.Spouses[0].HCHBP || 0,
        HCHC: this.client.clientProfile.Spouses[0].HCHC || 0,
        HCT1D: this.client.clientProfile.Spouses[0].HCT1D || 0,
        HCT2D: this.client.clientProfile.Spouses[0].HCT2D || 0,
        HCCD: this.client.clientProfile.Spouses[0].HCCD || 0,
        HCC: this.client.clientProfile.Spouses[0].HCC || 0,
        HCT: this.client.clientProfile.Spouses[0].HCT || 0,
        HCMS: this.client.clientProfile.Spouses[0].HCMS || 0,
        HCDCW: this.client.clientProfile.Spouses[0].HCDCW || 0,
        HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC || 0,

        HCALZ: this.client.clientProfile.Spouses[0].HCALZ || 0,
        HCPARK: this.client.clientProfile.Spouses[0].HCPARK || 0,
        HCAMP: this.client.clientProfile.Spouses[0].HCAMP || 0,
        HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD || 0,
        HCOBS: this.client.clientProfile.Spouses[0].HCOBS || 0,
      }) : "",
      includeSpouse: this.includeSpouse,
      selfGender: this.client.client.GenderID,
      spouseGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].gender || 1 : 1,
      BendPointInflation: 2,
      SelfCurrentAge: this.calculateAge(this.client.client.DOB),
      //SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) || 30 : 30,
      SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.calculateAge(spouseDOB) || 30 : 30,
      IsPresentValue: false,
      //SpouseCurrentMonthlyBenefit: this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g, "").replace("$", "") || 0 : 0,
      SpouseCurrentMonthlyBenefit: (this.client.clientProfile.Spouses[0].monthlyBenefits) ? Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits) : this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g, "").replace("$", "") || 0 : 0,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 0 : 0,
      FrmIncome: "Ind1",
      SelfPensionStartMonth: this.client.clientProfile.PensionMonths,
      isSelfSuspendable: "False",
      
      //SpouseBenefitAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseRetirementYears : 0,
      SpouseBenefitAge: (isAlt && this.includeSpouse) ? this.socialSecurityRetirementAgeForm.value.spouseClaimAge : ((this.includeSpouse) ? this.spouseRetirementYears : 0),
      
      selfCanRestrict: "False",
      SpousePIA: this.spousePIA,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spousePIA.toString().replace(/,/g, "").replace("$", "") : 0,
      SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy,//this.socialSecurityForm.get('selfLifeExpectancy').value,
      SpouseLifeExpectancy: this.client.clientProfile.Spouses[0].LifeExpectancy,//this.socialSecurityForm.get('spouseLifeExpectancy').value,
      StrategyDropDown: "AutoSelect",
      SelfPensionFrequency: "Monthly",
      SelfPensionStartYear: this.client.clientProfile.PensionYears,
      SelfPensionInfl: (this.client.clientProfile.PensionInfl == null) ? 3.00 : this.client.clientProfile.PensionInfl, //default is null
      SelfPIA: (this.client.clientProfile.PIA != null) ? this.client.clientProfile.PIA : 0,
      COLA: this.colas,
      FrmColaXml: this.colas,
      SpousePensionStartMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionMonth : 3,
      SpouseGovPensionAmount: spouseGovtPension,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g, "").replace("$", "") || 0 : 0,
      SpouseGovPension: spouseGovtPension > 0 ? true : false,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].includePension : "False",
      SpousePensionInfl: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].PensionInfl == null) ? 3 : this.client.clientProfile.Spouses[0].PensionInfl : 3,
      PIAIncomeYears1: 0,

      //TODO: need to add claim months as well (API check)
      SelfAlreadyClaimedAge: 0,//(isAlt) ? this.socialSecurityRetirementAgeForm.value.clientClaimAge : 0,

      SpouseAlreadyClaimedAge: 0,//(isAlt) ? this.socialSecurityRetirementAgeForm.value.spouseClaimAge : 0,

      spouseCanRestrict: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
      //SelfSubstantialEarningsYears: this.client.clientProfile.SubstantialEarningYears || 30,
      SelfSubstantialEarningsYears: this.client.clientProfile.SubstantialEarningYears ? this.client.clientProfile.SubstantialEarningYears : 0,
      
      SelfBenefitAge: (isAlt) ? this.socialSecurityRetirementAgeForm.value.clientClaimAge : this.clientRetirementYears,

      FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
      MaritalState: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].maritalStatus : "Single",
      SpousePensionStartYear: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionYear : "",
      SpousePensionFrequency: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "Monthly" : "",
      RetirementStrategy: "FileForBenefits",
      PIAIncomeYears2: 0,
      SpouseSubstantialEarningsYears: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].includePension ? Number(this.client.clientProfile.Spouses[0].substantialEarningYears) : 0,
      SelfGovPension: this.client.clientProfile.IncludePension == 1 ? true : false,
      isSpouseSuspendable: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
      
      selfRetirementYears: (isAlt) ? this.socialSecurityRetirementAgeForm.value.clientClaimAge : this.clientRetirementYears,
      selfRetirementMonths: (isAlt) ? (this.socialSecurityRetirementAgeForm.value.clientClaimMonths) ? this.socialSecurityRetirementAgeForm.value.clientClaimMonths : 0 : this.clientRetirementMonths,
      //Not always married....will this throw an error??
      spouseRetirementYears: (isAlt) ? this.socialSecurityRetirementAgeForm.value.spouseClaimAge : ((this.includeSpouse) ? this.spouseRetirementYears : 0),
      spouseRetirementMonths: (isAlt) ? (this.socialSecurityRetirementAgeForm.value.spouseClaimMonths) ? this.socialSecurityRetirementAgeForm.value.spouseClaimMonths : 0 :  ((this.includeSpouse) ? this.spouseRetirementMonths : 0),

      SelfFilingRestrictedYear: (this.client.clientProfile.SelfFilingRestrictedYear) ? this.client.clientProfile.SelfFilingRestrictedYear : 0,
      SelfFilingRestrictedMonth: (this.client.clientProfile.SelfFilingRestrictedMonth) ? this.client.clientProfile.SelfFilingRestrictedMonth : 0,
      SpouseFilingRestrictedYear: (this.client.clientProfile.Spouses[0].SpouseFilingRestrictedYear) ? this.client.clientProfile.Spouses[0].SpouseFilingRestrictedYear : 0,
      SpouseFilingRestrictedMonth: (this.client.clientProfile.Spouses[0].SpouseFilingRestrictedMonth) ? this.client.clientProfile.Spouses[0].SpouseFilingRestrictedMonth : 0,
      

      clientSurvivorSwitchYears: this.clientSurvivorSwitchYears,
      clientSurvivorSwitchMonths: this.clientSurvivorSwitchMonths,
      SurvivorSwitchYears: this.clientSurvivorSwitchYears,
      SurvivorSwitchMonths: this.clientSurvivorSwitchMonths,

      SelfDOB: this.client.client.DOB,
      //SpouseDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '1/1/1960') : '1/1/1960',
      SpouseDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? spouseDOB || '1/1/1960':'1/1/1960',
      SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null) ? this.client.clientProfile.CurrentIncome : 0,
      SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].currentIncome : 0,
      //SelfIRR: (this.client.clientProfile.IRR != null) ? this.client.clientProfile.IRR : 0,
      SelfIRR: (this.client.clientProfile.IRR) ? this.client.clientProfile.IRR : (this.client.clientProfile.HouseholdYearOneIncome / (this.client.clientProfile.CurrentIncome + (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].currentIncome) ? this.client.clientProfile.Spouses[0].currentIncome : 0 : 0))),
      
      FrmDiscountRate: 0.034,//parseFloat((Number(this.socialSecurityForm.get('inflationRate').value.replace('%', '')) / 100).toString()),
      SelfRetirementAge: this.client.clientProfile.RetirementAge,
      SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? 0 : (this.client.clientProfile.Spouses[0].retirementAge ? this.client.clientProfile.Spouses[0].retirementAge : 0)  : 0,
      SpousePreviousSpouses: JSON.stringify(previousSpouse),
      FrmState: this.client.clientProfile.RetirementState == 'NA' ? '  ' : this.client.clientProfile.RetirementState,
      FrmState1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
      SelfWorkingInRetirement: this.client.clientProfile.InRetStopWorkAge > 0 && this.client.clientProfile.InRetFirstYearIncome != null ? this.client.clientProfile.InRetStopWorkAge : 0,
      SpouseWorkingInRetirement: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetStopWork : 0,
      SelfWorkingInRetirementIncome: this.client.clientProfile.InRetFirstYearIncome > 0 ? this.client.clientProfile.InRetFirstYearIncome : 0,
      SpouseWorkingInRetirementIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetFirstYearIncome : 0,
      InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 2.40 : this.client.clientProfile.InRetirementInflationRate, //default if null
      MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome, //default if null

      SelfKnownBenefitClaiming: (this.client.clientProfile.SelfKnownBenefitClaiming) ? this.client.clientProfile.SelfKnownBenefitClaiming : 0,
      SpouseKnownBenefitClaiming: (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : 0 : 0,

      //earnsInRetStartAge: this.client.clientProfile.RetirementAge,
      //earnsInRetEndAge: this.client.clientProfile.InRetStopWorkAge

      SelfYearOfStatement: this.client.clientProfile.YearOfStatement || this.currentYear,
      SpouseYearOfStatement: this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : this.currentYear : this.currentYear,
      SelfSpouses: this.client.clientProfile.Spouses,

      SelfDateOfClaimMonth: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimMonth || 0 : 0,
      SelfDateOfClaimYear: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimYear || 0 : 0,
      SpouseDateOfClaimMonth: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimMonth : 0,
      SpouseDateOfClaimYear: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimYear : 0,
      HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome || 0,
      PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate, //default if null
      MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year || 0 : 0,
      MidRetRedDollar: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
      MidRetRedPer: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,
      MidRetIncomeInflationRate: this.client.midRetirementAdj ? this.client.midRetirementAdj.IncomeInflationRate || null : null,
      SelfSubEarningYears: this.client.clientProfile.SubstantialEarningYearsDetails ? this.client.clientProfile.SubstantialEarningYearsDetails : null,
      SpouseSubEarningYears: this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].SubstantialEarningYearsDetails ? JSON.stringify(this.client.clientProfile.Spouses[0].PIAYears) : null,
      invertSurvivorSwitch: !swappedClaim ? 0 : 1, //this.swappedClaim && this.adjSurvivorModal ? 0 : 1,
      SelfWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
      SelfWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].yearAtTimeOfPassing : 0 : 0,
      
      //TODO: issues with setting/calculating PIA in Alt when no PIA is set
      SelfFRAAge: this.clientRetirementYears,
      SelfFRAMonth: this.clientRetirementMonths,
      SpouseFRAAge: this.spouseRetirementYears,
      SpouseFRAMonth: this.spouseRetirementMonths
    }
  }

  //TODO: need to review if/when we need Survivor here
  clientRetirementYearsMin = 62;
  spouseRetirementYearsMin = 62;
  setSSDCAValidation(isClient){
    if(isClient){
      //if already collecting - disable both age and months
      if(this.client.clientProfile.SelfAlreadyCollecting){
        this.socialSecurityRetirementAgeForm.controls['clientClaimAge'].disable();
        this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].disable();
      } else {
        this.clientRetirementYearsMin = Math.min(62, this.clientRetirementYears);
        this.socialSecurityRetirementAgeForm.get('clientClaimAge').setValidators([Validators.required, Validators.min(this.clientRetirementYearsMin), Validators.max(70)]);
        this.socialSecurityRetirementAgeForm.get('clientClaimAge').updateValueAndValidity();

        if(this.socialSecurityRetirementAgeForm.value.clientClaimAge == 70){
          this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].setValue(0);
          this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].disable();
        } else {        
          this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].enable();        
          this.socialSecurityRetirementAgeForm.get('clientClaimMonths').setValidators([Validators.min(0), Validators.max(11)]);
        }

        this.socialSecurityRetirementAgeForm.get('clientClaimMonths').updateValueAndValidity();
      }
      
    } else {
      //if already collecting - disable both age and months
      if(this.client.clientProfile.SpouseAlreadyCollecting){
        this.socialSecurityRetirementAgeForm.controls['spouseClaimAge'].disable();
        this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].disable();
      } else {
        this.spouseRetirementYearsMin = Math.min(62, this.spouseRetirementYears);
        this.socialSecurityRetirementAgeForm.get('spouseClaimAge').setValidators([Validators.required, Validators.min(this.spouseRetirementYearsMin), Validators.max(70)]);
        this.socialSecurityRetirementAgeForm.get('spouseClaimAge').updateValueAndValidity();

        if(this.socialSecurityRetirementAgeForm.value.spouseClaimAge == 70){
          this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].setValue(0);
          this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].disable();
        } else {
          this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].enable();
          this.socialSecurityRetirementAgeForm.get('spouseClaimMonths').setValidators([Validators.min(0), Validators.max(11)]);
        }
        
        this.socialSecurityRetirementAgeForm.get('spouseClaimMonths').updateValueAndValidity();
      }
    }
  }

  getFRAv2(bday){
    // const startYear = new Date().getFullYear();
    const birthDate = new Date(bday);
    //var yearOfBirth = birthDate.getFullYear();
    var yearOfBirth = this.getBirthdayFullYear(birthDate);

    // var yearOfBirth = startYear - birthYear;
    // console.log('yearOfBirth',yearOfBirth);
    var fraMonths = 0;
    if(yearOfBirth <= 1954){
      if (yearOfBirth <= 1937) {
        fraMonths = 780;
      } else {
        if (yearOfBirth <=1942) {
          switch (yearOfBirth)
          {
            case 1938:
              fraMonths = 780+2;
              break;
            case 1939:
              fraMonths = 780 + 4;
              break;
            case 1940:
              fraMonths = 780 + 6;
              break;
            case 1941:
              fraMonths = 780 + 8;
              break;
            case 1942:
              fraMonths = 780 + 10;
              break;

          }
        } else {
          fraMonths = 792;
        }

      }
    } else if (yearOfBirth <=1961 && this.client.clientProfile.Spouses[0].maritalStatus === 'Widowed') {
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 0;
          break;
        case 1956:
          fraMonths = 792 + 0;
          break;
        case 1957:
          fraMonths = 792 + 2;
          break;
        case 1958:
          fraMonths = 792 + 4;
          break;
        case 1959:
          fraMonths = 792 + 6;
          break;
        case 1960:
          fraMonths = 792 + 8;
          break;
        case 1961:
          fraMonths = 792 + 10;
          break;
      }
    } else if(yearOfBirth <= 1959){
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 2;
          break;
        case 1956:
          fraMonths = 792 + 4;
          break;
        case 1957:
          fraMonths = 792 + 6;
          break;
        case 1958:
          fraMonths = 792 + 8;
          break;
        case 1959:
          fraMonths = 792 + 10;
          break;
      }
    } else {
      fraMonths = 804;
    }

    // console.log('fraMonths', fraMonths);
    var fra = fraMonths / 12;
    // console.log('fra', fra);
    // console.log('framonthtest', )

    let FRA = {
      age: 0,
      month: 0,
    }
    FRA.age = Math.floor(fra);
    //console.log('log FRA', fra%12)
    //this.getBirthdayMonth(bday)
    FRA.month = fraMonths % 12;

    // console.log('returned FRA', FRA);
    return FRA
  }

  getFRA(bday) {
    bday = typeof bday === 'string' ? bday : bday.formatted;
    let yearOfBirth = Number(bday.substring(bday.length - 4, bday.length));
    let FRA = {
      age: 0,
      month: 0,
    }

    if (yearOfBirth <= 1937) {
      FRA.age = 65;
      FRA.month = 0;
    } else if (yearOfBirth === 1938) {
      FRA.age = 65;
      FRA.month = 2;
    } else if (yearOfBirth === 1939) {
      FRA.age = 65;
      FRA.month = 4;
    } else if (yearOfBirth === 1940) {
      FRA.age = 65;
      FRA.month = 6;
    } else if (yearOfBirth === 1941) {
      FRA.age = 65;
      FRA.month = 8;
    } else if (yearOfBirth === 1942) {
      FRA.age = 65;
      FRA.month = 10;
    } else if (yearOfBirth >= 1943 && yearOfBirth <= 1954) {
      FRA.age = 66;
      FRA.month = 0;
    } else if (yearOfBirth === 1955) {
      FRA.age = 66;
      FRA.month = 2;
    } else if (yearOfBirth === 1956) {
      FRA.age = 66;
      FRA.month = 4;
    } else if (yearOfBirth === 1957) {
      FRA.age = 66;
      FRA.month = 6;
    } else if (yearOfBirth === 1958) {
      FRA.age = 66;
      FRA.month = 8;
    } else if (yearOfBirth === 1959) {
      FRA.age = 66;
      FRA.month = 10;
    } else if (yearOfBirth >= 1960) {
      FRA.age = 67;
      FRA.month = 0;
    } 

    return FRA;
  }

  getBirthdayFullYear(dob: Date){
    //const birthDate = new Date(dob);
    const startYear = new Date().getFullYear();

    var _monthOffset = 0;
    // If the person's DOB falls on the first day of the month, Soc.Sec. pretends they are an extra month older (as if born in the PREVIOUS month)
    if (dob.getDate() == 1)
    {
      _monthOffset = 1;
    }
    //return _monthOffset;
    // console.log('month day', dob.getDate());
    // console.log('month day offset', _monthOffset);


    var _yearOffset = 0;
    // If the person's DOB falls on New Year's Day, Soc.Sec. references factors and age thresholds according to the PREVIOUS year
    if ((dob.getMonth() == 0) && (_monthOffset == 1))
    {
      //(dbarksdale3) Updated behavior of this value
      //_yearOffset = -1;
      _yearOffset = 1;
    }
    //return _yearOffset;
    // console.log('month', dob.getMonth());
    // console.log('year offset', _yearOffset);


    return (startYear - this.getCurrentAgeByDOB(dob) - _yearOffset);
  }

  getCurrentAgeByDOB(birthday){
    var dob = new Date(birthday);
    const startYear = new Date();
    var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('getCurrentAgeByDOB', ((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
    return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  responseMMT;
  medicarePremiumsMMT;
  surchargesMMT;
  surchargesAvgCostPerYearMMT;
  totalMedicareCostMMT;

  public surcharges: string = '$0';
  public medicarePremiums: string = '$0';
  public totalMedicareCost: string = '$0';
  public totalSavings;//: string = '$0';
  public incomeReductionAmount: string = '$0';
  
  public startingSurchargeAmount: number = -1;
  public startingIllustration: any[];
  public changedSSAge:boolean = false;
  
  getMMTData() {
    var mmtInputs = {  
      InflationRate:  (this.client.clientProfile.InflationRate) ? this.client.clientProfile.InflationRate / 100 : 0.03,
      MagiIncomePercent: this.valueMAGISlider,
      IncludePartner: this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married',
      SocialSecurityRetirementAge: this.ssClientAge,
      SSMonthlyBenefit: this.client.clientProfile.PIA,
      PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? Number(this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "")) || 0 : this.client.clientProfile.Spouses[0] ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
      PartnerSocialSecurityAge: this.ssSpouseAge
    }

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient')
    }

    this.globalService.getMMTData(this.client, mmtInputs, user, true)
      .subscribe(
      mmtData => {
        this.responseMMT = mmtData;
        //this.calculateTotals(data);;
        //console.log('MMT Data', mmtData);
        var ts = 0, tp = 0, tm = 0, tss = 0;
        var savings = 0;
        var i = 0;
        for (var ageRange in mmtData.MagiAdjustedAgeRangeCosts) {
            tp += mmtData.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount;
            //surcharges: this.formatCurrency(entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]),
            ts += (mmtData.MagiAdjustedAgeRangeCosts[ageRange].Amount - mmtData.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount);
            tm += mmtData.MagiAdjustedAgeRangeCosts[ageRange].Amount;

            //i++;
            i = mmtData.MagiAdjustedAgeRangeCosts[ageRange].EndYear - mmtData.MagiAdjustedAgeRangeCosts[ageRange].StartYear;// + 1;
        }

        if (this.startingSurchargeAmount === -1 || this.changedSSAge) {
          this.startingSurchargeAmount = ts;
          this.startingIllustration = mmtData.IllustrationEntries;
          this.changedSSAge = false;
        } else {
            savings = Math.max(0, this.startingSurchargeAmount - ts);
        }

        this.medicarePremiumsMMT = tp;//this.formatCurrency(tp);
        this.surchargesMMT = ts;//totalSurcharges;//ts;//this.formatCurrency(ts);
        
        //console.log('Quick MMT surcharges', this.surchargesMMT);
        this.totalMedicareCostMMT = tm;//this.formatCurrency(tm);
        this.surchargesAvgCostPerYearMMT = ts / i;//this.formatCurrency(ts / i);
        //this.totalSavings = this.surchargesMMT = (mmtInputs.IncludePartner) ? savings / 2 : savings;
         this.totalSavings = (mmtInputs.IncludePartner) ? savings / 2 : savings;

        //HACK: added to get Quick MMT to load since HC was not yet set
        if(this.displayMMT){
          this.hcDataV2 = { RetirementYear: ((this.client.clientProfile.RetirementAge - this.client.clientProfile.CurrentAge) + new Date().getFullYear()) };
        }

        if(this.client.clientProfile.Bracket || this.displayMMT){
          this.incomeRangeSelectionForm.controls['IncomeOption'].setValue(1);

          if(this.displayMMT && !this.client.clientProfile.Bracket){
            if(this.client.clientProfile.HouseholdYearOneIncome){
              //this.setClientBracket(this.client.clientProfile.HouseholdYearOneIncome);
            } else {
              //this.client.clientProfile.Bracket = 1;
            }
          }

          this.getMMTBracket();
        } else {          
          this.incomeRangeSelectionForm.controls['IncomeOption'].setValue((this.client.clientProfile.HouseholdYearOneIncome) ? 3 : 2);
          //set validation on form(s)
          this.incomeRangeSelectionForm.get('IncomeValue').setValidators([Validators.required]);
          if(this.incomeRangeSelectionForm.value.IncomeOption == 2 && this.displayHC){
            if (this.client.clientProfile.IRR) {
              this.incomeRangeSelectionForm.get('IncomeReplacementRatio').setValidators([Validators.required, Validators.min(50), Validators.max(200)]);
              this.incomeRangeSelectionForm.get('IncomeInflationRate').setValidators([Validators.required]);
            }
          }
        }

        this.loadingService.isLoading(false);
      },
      error => this.error = <any>error);
  }

  changeIncomeOption(){
    this.isIncomeChange = true;
    if(this.incomeRangeSelectionForm.value.IncomeOption == 2 || this.incomeRangeSelectionForm.value.IncomeOption == 3){
      //this.client.clientProfile.Bracket = 6;
      //this.selectedIRMAABracket = 6;
      //this.incomeRangeSelectionForm.controls['BracketValue'].setValue(6);
      //this.incomeRangeSelectionForm.controls['BracketValue'].setValue(this.setClientBracket(this.client.clientProfile.CurrentIncome).toString());
      this.incomeRangeSelectionForm.get('IncomeValue').setValidators([Validators.required]);
      if(this.incomeRangeSelectionForm.value.IncomeOption == 2){
        this.incomeRangeSelectionForm.get('IncomeReplacementRatio').setValidators([Validators.required, Validators.min(50), Validators.max(200)]);
        this.incomeRangeSelectionForm.get('IncomeInflationRate').setValidators([Validators.required]);
      } else {
        this.incomeRangeSelectionForm.get('IncomeReplacementRatio').reset();
        this.incomeRangeSelectionForm.get('IncomeInflationRate').reset();
        this.incomeRangeSelectionForm.get('IncomeReplacementRatio').clearValidators();
        this.incomeRangeSelectionForm.get('IncomeInflationRate').clearValidators();
      }

      //default this.selectedIRMAABracket to null when not selecting a bracket
      this.selectedIRMAABracket = null;
    } else {
      //brackets here => default a selected bracket?
      if(!this.selectedIRMAABracket){
        this.selectedIRMAABracket = 1;
      }

      this.incomeRangeSelectionForm.get('IncomeValue').reset();
      this.incomeRangeSelectionForm.get('IncomeReplacementRatio').reset();
      this.incomeRangeSelectionForm.get('IncomeInflationRate').reset();

      this.incomeRangeSelectionForm.get('IncomeValue').clearValidators();
      this.incomeRangeSelectionForm.get('IncomeReplacementRatio').clearValidators();
      this.incomeRangeSelectionForm.get('IncomeInflationRate').clearValidators();
    }

    this.incomeRangeSelectionForm.get('IncomeValue').updateValueAndValidity();
    this.incomeRangeSelectionForm.get('IncomeReplacementRatio').updateValueAndValidity();
    this.incomeRangeSelectionForm.get('IncomeInflationRate').updateValueAndValidity();
  }

  responseMMTBracket;
  originalSetBracketForClient;
  incomeRangeSelectionForm: FormGroup;
  getMMTBracket() {
    let includePartner = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 'true' : 'false';
    var currentYear = new Date().getFullYear();
    let clientRetirementYear = Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
    let spouseRetirementYear = includePartner ? Math.max(currentYear, this.globalService.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob)): null;
    let bracketYear = includePartner ? (spouseRetirementYear < clientRetirementYear ? spouseRetirementYear: clientRetirementYear) : clientRetirementYear;
    if (spouseRetirementYear != 0 && spouseRetirementYear < clientRetirementYear) {
      bracketYear = spouseRetirementYear > currentYear ? spouseRetirementYear : currentYear;
    } else {
      bracketYear = clientRetirementYear > currentYear ? clientRetirementYear: currentYear;
    }

    console.log('bracketYear', bracketYear);
    this.globalService.getMMTBracket(includePartner, currentYear)
            .subscribe(
                data => {
                  this.responseMMTBracket = data;
                  console.log('MMT Brackets for Client', data);
                  this.selectedIRMAABracketDisplay = this.bracketChange(this.client.clientProfile.Bracket);
                  
                  //const currentYear = new Date().getFullYear();
                  //let isMarried = this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married';
                  let periods = Math.min(this.client.clientProfile.RetirementAge - Util.calculateAge(new Date(this.client.client.DOB), new Date()));

                  //If no bracket is set to the client profile, lets find the bracket for them
                  if(this.incomeRangeSelectionForm){
                    
                    if(this.incomeRangeSelectionForm.value.BracketValue == ''){
                      console.log('no bracket chosen');
                      this.incomeRangeSelectionForm.controls['BracketValue'].setValue(this.setClientBracket(this.client.clientProfile.CurrentIncome).toString());
                    }

                    this.displayClientSelectedBracket(this.incomeRangeSelectionForm.value.BracketValue);
                  } else {
                    this.displayClientSelectedBracket(this.client.clientProfile.Bracket);
                  }

                  if(!this.isIncomeChange && !this.displayMMT){
                    if (this.client.clientProfile.Bracket) {
                      //brackets
                      const brackets = [data.Bracket1, data.Bracket2, data.Bracket3, data.Bracket4, data.Bracket5, data.Bracket6]
                      const bracketIncome = this.client.clientProfile.Bracket == 1 ? brackets[1] / 2
                      : this.client.clientProfile.Bracket == 6 ?  brackets[5] : (brackets[this.client.clientProfile.Bracket - 1] + brackets[this.client.clientProfile.Bracket]) / 2;

                      this.client.clientProfile.CurrentIncome = bracketIncome;

                      this.displayClientBracket(this.client.clientProfile.Bracket);
                    } else {
                      if (this.client.clientProfile.CurrentIncome && !this.client.clientProfile.HouseholdYearOneIncome) {
                        this.incomeSubTitle = 'Household Income:'
                        this.client.clientProfile.CurrentIncome = this.client.clientProfile.HouseholdYearOneIncome;
                      } else {
                        this.incomeSubTitle = 'Household Income at Year 1 of Retirement:';
                      }

                      this.displayClientBracketText = this.incomeRangeSelectionForm.value.IncomeValue;
                    }

                    for (var i = 1; i <= periods; i++) {
                      this.client.clientProfile.CurrentIncome = this.client.clientProfile.CurrentIncome + (this.client.clientProfile.CurrentIncome * 0.03);
                    }

                    if (includePartner) {
                        /* this.client.clientProfile.Spouses[0].currentIncome = parseInt(this.client.clientProfile.CurrentIncome) / 2;
                        this.client.clientProfile.CurrentIncome = parseInt(this.client.clientProfile.CurrentIncome) / 2; */

                        /* this.client.clientProfile.Spouses[0].currentIncome = parseInt(this.incomeRangeSelectionForm.value.IncomeValue) / 2;
                        this.client.clientProfile.CurrentIncome = parseInt(this.incomeRangeSelectionForm.value.IncomeValue) / 2; */
                        
                    }

                    if (this.client.clientProfile.PIA === null) {
                      this.globalService.getPIA(this.generatePIAObject(this.client.clientProfile.CurrentIncome / 2)).subscribe(
                          piaData => {
                              this.client.clientProfile.PIA = piaData;

                              if (includePartner && this.client.clientProfile.Spouses[0].pia == null)
                                  this.client.clientProfile.Spouses[0].pia = piaData;

                              this.getMMTData();
                          }
                      );
                    } else {
                        //this.getMMTData();
                    }
                  } else {
                    if(this.isIncomeChange && this.displayMMT){
                      if (includePartner) {
                          if(this.client.clientProfile.Spouses[0].currentIncome){
                              //Portal1 backwards compatability add/fix
                              this.client.clientProfile.Spouses[0].currentIncome = parseInt(this.client.clientProfile.Spouses[0].currentIncome);                                
                          }
                      }

                      this.getMMTData();
                    } else {
                      if(this.incomeRangeSelectionForm.value.IncomeOption == 2){
                        this.incomeRangeSelectionForm.get('IncomeReplacementRatio').setValidators([Validators.required, Validators.min(50), Validators.max(200)]);
                        this.incomeRangeSelectionForm.get('IncomeInflationRate').setValidators([Validators.required]);
                        //this.incomeRangeSelectionForm.get('IncomeValue').updateValueAndValidity();
                        this.incomeRangeSelectionForm.get('IncomeReplacementRatio').updateValueAndValidity();
                        this.incomeRangeSelectionForm.get('IncomeInflationRate').updateValueAndValidity();
                      }
                    }
                  }

                  if(this.displayMMT && !this.displayHC){
                    //this.setScenarioObj((this.editingScenario == 'Alternate' || this.editingScenario == 'What If'), (this.editingScenario != 'Alternate' && this.editingScenario != 'What If'));
                    this.setScenarioObj(this.hasClickedAltSaveButton, !this.hasClickedAltSaveButton);
                    /* if(this.editingScenario == 'Alternate' || this.editingScenario == 'What If'){
                      this.editingScenario = '';
                    } */
                  }

                  //this.loadingService.isLoading(false);
                },
                error => console.log(error));
  }

  displayClientBracketText;
  displayClientSelectedBracketText;
  displayClientBracket(bracket){
    this.incomeSubTitle = 'Original MAGI:';
    if(bracket == 1){
      this.displayClientBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket1) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket2 - 1);
    } else if(bracket == 2){
      this.displayClientBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket2) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket3 - 1);
    } else if(bracket == 3){
      this.displayClientBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket3) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket4 - 1);
    } else if(bracket == 4){
      this.displayClientBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket4) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket5 - 1);
    } else if(bracket == 5){
      this.displayClientBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket5) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket6 - 1);
    } else { //6
      this.displayClientBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket6) + ' or more';
    }
  }

  displayClientSelectedBracket(bracket){
    if(bracket == 1){
      this.displayClientSelectedBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket1) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket2);
    } else if(bracket == 2){
      this.displayClientSelectedBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket2) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket3);
    } else if(bracket == 3){
      this.displayClientSelectedBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket3) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket4);
    } else if(bracket == 4){
      this.displayClientSelectedBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket4) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket5);
    } else if(bracket == 5){
      this.displayClientSelectedBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket5) + ' to ' + Utils.formatToCurrency(this.responseMMTBracket.Bracket6);
    } else { //6
      this.displayClientSelectedBracketText = Utils.formatToCurrency(this.responseMMTBracket.Bracket6) + ' or more';
    }
  }

  setClientBracket(income){
    if(income >= this.responseMMTBracket.Bracket1 && income <= this.responseMMTBracket.Bracket2 - 1){
      return 1;
    } else if(income >= this.responseMMTBracket.Bracket2 && income <= this.responseMMTBracket.Bracket3 - 1){
      return 2;
    } else if(income >= this.responseMMTBracket.Bracket3 && income <= this.responseMMTBracket.Bracket4 - 1){
      return 3;
    } else if(income >= this.responseMMTBracket.Bracket4 && income <= this.responseMMTBracket.Bracket5 - 1){
      return 4;
    } else if(income >= this.responseMMTBracket.Bracket5 && income <= this.responseMMTBracket.Bracket6 - 1){
      return 5;
    } else {
      return 6;
    }
  }

  coverageAdjustment(val, isClient){
    console.log('coverage change', val);
    // this.isMedicareCoverageChange = true; // need after NW release
    //this.medicareTitle = this.allHealthcarePremiumTypes.find((element) => element.value == val).name;
    if(val == "TM"){
      if(isClient){        
        this.profileInfo.controls['MedicareAdvantageHMO'].enable();
        this.profileInfo.controls['MedicareAdvantagePPO'].enable(); 

        if(this.profileInfo.value.MedicareAdvantageHMO || this.profileInfo.value.MedicareAdvantagePPO){
          this.profileInfo.controls['MedicarePartB'].setValue(true);
          this.profileInfo.controls['MedicarePartD'].setValue(true);
        } else if(!this.profileInfo.value.MedicarePartB){
          this.profileInfo.controls['SupplimentalInsurance'].setValue(false);
          this.profileInfo.controls['SupplimentalInsurance'].disable();
          if(!this.profileInfo.value.MedicarePartD && !this.profileInfo.value.DentalInsurance){
            this.profileInfo.controls['MedicarePartD'].setValue(1);
            this.profileInfo.controls['MedicarePartD'].enable();     
          }
        }
        
        this.profileInfo.controls['MedicareAdvantageHMO'].setValue(false);
        this.profileInfo.controls['MedicareAdvantagePPO'].setValue(false);  
                
      } else {
        this.spouseProfileInfo.controls['MedicareAdvantageHMO'].enable();
        this.spouseProfileInfo.controls['MedicareAdvantagePPO'].enable();
        if(this.spouseProfileInfo.value.MedicareAdvantageHMO || this.spouseProfileInfo.value.MedicareAdvantagePPO){
          this.spouseProfileInfo.controls['MedicarePartB'].setValue(true);
          this.spouseProfileInfo.controls['MedicarePartD'].setValue(true);
        } else if(!this.spouseProfileInfo.value.MedicarePartB){
          this.spouseProfileInfo.controls['SupplimentalInsurance'].setValue(false);
          this.spouseProfileInfo.controls['SupplimentalInsurance'].disable();
          if(!this.spouseProfileInfo.value.MedicarePartD && !this.spouseProfileInfo.value.DentalInsurance){
            this.spouseProfileInfo.controls['MedicarePartD'].setValue(1);
            this.spouseProfileInfo.controls['MedicarePartD'].enable();     
          }
        }

        this.spouseProfileInfo.controls['MedicareAdvantageHMO'].setValue(false);
        this.spouseProfileInfo.controls['MedicareAdvantagePPO'].setValue(false);
      }
    } else if (val == "HMO") {
      if(isClient){
        this.profileInfo.controls['MedicarePartD'].setValue(false);
        this.profileInfo.controls['MedicarePartB'].setValue(false);
        this.profileInfo.controls['SupplimentalInsurance'].setValue(false)
        
        this.profileInfo.controls['MedicareAdvantagePPO'].setValue(false);
        this.profileInfo.controls['MedicareAdvantageHMO'].setValue(true);
        this.profileInfo.controls['MedicareAdvantageHMO'].disable();
        this.profileInfo.controls['MedicareAdvantagePPO'].enable();

      } else {
        this.spouseProfileInfo.controls['MedicarePartD'].setValue(false);
        this.spouseProfileInfo.controls['MedicarePartB'].setValue(false);
        this.spouseProfileInfo.controls['SupplimentalInsurance'].setValue(false);

        this.spouseProfileInfo.controls['MedicareAdvantagePPO'].setValue(false);
        this.spouseProfileInfo.controls['MedicareAdvantageHMO'].setValue(true);
        this.spouseProfileInfo.controls['MedicareAdvantageHMO'].disable();
        this.spouseProfileInfo.controls['MedicareAdvantagePPO'].enable();
        // this.spouseProfileInfo.controls['MedicareAdvantageHMO'].disable();
      }
    } else { //PPO
      if(isClient){
        this.profileInfo.controls['MedicarePartD'].setValue(false);
        this.profileInfo.controls['MedicarePartB'].setValue(false);
        this.profileInfo.controls['SupplimentalInsurance'].setValue(false);

        this.profileInfo.controls['MedicareAdvantageHMO'].setValue(false);
        this.profileInfo.controls['MedicareAdvantagePPO'].setValue(true);
        this.profileInfo.controls['MedicareAdvantageHMO'].enable();
        this.profileInfo.controls['MedicareAdvantagePPO'].disable();
        

        // this.profileInfo.controls['MedicareAdvantagePPO'].disable();
      } else {
        this.spouseProfileInfo.controls['MedicarePartD'].setValue(false);
        this.spouseProfileInfo.controls['MedicarePartB'].setValue(false);
        this.spouseProfileInfo.controls['SupplimentalInsurance'].setValue(false);

        this.spouseProfileInfo.controls['MedicareAdvantageHMO'].setValue(false);
        this.spouseProfileInfo.controls['MedicareAdvantagePPO'].setValue(true);
        this.spouseProfileInfo.controls['MedicareAdvantageHMO'].enable();
        this.spouseProfileInfo.controls['MedicareAdvantagePPO'].disable();
        // this.spouseProfileInfo.controls['MedicareAdvantagePPO'].disable();
      }
    }
    console.log('this.profileInfo.value.MedicareAdvantageHMO',  this.profileInfo.value.MedicareAdvantageHMO);

    //if apply to spouse is toggled on
    if(isClient && this.includeSpouse && this.profileInfo.value.IsSpouseSameHCSelection){
      this.profileInfo.controls['MedicareAdvantageHMO'].enable();
      this.profileInfo.controls['MedicareAdvantagePPO'].enable();
      this.spouseProfileInfo.controls['MedicareAdvantageHMO'].enable();
      this.spouseProfileInfo.controls['MedicareAdvantagePPO'].enable();

      this.spouseProfileInfo.controls['MedicarePartB'].setValue(this.profileInfo.value.MedicarePartB);
      this.spouseProfileInfo.controls['MedicarePartD'].setValue(this.profileInfo.value.MedicarePartD);
      this.spouseProfileInfo.controls['SupplimentalInsurance'].setValue(this.profileInfo.value.SupplimentalInsurance);

      this.spouseProfileInfo.controls['HealthCarePremiumType'].setValue(this.profileInfo.value.HealthCarePremiumType);

      this.spouseProfileInfo.controls['MedicareAdvantageHMO'].setValue(this.profileInfo.value.MedicareAdvantageHMO);
      this.spouseProfileInfo.controls['MedicareAdvantagePPO'].setValue(this.profileInfo.value.MedicareAdvantagePPO);

      this.spouseProfileInfo.controls['MedicareAdvantageHMO'].disable();
      this.spouseProfileInfo.controls['MedicareAdvantagePPO'].disable();
      this.profileInfo.controls['MedicareAdvantageHMO'].disable();
      this.profileInfo.controls['MedicareAdvantagePPO'].disable();
    }
  }

  responseSS;
  //responseSSAlt;
  getSSData(isAlt) {
    const socialSecurityObject = this.getSocialSecurityObjectV2(isAlt);  
    /* if (socialSecurityObject.MaritalState == 'Divorced') { 
      socialSecurityObject.SpouseBenefitAge = 62;
      socialSecurityObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears : 62;
      socialSecurityObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths : 0;
      
    } else if (socialSecurityObject.MaritalState == 'Widowed') {      
      socialSecurityObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears : 62;
      socialSecurityObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths : 0;
      
    }  */
    console.log('Quick SS obj', socialSecurityObject);
    const userForm = {
      ClientID: this.client.client.ID,
      UserID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID
    }  
    this.globalService.getSSData(socialSecurityObject, userForm)
      .subscribe(
        data => {
          this.responseSS = data;

          console.log('SS', this.responseSS);

          //HACK: added to SS because we use this.hcDataV2 for all the other scenarios/illustrations and need it
          this.hcDataV2 = {};
          var currentYear = new Date().getFullYear();
          this.hcDataV2.RetirementYear = Math.max(currentYear, this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB));
          
          const earliestAges = { client: this.responseSS.earlStartBenLabel.replace(' month', ' mo').replace(' months', ' mos').split('/')[0], partner: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.responseSS.earlStartBenLabel.replace(' month', ' mo').replace(' months', ' mos').split('/')[1] : ''};
          const chosenAges = { client: this.responseSS.cusStartBenLabel.replace(' month', ' mo').replace(' months', ' mos').split('/')[0], partner: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.responseSS.cusStartBenLabel.replace(' month', ' mo').replace(' months', ' mos').split('/')[1] : ''};
          const optimalAges = { client: this.responseSS.opStartBenLabel.replace(' month', ' mo').replace(' months', ' mos').split('/')[0], partner: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.responseSS.opStartBenLabel.replace(' month', ' mo').replace(' months', ' mos').split('/')[1] : ''};
          console.log('chosen ages', chosenAges);
          console.log('cusStartBenLabel', this.responseSS.cusStartBenLabel);

          const earliestTotals = { client: this.responseSS.earlSelfBenefit, partner: this.responseSS.earlSpouseBenefit, netOfMedicare: this.responseSS.earlNetOfB, netOfMedicarePercent: this.responseSS.earlPartBPercent }
          const chosenTotals = { client: this.responseSS.cusSelfBenefit, partner: this.responseSS.cusSpouseBenefit, netOfMedicare: this.responseSS.cusNetOfB, netOfMedicarePercent: this.responseSS.cusPartBPercent }
          const optimalTotals = { client: this.responseSS.opSelfBenefit, partner: this.responseSS.opSpouseBenefit, netOfMedicare: this.responseSS.optNetOfB, netOfMedicarePercent: this.responseSS.optPartBPercent }
       
          //Need to set for displayed table
          if(isAlt){    
            //this.ssDataAlt = []; //reset the array        
            //this.ssDataAlt.push({Strategy: 'Earliest', ClaimAge: (earliestAges.partner == '') ? earliestAges.client : earliestAges.client + ' & ' + earliestAges.partner, TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(earliestTotals.client) + Utils.formatToNumber(earliestTotals.partner)), MedicareDeduction: this.responseSS.earlPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.earlTotalBenefit, this.responseSS.earlPartB)});
            //this.ssDataAlt.push({Strategy: 'Alternate', ClaimAge: (chosenAges.partner == '') ? chosenAges.client : chosenAges.client.replace('/', '&'), TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) + Utils.formatToNumber(chosenTotals.partner)), MedicareDeduction: this.responseSS.cusPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.cusTotalBenefit, this.responseSS.cusPartB)});
            //this.ssDataAlt.push({Strategy: 'Optimal', ClaimAge: (optimalAges.partner == '') ? optimalAges.client : optimalAges.client + ' & ' + optimalAges.partner, TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(optimalTotals.client) + Utils.formatToNumber(optimalTotals.partner)), MedicareDeduction: this.responseSS.optPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.opTotalBenefit, this.responseSS.optPartB)});
            if(this.ssDataAlt.length > 3){
              this.ssDataAlt.pop();
            } else {
              this.ssDataAlt = this.ssData;
            }
            this.ssDataAlt.push({Strategy: 'Alternate', ClaimAge: (chosenAges.partner == '') ? chosenAges.client : chosenAges.client + ' & ' + chosenAges.partner, 
              TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) 
                + ((this.client.clientProfile.Spouses[0].maritalStatus != 'Divorced') ? Utils.formatToNumber(chosenTotals.partner) : 0)
                + Utils.formatToNumber(this.responseSS.depChildrenSumTotal)), 
              MedicareDeduction: this.responseSS.cusPartB, 
              NetAfterMedicare: this.sumBenefit(this.responseSS.cusTotalBenefit, this.responseSS.cusPartB)});

          } else {
            this.ssData.push({Strategy: 'Earliest', ClaimAge: (earliestAges.partner == '') ? earliestAges.client : earliestAges.client + ' & ' + earliestAges.partner, 
              TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(earliestTotals.client) 
                + ((this.client.clientProfile.Spouses[0].maritalStatus != 'Divorced') ? Utils.formatToNumber(earliestTotals.partner) : 0)
                + Utils.formatToNumber(this.responseSS.depChildrenSumTotalEarliest)), 
              MedicareDeduction: this.responseSS.earlPartB, 
              NetAfterMedicare: this.sumBenefit(this.responseSS.earlTotalBenefit, this.responseSS.earlPartB)});

            this.ssData.push({Strategy: 'FRA', ClaimAge: (chosenAges.partner == '') ? chosenAges.client : chosenAges.client + ' & ' + chosenAges.partner, 
              TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) 
              + ((this.client.clientProfile.Spouses[0].maritalStatus != 'Divorced') ? Utils.formatToNumber(chosenTotals.partner) : 0)
              + Utils.formatToNumber(this.responseSS.depChildrenSumTotal)), 
              MedicareDeduction: this.responseSS.cusPartB, 
              NetAfterMedicare: this.sumBenefit(this.responseSS.cusTotalBenefit, this.responseSS.cusPartB)});

            this.ssData.push({Strategy: 'Optimal', ClaimAge: (optimalAges.partner == '') ? optimalAges.client : optimalAges.client + ' & ' + optimalAges.partner, 
              TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(optimalTotals.client) 
                + ((this.client.clientProfile.Spouses[0].maritalStatus != 'Divorced') ? Utils.formatToNumber(optimalTotals.partner) : 0)
                + Utils.formatToNumber(this.responseSS.depChildrenSumTotalOptimal)), 
              MedicareDeduction: this.responseSS.optPartB, 
              NetAfterMedicare: this.sumBenefit(this.responseSS.opTotalBenefit, this.responseSS.optPartB)});
          }

          console.log('ssData', this.ssData);

          //this.setScenarioObj((this.editingScenario == 'Alternate' || this.editingScenario == 'What If'), (this.editingScenario != 'Alternate' && this.editingScenario != 'What If'));
          this.setScenarioObj(this.hasClickedAltSaveButton, !this.hasClickedAltSaveButton);
          /* if(this.editingScenario == 'Alternate' || this.editingScenario == 'What If'){
            this.editingScenario = '';
          } */

          this.loadingService.isLoading(false);
        },
        error => {
          this.error = <any>error
        });
  }

  /* getSSDataAlt(isAlt){
    const socialSecurityObject = this.getSocialSecurityObject(isAlt);  
    const userForm = {
      ClientID: this.client.client.ID,
      UserID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID
    }  
    this.globalService.getSSData(socialSecurityObject, userForm)
      .subscribe(
        data => {
          this.responseSSAlt = data;

          console.log('SS', this.responseSS);
          
          //const earliestAges = { client: this.responseSS.earlStartBenLabel.split('/')[0], partner: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.responseSS.earlStartBenLabel.split('/')[1] : ''};
          const chosenAges = { client: this.responseSS.cusStartBenLabel.replace(' month', 'mo').replace(' months', 'mo'), partner: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.responseSS.cusStartBenLabel.replace(' month', 'mo').replace(' months', 'mo') : ''};
          //const optimalAges = { client: this.responseSS.opStartBenLabel.split('/')[0], partner: this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? this.responseSS.opStartBenLabel.split('/')[1] : ''};

          //const earliestTotals = { client: this.responseSS.earlSelfBenefit, partner: this.responseSS.earlSpouseBenefit, netOfMedicare: this.responseSS.earlNetOfB, netOfMedicarePercent: this.responseSS.earlPartBPercent }
          const chosenTotals = { client: this.responseSS.cusSelfBenefit, partner: this.responseSS.cusSpouseBenefit, netOfMedicare: this.responseSS.cusNetOfB, netOfMedicarePercent: this.responseSS.cusPartBPercent }
          //const optimalTotals = { client: this.responseSS.opSelfBenefit, partner: this.responseSS.opSpouseBenefit, netOfMedicare: this.responseSS.optNetOfB, netOfMedicarePercent: this.responseSS.optPartBPercent }
       
          //Need to set for displayed table
          if(isAlt){    
            if(this.ssDataAlt.length > 3){
              this.ssDataAlt.pop();
            }

            //this.ssDataAlt.push({Strategy: 'Earliest', ClaimAge: (earliestAges.partner == '') ? earliestAges.client : earliestAges.client + ' & ' + earliestAges.partner, TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(earliestTotals.client) + Utils.formatToNumber(earliestTotals.partner)), MedicareDeduction: this.responseSS.earlPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.earlTotalBenefit, this.responseSS.earlPartB)});
            this.ssDataAlt.push({Strategy: 'Alternate', ClaimAge: (chosenAges.partner == '') ? chosenAges.client : chosenAges.client.replace('/', '&'), TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) + Utils.formatToNumber(chosenTotals.partner)), MedicareDeduction: this.responseSS.cusPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.cusTotalBenefit, this.responseSS.cusPartB)});
            //this.ssDataAlt.push({Strategy: 'Optimal', ClaimAge: (optimalAges.partner == '') ? optimalAges.client : optimalAges.client + ' & ' + optimalAges.partner, TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(optimalTotals.client) + Utils.formatToNumber(optimalTotals.partner)), MedicareDeduction: this.responseSS.optPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.opTotalBenefit, this.responseSS.optPartB)});
         
          } else {
            //this.ssData.push({Strategy: 'Earliest', ClaimAge: (earliestAges.partner == '') ? earliestAges.client : earliestAges.client + ' & ' + earliestAges.partner, TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(earliestTotals.client) + Utils.formatToNumber(earliestTotals.partner)), MedicareDeduction: this.responseSS.earlPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.earlTotalBenefit, this.responseSS.earlPartB)});
            this.ssData.push({Strategy: 'Alternate', ClaimAge: (chosenAges.partner == '') ? chosenAges.client : chosenAges.client.replace('/', '&'), TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) + Utils.formatToNumber(chosenTotals.partner)), MedicareDeduction: this.responseSS.cusPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.cusTotalBenefit, this.responseSS.cusPartB)});
            //this.ssData.push({Strategy: 'Optimal', ClaimAge: (optimalAges.partner == '') ? optimalAges.client : optimalAges.client + ' & ' + optimalAges.partner, TotalBenefit: Utils.formatToCurrency(Utils.formatToNumber(optimalTotals.client) + Utils.formatToNumber(optimalTotals.partner)), MedicareDeduction: this.responseSS.optPartB, NetAfterMedicare: this.sumBenefit(this.responseSS.opTotalBenefit, this.responseSS.optPartB)});
          }

          this.setScenarioObj((this.editingScenario == 'Alternate') ? true : false, (this.editingScenario == 'Alternate') ? false : true);
          if(this.editingScenario == 'Alternate'){
            this.editingScenario = '';
          }

          this.loadingService.isLoading(false);
        },
        error => {
          this.error = <any>error
        });
  } */

  sumBenefit(benefitTotal, medicareDeduction) {
    if (benefitTotal && medicareDeduction) {
      return '$' + (benefitTotal.replace(/[^0-9\.-]+/g,"") - medicareDeduction.replace(/[^0-9\.-]+/g,"")).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    }
  }

  /* getBirthdayMonth(date = null) {
    var d = new Date(date);
    if(d.getDay() == 1){
      return d.getMonth() -1;
    }

    return (d.getMonth() + 1);
  } */

  getBirthdayMonth(date = null) {
    var d = new Date(date);
    return (d.getMonth() + 1);
  }

  genderConvert(genderID){
    return (genderID == 1) ? 'Female' : 'Male';
  }

  maritalStatusConvert(maritalStatus){
    return (maritalStatus == 1) ? 'Single' : 'Married'; //Divorced | Widowed
  }

  healthConditionConvert(clientProfile){
    var result = "";
    if(clientProfile.HCHBP > 0){
      result += "High Blood Pressure"
    }

    if(clientProfile.HCHC > 0){
      result += ((result == "") ? "" : ", ") + "High Cholesterol"
    }

    if(clientProfile.HCT2D > 0){
      result += ((result == "") ? "" : ", ") + "Type 2 Diabetes"
    }

    if(clientProfile.HCCD > 0){
      result += ((result == "") ? "" : ", ") + "Cardiovascular Disease"
    }

    if(clientProfile.HCC > 0){
      result += ((result == "") ? "" : ", ") + "Cancer"
    }

    if(clientProfile.HCT > 0){
      result += ((result == "") ? "" : ", ") + "Tobacco"
    }
    
    return ((result == "") ? "No Conditions" : result);
  }

  // TODO: Make utility file
  /* calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } */

  calculateAge(birthday) {
   /*  var bday = new Date(birthday);
    var today = new Date();
    return today.getFullYear() - bday.getFullYear(); */
    if(this.displaySS){
      birthday = new Date(birthday);
      let currentDate = new Date();
      let currentAgeOffset = (currentDate.getMonth() < birthday.getMonth()) ? 1 : 0;
      // console.log('currentAgeOffset', currentAgeOffset);
      let currentAge = (currentDate.getFullYear() - birthday.getFullYear()) - currentAgeOffset;
      return currentAge;

    } else {
      
      var bday = new Date(birthday);
      var today = new Date();
      return today.getFullYear() - bday.getFullYear();
    }
    
    /* birthday = new Date(birthday);
    let currentDate = new Date();
    let currentAgeOffset = (currentDate.getMonth() < birthday.getMonth()) ? 1 : 0;
    // console.log('currentAgeOffset', currentAgeOffset);
    let currentAge = (currentDate.getFullYear() - birthday.getFullYear()) - currentAgeOffset;
    return currentAge; */
  }

  getNumber(val) {
    val = val ? val.toString() : '';
    val = val.replace('$', '').replace(',', '');
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? numbers : 0
  }

  advisor;
  selectedAdvisor;
  hasClickedAltSaveButton = false;
  saveClientV2(client, directToReports) {
    this.loadingService.isLoading(true);
    this.hasClickedAltSaveButton = true;
    this.isRetirementAgePanelOpen = false;

    if(!this.copyOfClientProfile){
      this.copyOfClientProfile = { ...this.client.clientProfile };
      if(!this.copyOfSpouseProfile){
        this.copyOfSpouseProfile = { ...this.copyOfClientProfile.Spouses[0] };
      }
    }
    console.log('this.client.clientProfile', this.client.clientProfile)
    if (this.displaySS){
      //need to recalc SS
      this.getSSData(true);      
    } else {
      //TODO: We need to map changes from the edit mode form to the local version of the client profile (just on this page)
      //then pass that object to the getHCData function
        //ex: this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
      this.client.clientProfile.LifeExpectancy = this.clientModelV2.healthInformation.lifeExpectancy;
      this.client.clientProfile.RetirementState = this.retirementAreaForm.value.clientRetirementState;//this.clientModelV2.generalInformation.retirementState;
      this.client.clientProfile.ClientMetroArea = (this.displayHC && !this.displayLTC) ? this.client.clientProfile.ClientMetroArea : this.retirementAreaForm.value.clientMetroRegion;
      this.client.clientProfile.RetirementAge = this.clientModelV2.generalInformation.retirementAge;
      if(this.clientModelV2.maritalStatus.maritalStatus === 'Married'){
        this.client.clientProfile.Spouses[0].LifeExpectancy = this.clientModelV2.maritalStatus.lifeExpectancy
        this.client.clientProfile.Spouses[0].state = this.retirementAreaForm.value.spouseRetirementState;//this.clientModelV2.maritalStatus.retirementState;
        this.client.clientProfile.SpouseMetroArea = (this.displayHC && !this.displayLTC) ? this.client.clientProfile.SpouseMetroArea : this.retirementAreaForm.value.spouseMetroRegion;
        this.client.clientProfile.Spouses[0].retirementAge = this.clientModelV2.maritalStatus.retirementAge;
      }

      if(!this.displayMMT){
        if (this.responseMMTBracket && this.incomeRangeSelectionForm.value.IncomeOption == 1) {
          this.client.clientProfile.Bracket = this.selectedIRMAABracket;
          this.client.clientProfile.HouseholdYearOneIncome = null;
          this.client.clientProfile.CurrentIncome = null;
        } else if (this.incomeRangeSelectionForm.value.IncomeOption == 2) {
          this.client.clientProfile.CurrentIncome = Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue);
         /*  if(this.includeSpouse){
            this.client.clientProfile.CurrentIncome = Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) / 2;
            this.client.clientProfile.Spouses[0].currentIncome = Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) / 2;
          } */
          this.client.clientProfile.InflationRate = Utils.removePercentageFormatting(this.incomeRangeSelectionForm.value.IncomeInflationRate);
          this.client.clientProfile.IRR = Utils.removePercentageFormatting(this.incomeRangeSelectionForm.value.IncomeReplacementRatio);
          this.client.clientProfile.HouseholdYearOneIncome = null;

        } else if (this.incomeRangeSelectionForm.value.IncomeOption == 3) {
          this.client.clientProfile.CurrentIncome = null;
          this.client.clientProfile.HouseholdYearOneIncome = Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue);
        }
      }

      //TODO: Need to get MMT results without updating client profile
        //changing the IRMAA slider or brackets for client/spouse

      if (this.displayHC)
        this.getHCData(this.client, this.partnerActive);
      if (this.displayLTC)
        this.getLTCData(this.client);
      if(this.displayMMT)
        this.getMMTData();
    }
   }

  advisors;
  isSelectingAdvisor = true;
  selectedAdvisors;
  selectedOrganization;
  organizations;
  getAdvisor(){
    this.globalService.getAdvisorData(Number(localStorage.getItem('userId')))
    .subscribe(
      advisor => {
        this.advisor = advisor;
        if (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) {
          this.globalService.getOrganizationsData()
            .subscribe(
              organizations => {
                var temp = [];

                organizations.forEach((org) => {
                  if (org.Name.length > 0) {
                    org.Name = org.Name.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
                    temp.push(org);
                  }
                });

                temp = temp.sort((a, b) => {
                  if (a.Name.toLowerCase() < b.Name.toLowerCase()) return -1;
                  if (a.Name.toLowerCase() > b.Name.toLowerCase()) return 1;
                  return 0;
                });

                this.organizations = temp;
              },
              error => this.error = <any>error);

          this.globalService.getAdvisorsData(1)
            .subscribe(
              advisors => {
                this.advisors = advisors;
                if (this.isSelectingAdvisor) {
                  this.selectedOrganization = advisor.OrganizationID;
                  this.handleOrgSelected(true);
                }
              },
              error => this.error = <any>error);
        }
      },
      error => this.error = <any>error);
  }

  handleOrgSelected(auto) {
    this.selectedAdvisors = [];
    var temp = [];

    temp = this.advisors.sort((a, b) => {
      if (a.c.FirstName.toLowerCase() < b.c.FirstName.toLowerCase()) return -1;
      if (a.c.FirstName.toLowerCase() > b.c.FirstName.toLowerCase()) return 1;
      return 0;
    });

    temp.forEach((advisor) => {
      if (advisor.o.ID == this.selectedOrganization) {
        if (advisor.c.FirstName.length > 0 && advisor.c.LastName.length > 0) {
          if (advisor.c.IsActive) {
            this.selectedAdvisors.push(advisor);
          }
        }
      }
    });

    if (auto) {
      this.selectedAdvisor = this.advisor.ID;
    } else {
      this.selectedAdvisor = 0;
    }
  }

  getAgeYearAtClaimYear(birthday, claimYear, claimMonth) {
    console.log('birthday', birthday);
    console.log('claimYear', claimYear);
    var dob = new Date(birthday);
    // const startYear = new Date(claimYear);
    // var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('startYear.getFullYear()', claimYear)
    console.log('dob.getFullYear()', dob.getFullYear())
    var ageDiffs = claimYear - dob.getFullYear();
    console.log('ageDiffs', ageDiffs);
    ageDiffs = dob.getMonth() + 1 > claimMonth ? ageDiffs - 1: ageDiffs;
    return ageDiffs;
    // console.log('age',Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (claimMonth + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset)));
    // return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (claimMonth + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  getAgeMonthAtClaimMonth(birthday,claimMonth) {
    var dob = new Date(birthday);
    console.log('dobFull', dob);
    var dobMonth = dob.getMonth() + 1;
    console.log('dobMonth', dobMonth)
    console.log('claimMonth', claimMonth)
    console.log('claimMonth - dobMonth', claimMonth - dobMonth)
    var months = dobMonth > claimMonth ? (12 - dobMonth) + Number(claimMonth) : (claimMonth - dobMonth);
    console.log('months', months)
    return months
  }
  
  public backUpClient: any = {};
  currentAgeOffset;
  isSpouseSurvivor;
  adjSurvivorModal;
  adjSurvivorBenefitAge;
  adjSurvivorBenefitMonths;
  adjRetirementBenefitAge;
  adjRetirementBenefitMonths;
  ssClientAge;
  ssSpouseAge;
  getClient() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
        client => {
          this.client = client;
          this.clientModelV2.spouses = JSON.parse(client.clientProfile.Spouses);

          if (!this.client.clientProfile.SSDesiredAgeYears) {
            this.ssClientAge = this.client.clientProfile.RetirementAge < 62 ? 62
            : this.client.clientProfile.RetirementAge >= 63 && this.client.clientProfile.RetirementAge <= 69 ? this.client.clientProfile.RetirementAge
                : 70
          } else {
              this.ssClientAge = this.client.clientProfile.SSDesiredAgeYears;
          }

          if (this.clientModelV2.spouses) {
            //this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
            
            if (this.clientModelV2.spouses[0].maritalStatus == 'Married' && !this.clientModelV2.spouses[0].sSDesiredAgeYears) {
                this.ssSpouseAge = this.clientModelV2.spouses[0].retirementAge < 62 ? 62
                    : this.clientModelV2.spouses[0].retirementAge >= 63 && this.clientModelV2.spouses[0].retirementAge <= 69 ? this.clientModelV2.spouses[0].retirementAge
                        : 70
            } else if (this.clientModelV2.spouses[0].maritalStatus == 'Married') {
                this.ssSpouseAge = this.clientModelV2.spouses[0].sSDesiredAgeYears;
                if (!this.client.clientProfile.SSDesiredAgeYears) {
                    this.ssClientAge = this.ssSpouseAge;
                    this.client.clientProfile.SSDesiredAgeYears = this.ssSpouseAge;
                }
            }
        }

          if (this.client.clientProfile.LifeExpectancy < this.client.clientProfile.RetirementAge || this.client.clientProfile.LifeExpectancy < 65 && !this.client.clientProfile.IsPrivHealthIns) {
            const dialogRef = this.dialog.open(ProfileNotEligibleComponent, {
              width: '600px',
              height: '250px',
              disableClose: true
            });  
          }
          
          this.mapToClientObject(client);
            this.isPre65 = (Number(this.client.clientProfile.RetirementAge || 0) >= 65) ? false 
            : (Number(this.globalService.calculateAge(this.client.client.DOB)) >= 65) ? false 
            : true;
          console.log('this.isPre65', this.isPre65);

          this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);

          this.clientSpouseFullName = client.clientProfile && client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Married' ?
          (client.client.LastName == client.clientProfile.Spouses[0].lastName) ? 
                client.client.FirstName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.client.LastName :
                client.client.FirstName + ' ' + client.client.LastName + ' and ' + client.clientProfile.Spouses[0].firstName + ' ' + client.clientProfile.Spouses[0].lastName
                : client.client.FirstName + ' ' + client.client.LastName;

          if (client.clientProfile.Spouses[0] && client.clientProfile.Spouses[0].maritalStatus == 'Single') {
            if(client.clientProfile.Spouses[1] && client.clientProfile.Spouses[1].maritalStatus != 'Widowed'){
              if(client.clientProfile.Spouses[1].alive && client.clientProfile.Spouses[1].tenyears){
                //console.log('spouse IS alive | HAS BEEN together 10rys')
                this.includeSpouse = true;
              } else {
                //console.log('spouse IS NOT alive | NOT together 10rys')
                if(!client.clientProfile.Spouses[1].alive && client.clientProfile.Spouses[1].tenyears){
                  //(041623) this is for Divorced to Widowed cases
                  this.includeSpouse = true;
                } else {
                  this.includeSpouse = false;
                }
              }
            } else {
              this.includeSpouse = false;
            }
          } else {
            //ZSS added cause of the Survivor Switch Widow issues we were seeing
            /* if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus != 'Widowed') {
              this.includeSpouse = true;
            } else {
              this.includeSpouse = false;
            } */
            console.log('says im not single in here');
            this.includeSpouse = true;
          }

          this.selectedIRMAABracket = client.clientProfile.Bracket;
          //this.selectedIRMAABracketDisplay = this.bracketChange(this.selectedIRMAABracket);

          let previousSpouseWidowSpouse;
          
          for (let spousesSpouse in this.client.clientProfile.Spouses) {
            for (let previousSpouse in this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse) {
              if (this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse].maritalStatus == 'Widowed')
                previousSpouseWidowSpouse = this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse];
            }
          }

          this.previousSpouse = previousSpouseWidowSpouse || { pia: "$0"};

          if (this.client.clientProfile.Spouses.length > 1) {
            this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
          }

          if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
            this.partnerActive = true;
            var spouseAge = Number(this.globalService.calculateAge(client.clientProfile.Spouses[0].dob));
            var spouseRetirementAge = Number(client.clientProfile.Spouses[0].retirementAge || 0)
            // this.isSpousePre65 = (( spouseRetirementAge >= 65 || spouseAge >= 65)
            //   ? false : true);
            
            //this.isSpousePre65 = ((spouseRetirementAge >= 65 || spouseAge >= 65 || !this.client.clientProfile.IsSpousePrivHealthIns) ? false: true);
            this.isSpousePre65 = ((spouseRetirementAge >= 65 || spouseAge >= 65) ? false : true);

          } else {
            this.partnerActive = false;
            this.isSpousePre65 = false
          }

          this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);

          //TODO: uncomment the below for prod
          if(this.displayMMT || this.displayHC){
            //IF percent is set - need to set the slider on load
            this.valueMAGISlider = (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome;//100;

            //IF brackets are set - need to set here
            if(this.client.clientProfile.Bracket){
              this.incomeRangeSelectionForm.controls['IncomeOption'].setValue(1);
              this.incomeRangeSelectionForm.controls['BracketValue'].setValue(this.client.clientProfile.Bracket.toString());
            } else {
              //If no bracket is set to the client profile, lets find the bracket for them
              //this.incomeRangeSelectionForm.controls['BracketValue'].setValue(this.setClientBracket(this.client.clientProfile.CurrentIncome).toString());
              if(this.client.clientProfile.HouseholdYearOneIncome){
                this.incomeRangeSelectionForm.controls['IncomeOption'].setValue(3);                
                this.incomeRangeSelectionForm.controls['IncomeValue'].setValue(Utils.formatToCurrency(this.client.clientProfile.HouseholdYearOneIncome));

                if(this.client.clientProfile.IRR){
                  this.incomeRangeSelectionForm.controls['IncomeReplacementRatio'].setValue(Utils.formatToPercentage(this.client.clientProfile.IRR));
                }

                if(this.client.clientProfile.InflationRate){
                  this.incomeRangeSelectionForm.controls['IncomeInflationRate'].setValue(Utils.formatToPercentage(this.client.clientProfile.InflationRate));
                }
              } else {
                this.incomeRangeSelectionForm.controls['IncomeOption'].setValue(2);
                let currentIncome = (Number(this.client.clientProfile.CurrentIncome) + Number(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (this.client.clientProfile.Spouses[0].currentIncome || 0) : 0));
                this.incomeRangeSelectionForm.controls['IncomeValue'].setValue(Utils.formatToCurrency(parseInt(Math.round(currentIncome).toString())));

                if (this.client.clientProfile.IRR) {
                  if(this.displayHC){
                    this.incomeRangeSelectionForm.controls['IncomeReplacementRatio'].setValue(Utils.formatToPercentage(this.client.clientProfile.IRR));
                  }
                }

                if (this.client.clientProfile.InflationRate) {
                  if(this.displayHC){
                    this.incomeRangeSelectionForm.controls['IncomeInflationRate'].setValue(Utils.formatToPercentage(this.client.clientProfile.InflationRate));
                  }
                }
              }
            }
          } else if (this.displaySS && this.partnerActive){
            //TODO: do we prepopulate form with claim age?
            this.socialSecurityRetirementAgeForm = new FormGroup({
              clientClaimAge: new FormControl(),
              clientClaimMonths: new FormControl(),
              spouseClaimAge: new FormControl(),
              spouseClaimMonths: new FormControl()
            });
          }
          
          this.retirementAreaForm.controls['clientRetirementState'].setValue(client.clientProfile.RetirementState);
          if(this.partnerActive){
            this.retirementAreaForm.controls['spouseRetirementState'].setValue(this.clientModelV2.spouses[0].state);
          }

          if(this.displayLTC){
            if(this.retirementAreaForm.value.clientRetirementState != "NA"){
              this.retirementAreaForm.controls['clientMetroRegion'].setValue(client.clientProfile.ClientMetroArea);
              this.getLTCStateRegions(client.clientProfile.RetirementState, true);
            }

            if(this.partnerActive){
              //this.retirementAreaForm.controls['spouseRetirementState'].setValue(this.clientModelV2.spouses[0].state);
              if(this.retirementAreaForm.value.spouseRetirementState != "NA"){
                this.retirementAreaForm.controls['spouseMetroRegion'].setValue(client.clientProfile.SpouseMetroArea);
                this.getLTCStateRegions(client.clientProfile.Spouses[0].state, false);
              }
            }
          }

          this.client.clientProfile.Premiums = JSON.parse(this.client.clientProfile.Premiums);
          this.client.clientProfile.OOPCosts = JSON.parse(this.client.clientProfile.OOPCosts);
          
          //let privateHealthInsurance = this.client.clientProfile.CoverageType ? this.client.clientProfile.IsPrivHealthIns: (this.isPre65 ? 'true':this.client.clientProfile.IsPrivHealthIns);
          let privateHealthInsurance = this.client.clientProfile.IsPrivHealthIns;
          let preRetirementCoverageType = this.client.clientProfile.CoverageType;
          // let preRetirementCoverageType = this.client.clientProfile.CoverageType ? this.client.clientProfile.CoverageType : (this.isPre65 && this.client.clientProfile.IsPrivHealthIns ? 'HMO':this.client.clientProfile.CoverageType);
          console.log('preRetirementCoverageType', preRetirementCoverageType)
          console.log('privateHealthInsurance', privateHealthInsurance)
          this.profileInfo = new FormGroup({
            privateHealthInsurance: new FormControl(privateHealthInsurance),
            preRetirementCoverageType: new FormControl(preRetirementCoverageType),
            inRetirementCoverageType: new FormControl(this.client.clientProfile.PremiumType),
            HealthCarePremiumType: new FormControl((this.client.clientProfile.PremiumType) ? this.client.clientProfile.PremiumType : ""),
            //Traditional Medicare (TM)

            MedicarePartB: new FormControl((this.client.clientProfile.PremiumType == "TM") ? this.client.clientProfile.Premiums.MedicarePartB : false),
            MedicarePartD: new FormControl((this.client.clientProfile.PremiumType == "TM" ) ? this.client.clientProfile.Premiums.MedicarePartD : false),
            SupplimentalInsurance: new FormControl((this.client.clientProfile.PremiumType == "TM") ? this.client.clientProfile.Premiums.SupplimentalInsurance : false),
            supplementalPlanType: new FormControl(this.client.clientProfile.SelfSupplementalPlan),

            //Medicare Adv HMO
            MedicareAdvantageHMO: new FormControl((this.client.clientProfile.PremiumType == "HMO") ? this.client.clientProfile.Premiums.MedicareAdvantageHMO : false),

            //Medicare Adv PPO
            MedicareAdvantagePPO: new FormControl((this.client.clientProfile.PremiumType == "PPO") ? this.client.clientProfile.Premiums.MedicareAdvantagePPO : false),
            

            //always avail
            DentalInsurance: new FormControl((this.client.clientProfile.PremiumType) ? this.client.clientProfile.Premiums.DentalInsurance : false),
            HospitalAndTest: new FormControl((this.client.clientProfile.PremiumType) ? this.client.clientProfile.OOPCosts.HospitalAndTest : false),
            PrescriptionDrugs: new FormControl((this.client.clientProfile.PremiumType) ? this.client.clientProfile.OOPCosts.PrescriptionDrugs : false),  
            HearingAndVisionCosts: new FormControl((this.client.clientProfile.PremiumType) ? this.client.clientProfile.OOPCosts.HearingAndVisionCosts : false),    
            DentalCosts: new FormControl((this.client.clientProfile.PremiumType) ? this.client.clientProfile.OOPCosts.DentalCosts : false), 
            //TODO: need to save this new value
            //if runReportWithSpouse is set to TRUE, ignore form spouseProfileInfo
            IsSpouseSameHCSelection: new FormControl(this.client.clientProfile.IsHSApplySpouse),
            maritalStatus: new FormControl()
          });

          if(this.profileInfo.value.MedicareAdvantageHMO){
            this.profileInfo.controls['MedicareAdvantageHMO'].disable();
          } else if(this.profileInfo.value.MedicareAdvantagePPO){
            this.profileInfo.controls['MedicareAdvantagePPO'].disable();
          }

          console.log('this.profileInfo', this.profileInfo.value.medicarePartB);

          if(this.displayHC){
            //this.profileInfo.controls['HealthCarePremiumType'].setValue ((this.client.clientProfile.PremiumType) ? this.client.clientProfile.PremiumType : "");
            this.medicareTitle = this.allHealthcarePremiumTypes.find((element) => element.value == this.profileInfo.value.HealthCarePremiumType).displayName;
            //this.changeSelection(this.isShowSpouse);            
          }
          
          if(this.displaySS){

                      this.client = cloneDeep(client);
                      this.backUpClient = cloneDeep(client);
                      //this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
                      //this.backUpClient.clientProfile.Spouses = JSON.parse(this.backUpClient.clientProfile.Spouses);
                      //this.clientFullName = this.backUpClient.client.FirstName + " " + this.backUpClient.client.LastName;
            
                      const fullDOB = new Date(this.client.client.DOB.toString());
            
                      if (this.backUpClient.clientProfile.Spouses[0].maritalStatus == 'Married') {
                        const spouseFullDOB = new Date(this.client.clientProfile.Spouses[0].dob.toString());
                        // ZSS need to review: uncomment !this.backUpClient.clientProfile.SSDesiredAgeYears && this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears
                        // PR: https://hvsfin.visualstudio.com/HVSPortal-v2/_git/HVSPortal-v2/pullrequest/1357?_a=files&path=/src/app/social-security/social-security.component.ts
                        if (this.backUpClient.clientProfile.SelfAlreadyCollecting && this.backUpClient.clientProfile.DateOfClaimYear && this.backUpClient.clientProfile.DateOfClaimMonth && !this.backUpClient.clientProfile.SSDesiredAgeYears && this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears) {
                          let clientAgeMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.client.DOB);
                          clientAgeMonths = clientAgeMonths < 0 ? 12 + clientAgeMonths : clientAgeMonths;
                          let getClaimAge = this.getAgeYearAtClaimYear(fullDOB, this.client.clientProfile.DateOfClaimYear, this.client.clientProfile.DateOfClaimMonth);
                          this.client.clientProfile.SSDesiredAgeYears = getClaimAge > this.calculateAge(this.backUpClient.client.DOB) ? getClaimAge : this.calculateAge(this.backUpClient.client.DOB);
                          this.client.clientProfile.SSDesiredAgeMonths = getClaimAge > this.calculateAge(this.backUpClient.client.DOB) ? this.getAgeMonthAtClaimMonth(fullDOB, this.client.clientProfile.DateOfClaimMonth) : clientAgeMonths;
                          this.backUpClient.clientProfile.SSDesiredAgeYears = this.client.clientProfile.SSDesiredAgeYears;
                          this.backUpClient.clientProfile.SSDesiredAgeMonths = this.client.clientProfile.SSDesiredAgeMonths;
                        }
                        // ZSS need to review: uncomment !this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears && this.backUpClient.clientProfile.SSDesiredAgeYears
                        if (this.backUpClient.clientProfile.SpouseAlreadyCollecting && this.backUpClient.clientProfile.Spouses[0].dateOfClaimYear && this.backUpClient.clientProfile.Spouses[0].dateOfClaimMonth && spouseFullDOB && !this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears && this.backUpClient.clientProfile.SSDesiredAgeYears) {
                          let spouseAgeMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.clientProfile.Spouses[0].dob);
                          spouseAgeMonths = spouseAgeMonths < 0 ? 12 + spouseAgeMonths : spouseAgeMonths;
                          let getSpouseClaimAge = this.getAgeYearAtClaimYear(spouseFullDOB, this.client.clientProfile.Spouses[0].dateOfClaimYear, this.client.clientProfile.Spouses[0].dateOfClaimMonth);
                          this.client.clientProfile.Spouses[0].sSDesiredAgeYears = getSpouseClaimAge > this.calculateAge(this.client.clientProfile.Spouses[0].dob) ? getSpouseClaimAge: this.calculateAge(this.client.clientProfile.Spouses[0].dob);
                          this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = getSpouseClaimAge > this.calculateAge(this.client.clientProfile.Spouses[0].dob) ? this.getAgeMonthAtClaimMonth(spouseFullDOB, this.client.clientProfile.Spouses[0].dateOfClaimMonth): spouseAgeMonths;
                          this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears = this.client.clientProfile.Spouses[0].sSDesiredAgeYears;
                          this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths;
                        }
                      }
            
                      console.log('this.backUpClient 02', this.backUpClient);
                      const age = this.calculateAge(new Date(this.backUpClient.client.DOB));
                      const nowDate = new Date();
                      this.currentAgeOffset = (nowDate.getMonth() < new Date(this.backUpClient.client.DOB).getMonth()) ? 1 : 0;
                      this.clientSurvivorSwitchYears = this.backUpClient.clientProfile.SurvivorSwitchYears || 0;
                      this.clientSurvivorSwitchMonths =  this.backUpClient.clientProfile.SurvivorSwitchMonths || 0;
                      // if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus != 'Married') {
                      if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus == 'Single') {
                        if(this.backUpClient.clientProfile.Spouses[1] && this.backUpClient.clientProfile.Spouses[1].maritalStatus != 'Widowed'){
                          if(this.backUpClient.clientProfile.Spouses[1].alive && this.backUpClient.clientProfile.Spouses[1].tenyears){
                            //console.log('spouse IS alive | HAS BEEN together 10rys')
                            this.includeSpouse = true;
                          } else {
                            //console.log('spouse IS NOT alive | NOT together 10rys')
                            if(!this.backUpClient.clientProfile.Spouses[1].alive && this.backUpClient.clientProfile.Spouses[1].tenyears){
                              //(041623) this is for Divorced to Widowed cases
                              this.includeSpouse = true;
                            } else {
                              this.includeSpouse = false;
                            }
                          }
                        } else {
                          this.includeSpouse = false;
                        }
                      } else {
                        //ZSS added cause of the Survivor Switch Widow issues we were seeing
                        /* if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus != 'Widowed') {
                          this.includeSpouse = true;
                        } else {
                          this.includeSpouse = false;
                        } */
                        console.log('says im not single in here');
                        this.includeSpouse = true;
                      }

                      // console.log('outside this.nonLegalMarried', this.client)
                      //QUESTION ZSS: does this need to be refigured since we removed the 'Single' status in the Spouses array? Or is this on purpose since its just looking for the second spouse?
                      console.log('here not single 01', this.client.clientProfile.Spouses.length);
                      let spouses = [];
                      spouses[0] = { PIAYears: {} };
                      spouses[0].maritalStatus = 'Single';//this.clientModelV2.maritalStatus.maritalStatus;
                      spouses[0].pia = '';
                      spouses[0].pension = '';
                      if (this.client.clientProfile.Spouses.length > 0 && this.backUpClient.clientProfile.Spouses[0].maritalStatus != "Married") {
                        //if (this.client.clientProfile.Spouses[0].maritalStatus != 'Single' || this.client.clientProfile.Spouses[1].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[1].maritalStatus == 'Widowed') {
                          console.log('here not single');
                          this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
                          this.client.clientProfile.Spouses = this.client.clientProfile.Spouses ? this.client.clientProfile.Spouses: spouses;
                          if (this.client.clientProfile.Spouses) {
                            console.log('here check')
                          }
                          console.log('this.client.clientProfile.Spouses', this.client.clientProfile.Spouses);
            
                          // if (!this.client.clientProfile.Spouses[0]) {
                          //   this.client.clientProfile.Spouses = spouses;
                          // }
            
                        //}
                        // console.log('this.client.clientProfile.Spouses 01', this.client.clientProfile.Spouses);
                      }
                      let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : null) ;
                      console.log('reset spouse array', this.client.clientProfile.Spouses);
            
                      if (this.client.clientProfile.Spouses[0]) {
                        if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
                          if (!this.client.clientProfile.Spouses[0].tenyears) {
                            this.client.clientProfile.Spouses = spouses;
                          } else {
                            if (!this.client.clientProfile.Spouses[0].alive) {
                              this.client.clientProfile.Spouses[0].maritalStatus = 'Widowed';
                            }
                          }
            
                        }
                        // if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive) {
                        //   this.client.clientProfile.Spouses[0].maritalStatus = 'Widowed';
                        //   this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
                        // } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.client.clientProfile.Spouses[0].alive && !this.client.clientProfile.Spouses[0].tenyears) {
                        //   let isSpouseSingle = false;
                        //   for (let spouses of this.client.clientProfile.Spouses) {
                        //     if (spouses.maritalStatus == 'Divorced' && spouses.alive && !spouses.tenyears) {
                        //       isSpouseSingle = true;
                        //     } else {
                        //       isSpouseSingle = false;
                        //       break;
                        //     }
                        //   }
                        //   if (isSpouseSingle) {
                        //     let spouses = [];
                        //     spouses[0] = { PIAYears: {} };
                        //     spouses[0].maritalStatus = 'Single';//this.clientModelV2.maritalStatus.maritalStatus;
                        //     spouses[0].pia = '';
                        //     spouses[0].pension = '';
                        //     this.client.clientProfile.Spouses = spouses;
                        //   }
                        //   // this.client.clientProfile.Spouses = [];
            
                        // }
                        if (this.client.clientProfile.Spouses[0].maritalStatus != 'Single' || this.client.clientProfile.Spouses[0].retirementAge) {
                          this.client.clientProfile.Spouses[0].retirementAge = parseInt(this.client.clientProfile.Spouses[0].retirementAge);
                        }
            
                        //TODO: figure out how to convert spouses from existing Prodcution clients to Redesign (this needs to be done since the user wont know to go to Client Hub to update once in the new tool)
                        if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.client.clientProfile.Spouses[0].alive && this.client.clientProfile.Spouses[0].tenyears
                          && !(this.client.clientProfile.Spouses[0].expectedClaimAgeYears)) {
                          //need to calc LE because it was never set in Prod
                          //this looks like it already exists in Prod - commenting out for now to test
                          //this.backUpClient.clientProfile.Spouses[0].LifeExpectancy = 0;
                          //this.client.clientProfile.Spouses[0].LifeExpectancy = 0;
            
                          //need to set date of birth too
                          this.client.clientProfile.Spouses[0].dob = new Date(spouseDOB);
                          this.client.clientProfile.Spouses[0].dobStr = this.client.clientProfile.Spouses[0].dob.toString();
            
                          //need to calc this spouses FRA
                          //this was never set for a spouse in Prod
                          var exSpouseFRA = this.getFRAv2(spouseDOB);
                          this.client.clientProfile.Spouses[0].expectedClaimAgeYears = exSpouseFRA.age;
                          this.client.clientProfile.Spouses[0].expectedClaimAgeMonths = exSpouseFRA.month;
            
                        } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
                          && this.client.clientProfile.Spouses[0].yearOfStatement == null){
                          //need to set year of statement for Widow
                          this.client.clientProfile.Spouses[0].yearOfStatement = this.currentYear;
                          this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing = false;
                        }
                      }
            
                      console.log('this.client.clientProfile.Spouses[0]', this.client.clientProfile.Spouses[0]);
                      if (this.client.clientProfile.Spouses.length) {
                        this.spousePIA = typeof this.client.clientProfile.Spouses[0].pia === 'string' 
                          ? this.client.clientProfile.Spouses[0].pia.replace(/,/g,"").replace("$","") 
                          : (this.client.clientProfile.Spouses[0].pia) 
                          ? this.client.clientProfile.Spouses[0].pia : 0;
                      }
                      //this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);

            this.clientPIA = (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0;
          // console.log('this.client.client.DOB', this.client.client.DOB);
          let FRA = this.getFRAv2(this.client.client.DOB);
          console.log('FRA from SS', FRA);

          this.clientRetirementYears = FRA.age;
          this.clientRetirementMonths = FRA.month;
          console.log('this.clientRetirementYears 01', this.clientRetirementYears );
          console.log('this.clientRetirementMonths 01', this.clientRetirementMonths);

          this.clientClaimStatus = this.calculateAge(this.client.client.DOB) >= 70 ? "True" : "False";

          this.clientClaimStatusDisabled = this.calculateAge(this.client.client.DOB) < 62 && !this.client.clientProfile.Spouses ||
                                           this.calculateAge(this.client.client.DOB) < 62 && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus !== 'Widowed' || 
                                           this.calculateAge(this.client.client.DOB) < 60 && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus === 'Widowed' ||
                                           this.calculateAge(this.client.client.DOB) >= 70;

          var clientMonths = 0;
          var spouseMonths = 0;

          // Past FRA, past retirement
          // already collected
          let isSelfAlreadyCollected = this.client.clientProfile.SelfAlreadyCollecting == 1 ? true : false;
          clientMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.client.DOB);
          // console.log('this.getBirthdayMonth(this.client.client.DOB)',this.getBirthdayMonth(this.client.client.DOB));
          // console.log('new Date().getMonth() + 1', new Date().getMonth());
          if (clientMonths > 0) {
            this.clientAgeMonth = clientMonths;
          } else if (clientMonths < 0) {
            this.clientAgeMonth = 12 + clientMonths;
          } else {
            this.clientAgeMonth = 0;
          }
          const birthDate = new Date(this.client.client.DOB);
          const startYear = new Date();
          let currentExactAge = this.calculateAge(birthDate);
          console.log('currentExactAge', currentExactAge);
          console.log('isSelfAlreadyCollected', isSelfAlreadyCollected);
          console.log('this.clientRetirementYears', this.clientRetirementYears);
          if (this.clientRetirementYears < currentExactAge || (this.clientRetirementYears == currentExactAge && this.clientRetirementMonths < this.clientAgeMonth)  || isSelfAlreadyCollected) {
            this.clientRetirementYears = currentExactAge;
            if(this.clientRetirementYears >= 70){
              if (age >= 70) {
                this.clientRetirementMonths = this.clientAgeMonth;
              } else {
                this.clientRetirementMonths = 0;
              }
            } else {
              this.clientRetirementMonths = this.clientAgeMonth;
            }
          }

          //this.dependentChildCount = this.client.clientProfile.Children && this.client.clientProfile.Children.length || 0;

          let previousSpouseWidowSpouse;
          
          for (let spousesSpouse in this.client.clientProfile.Spouses) {
            for (let previousSpouse in this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse) {
              if (this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse].maritalStatus == 'Widowed')
                previousSpouseWidowSpouse = this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse];
            }
          }

          this.previousSpouse = previousSpouseWidowSpouse || { pia: "$0"};

            if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus != 'Married') {
              if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced'){
                //this.spouseRetirementYears = this.calculateAge(this.client.clientProfile.Spouses[0].dob) > 67 ? Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : 67;
                this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;              
                this.spouseRetirementMonths = 1;
              } else {
                if(this.includeSpouse){
                  //console.log('this is setting the spouseRetirementYears');
                  //this.spouseRetirementYears = this.calculateAge(this.client.clientProfile.Spouses[0].dob) > 67 ? Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : 67;
                  this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;                
                  this.spouseRetirementMonths = 1;
                }
              }
              //console.log('zss in here 08', this.client.clientProfile.Spouses);
              if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive) {
                //console.log('zss in here 09', this.client.clientProfile.Spouses[0].alive);
                this.client.clientProfile.Spouses[0].maritalStatus = 'Widowed';              
                this.spouseRetirementMonths = 1;
              } 
              
             /*  else if((this.client.clientProfile.Spouses.length > 1 && this.client.clientProfile.Spouses[0].maritalStatus == 'Single')){
                console.log('zss in here 09', this.client.clientProfile.Spouses[0].alive);
                if(this.client.clientProfile.Spouses[1].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[1].alive){
                  this.client.clientProfile.Spouses[1].maritalStatus = 'Widowed'
                }
              } */
  
            }

            if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' || this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
              this.spouseClaimStatus = this.calculateAge(spouseDOB) >= 70 ? "True" : "False";
              this.spouseClaimStatusDisabled = this.calculateAge(spouseDOB) < 62 || this.calculateAge(spouseDOB) >= 70;
  
              let FRA = this.getFRAv2(spouseDOB);
               console.log('FRA for Spouse', FRA);
              this.spouseRetirementYears = FRA.age;
              this.spouseRetirementMonths = FRA.month;
              // Past FRA, past retirement
              // already collected
              spouseMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(spouseDOB);
              if (spouseMonths > 0) {
                this.spouseAgeMonth = spouseMonths;
              } else if (spouseMonths < 0) {
                this.spouseAgeMonth = 12 + spouseMonths;
              } else {
                this.spouseAgeMonth = 0;
              }
              let isSpouseAlreadyCollected = this.client.clientProfile.SpouseAlreadyCollecting == 1 ? true : false;
              let spouseAge = this.calculateAge(spouseDOB);
              if (this.spouseRetirementYears < spouseAge  
                || (this.spouseRetirementYears == spouseAge && this.spouseRetirementMonths < this.spouseAgeMonth ) 
                || isSpouseAlreadyCollected) {
                //console.log('set spouse in this if statment');
                this.spouseRetirementYears = spouseAge ;
                // this.spouseRetirementMonths = this.getBirthdayMonth(spouseDOB);
  
                // this.spouseRetirementMonths = spouseAgeMonth;
  
                if(this.spouseRetirementYears >= 70){
                  if (spouseAge >= 70) {
                    this.spouseRetirementMonths = this.spouseAgeMonth;
                  } else {
                    this.spouseRetirementMonths = 0;
                  }
                } else {
                  this.spouseRetirementMonths = this.spouseAgeMonth;
                }
  
              }
              
  
              // this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;
              this.spouseMonthlyBenefitAmount = (this.client.clientProfile.Spouses[0].pia) ? this.client.clientProfile.Spouses[0].pia : 0;
  
              this.spouseStartPIA = (70/100) * this.spouseMonthlyBenefitAmount;
              this.spouseEndPIA = (132/100) * this.spouseMonthlyBenefitAmount;
  
            }
  
            this.clientMonthlyBenefitAmount = (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0;
  
            this.startPIA = (70/100) * this.clientMonthlyBenefitAmount;
            this.endPIA = (132/100) * this.clientMonthlyBenefitAmount;
            /* if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].isLegalSpouse == 0 && !isClient) {
              this.socialSecurityForm.patchValue({'selfLifeExpectancy' : (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].LifeExpectancy) || 0 });
            } else {
              this.socialSecurityForm.patchValue({'selfLifeExpectancy' : this.client.clientProfile.LifeExpectancy });
              this.socialSecurityForm.patchValue({'spouseLifeExpectancy' : (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].LifeExpectancy) || 0 });
            } */

            //TODO: need to figure this out more with 'non-legally married' cases
          if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') {
            this.spouseMonthlyBenefitAmount = this.client.clientProfile.Spouses[0].monthlyBenefitAtPassing;
            if(this.client.clientProfile.Spouses[0].monthlyBenefitAtPassing){
              this.spouseClaimStatus = "True";
            }
          }

            this.isSpouseSurvivor = ((this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.calculateAge(spouseDOB) <= 60
            || (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.calculateAge(spouseDOB) <= 69);

            if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
            || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') 
            && this.includeSpouse && !this.isSpouseSurvivor) 
            && !this.adjSurvivorModal && this.client.clientProfile.SurvivorSwitchYears > 0) {

              console.log('this.client01', this.swappedClaim);
              if (this.client.clientProfile.SurvivorSwitchYears < (this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SelfRetirementYears)) {
                this.swappedClaim = true;
                console.log('switch is true here 01', this.swappedClaim);
              } else if (this.client.clientProfile.SurvivorSwitchYears < (this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SelfRetirementYears)) {
                console.log('swap set to false here');
                this.swappedClaim = false;
              } else {
                if (this.client.clientProfile.SurvivorSwitchMonths < (this.client.clientProfile.SSDesiredAgeMonths || this.client.clientProfile.SelfRetirementMonths)) {
                  this.swappedClaim = true;
                  console.log('switch is true here 02', this.swappedClaim);
                } else if (this.client.clientProfile.SurvivorSwitchMonths < (this.client.clientProfile.SSDesiredAgeMonths || this.client.clientProfile.SelfRetirementMonths)) {
                  this.swappedClaim = true;
                } else {
                  this.swappedClaim = true;
                }
              }
    
              this.adjSurvivorBenefitAge = !this.swappedClaim ? this.client.clientProfile.SSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears
              this.adjSurvivorBenefitMonths = !this.swappedClaim ? this.client.clientProfile.SSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
              this.adjRetirementBenefitAge = this.swappedClaim ? this.client.clientProfile.SSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears;
              this.adjRetirementBenefitMonths = this.swappedClaim ? this.client.clientProfile.SSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
              
              //this.objAdjustedDesiredScenario.spouseSurvivorSwitchAgeYears = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears;
              //this.objAdjustedDesiredScenario.spouseSurvivorSwitchAgeMonths = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths

              this.isSurvAndFirstLoadSwapped = true;
  
            } else if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
              || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) 
              && (!this.adjSurvivorModal || this.isSpouseSurvivor)) {
              //this.swappedClaim = true
  
              if (this.client.clientProfile.SurvivorSwitchYears > ((this.client.clientProfile.Spouses[0].sSDesiredAgeYears) ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : 0)) {
                this.swappedClaim = true;
                console.log('switch is true here 03', this.swappedClaim);
              } else if (this.client.clientProfile.SurvivorSwitchYears < ((this.client.clientProfile.Spouses[0].sSDesiredAgeYears) ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : 0)) {
                this.swappedClaim = false;
              } else {
                if (this.client.clientProfile.SurvivorSwitchMonths > ((this.client.clientProfile.Spouses[0].sSDesiredAgeMonths) ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : 0)) {
                  this.swappedClaim = true;
                  console.log('switch is true here 04', this.swappedClaim);
                } else if (this.client.clientProfile.SurvivorSwitchMonths < ((this.client.clientProfile.Spouses[0].sSDesiredAgeMonths) ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : 0)) {
                  this.swappedClaim = false;
                } else {
                  this.swappedClaim = false;
                }
              }
  
              if(this.isSpouseSurvivor){
                //ZSS added over rides here for spousal surv
                if(!this.client.clientProfile.Spouses[0].sSDesiredAgeYears && this.client.clientProfile.SSDesiredAgeYears){
                  let fra = this.getFRAv2(spouseDOB);
                  let dob = this.calculateAge(spouseDOB);
                  this.client.clientProfile.Spouses[0].sSDesiredAgeYears = (dob > fra.age) ? dob : fra.age;
                  this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = (dob > fra.age) ? 0 : fra.month;
                }
                this.adjSurvivorBenefitAge = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears
                this.adjSurvivorBenefitMonths = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
                this.adjRetirementBenefitAge = !this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears;
                this.adjRetirementBenefitMonths = !this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
              } else {
                //this.adjRetirementBenefitAge = this.client.clientProfile.Spouses[0].sSDesiredAgeYears
                //this.adjRetirementBenefitMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths
                this.adjRetirementBenefitAge = this.client.clientProfile.SSDesiredAgeYears
                this.adjRetirementBenefitMonths = this.client.clientProfile.SSDesiredAgeMonths
                if(!this.adjSurvivorModal){
                  this.swappedClaim = true;
                }
              }
  
              this.isSurvAndFirstLoadSwapped = true; 
              console.log('am I here with spouse?', this.swappedClaim);  
              //console.log('asd2', this.swappedClaim);         
            }
          }


          if(this.partnerActive){
           
            //reset premiums as an object
            this.client.clientProfile.SpousePremiums = JSON.parse(this.client.clientProfile.SpousePremiums);
            if(this.client.clientProfile.SpouseOOPCosts){
              this.client.clientProfile.SpouseOOPCosts = JSON.parse(this.client.clientProfile.SpouseOOPCosts);
            }

            console.log('this.client.clientProfile.SpouseCoverageType', this.client.clientProfile.SpouseCoverageType);

            //let spousePrivateHealthInsurance = this.client.clientProfile.SpouseCoverageType ? this.client.clientProfile.IsSpousePrivHealthIns: (this.isSpousePre65 ? true : this.client.clientProfile.IsSpousePrivHealthIns);
            let spousePrivateHealthInsurance = this.client.clientProfile.IsSpousePrivHealthIns;
            let spousePreRetirementCoverageType = this.client.clientProfile.SpouseCoverageType;// ? this.client.clientProfile.SpouseCoverageType : (this.isSpousePre65 ? 'HMO' : this.client.clientProfile.SpouseCoverageType);

            this.spouseProfileInfo = new FormGroup({
              privateHealthInsurance: new FormControl(spousePrivateHealthInsurance),
              preRetirementCoverageType: new FormControl(spousePreRetirementCoverageType),
              inRetirementCoverageType: new FormControl(this.client.clientProfile.SpousePremiumType),
              HealthCarePremiumType: new FormControl((this.client.clientProfile.SpousePremiumType) ? this.client.clientProfile.SpousePremiumType : ""),

              //Traditional Medicare (TM)
              MedicarePartB: new FormControl((this.client.clientProfile.SpousePremiumType == "TM") ? this.client.clientProfile.SpousePremiums.SpouseMedicarePartB : false),
              MedicarePartD: new FormControl((this.client.clientProfile.SpousePremiumType == "TM") ? this.client.clientProfile.SpousePremiums.SpouseMedicarePartD : false),
              SupplimentalInsurance: new FormControl((this.client.clientProfile.SpousePremiumType == "TM") ? this.client.clientProfile.SpousePremiums.SpouseSupplimentalInsurance : false),
              supplementalPlanType: new FormControl(this.client.clientProfile.SpouseSupplementalPlan),

              //Medicare Adv HMO
              MedicareAdvantageHMO: new FormControl((this.client.clientProfile.SpousePremiumType == "HMO") ? this.client.clientProfile.SpousePremiums.SpouseMedicareAdvantageHMO : false),

              //Medicare Adv PPO
              MedicareAdvantagePPO: new FormControl((this.client.clientProfile.SpousePremiumType == "PPO") ? this.client.clientProfile.SpousePremiums.SpouseMedicareAdvantagePPO : false),

              //always avail
              DentalInsurance: new FormControl(this.client.clientProfile.SpousePremiums? this.client.clientProfile.SpousePremiums.SpouseDentalInsurance: null),
              HospitalAndTest: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest: null),
              PrescriptionDrugs: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs: null),  
              HearingAndVisionCosts: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts: null),    
              DentalCosts: new FormControl(this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseDentalCosts: null),   
              //TODO: need to save this new value
              IsSpouseSameHCSelection: new FormControl(false),
              maritalStatus: new FormControl()
            }); 

            if(this.spouseProfileInfo.value.MedicareAdvantageHMO){
              this.spouseProfileInfo.controls['MedicareAdvantageHMO'].disable();
            } else if(this.spouseProfileInfo.value.MedicareAdvantagePPO){
              this.spouseProfileInfo.controls['MedicareAdvantagePPO'].disable();
            }

            if(this.displayHC){
              if(this.partnerActive){
                this.spouseMedicareTitle = (this.client.clientProfile.SpousePremiumType) ? this.allHealthcarePremiumTypes.find((element) => element.value == this.spouseProfileInfo.value.HealthCarePremiumType).displayName: '';
              }
            }
            /* if(this.client.clientProfile.SpousePremiums){
              var premiums = this.client.clientProfile.SpousePremiums;
              if (this.client.clientProfile.SpousePremiumType == 'TM') {
                this.spouseMedicareCoverageForm.controls['MedicarePartB'].setValue(premiums.SpouseMedicarePartB);
                this.spouseMedicareCoverageForm.controls['MedicarePartD'].setValue(premiums.SpouseMedicarePartD);
                this.spouseMedicareCoverageForm.controls['SupplimentalInsurance'].setValue(premiums.SpouseSupplimentalInsurance);
                this.spouseMedicareCoverageForm.controls['DentalInsurance'].setValue(premiums.SpouseDentalInsurance);
              } else if (this.client.clientProfile.SpousePremiumType == 'HMO') {
                this.spouseMedicareCoverageForm.controls['MedicareAdvantageHMO'].setValue(premiums.SpouseMedicareAdvantageHMO);
                this.spouseMedicareCoverageForm.controls['DentalInsurance'].setValue(premiums.SpouseDentalInsurance);
              } else  if (this.client.clientProfile.SpousePremiumType == 'PPO') {
                this.spouseMedicareCoverageForm.controls['MedicareAdvantagePPO'].setValue(premiums.SpouseMedicareAdvantagePPO);
                this.spouseMedicareCoverageForm.controls['DentalInsurance'].setValue(premiums.SpouseDentalInsurance);
              }
    
              var oopCosts = this.client.clientProfile.SpouseOOPCosts;//JSON.parse(this.client.clientProfile.OOPCosts) || [];
    
              this.spouseMedicareCoverageForm.controls['HospitalAndTest'].setValue((this.client.clientProfile.SpousePremiumType) ? oopCosts.SpouseHospitalAndTest : false);
              this.spouseMedicareCoverageForm.controls['PrescriptionDrugs'].setValue((this.client.clientProfile.SpousePremiumType) ? oopCosts.SpousePrescriptionDrugs : false);
              this.spouseMedicareCoverageForm.controls['HearingAndVisionCosts'].setValue((this.client.clientProfile.SpousePremiumType) ? oopCosts.SpouseHearingAndVisionCosts : false);
              this.spouseMedicareCoverageForm.controls['DentalCosts'].setValue((this.client.clientProfile.SpousePremiumType) ? oopCosts.SpouseDentalCosts : false);
    
              this.spouseMedicareCoverageForm.controls['IsSpouseSameHCSelection'].setValue(this.client.clientProfile.IsHSApplySpouse);
            } */
          } 

          //HACK
          this.client.clientProfile.HCCDYrsDiag = this.client.clientProfile.HCCDYrsDiag ? 1 : 0;
          this.client.clientProfile.HCCYrsDiag = this.client.clientProfile.HCCYrsDiag ? 1 : 0;
          
          if(this.displayMMT){
            this.getMMTData();
          } else if (this.displaySS){
            this.getSSData(false);
          } else if (this.displayLTC && !this.displayHC){
            this.getLTCData(client);
          } else { //Combined
            this.getHCData(client, this.partnerActive, true);
          }

          this.incomeOnPageLoadCheck();
          
        },
        error => this.error = <any>error);
  }

  expandIncomeSection: boolean = false;
  incomeOnPageLoadCheck(){
    if(this.incomeRangeSelectionForm.value.IncomeOption == 2 && this.displayHC){
      this.incomeRangeSelectionForm.get('IncomeReplacementRatio').setValidators([Validators.required, Validators.min(50), Validators.max(200)]);
      this.incomeRangeSelectionForm.get('IncomeInflationRate').setValidators([Validators.required]);
      //this.incomeRangeSelectionForm.get('IncomeValue').updateValueAndValidity();
      this.incomeRangeSelectionForm.get('IncomeReplacementRatio').updateValueAndValidity();
      this.incomeRangeSelectionForm.get('IncomeInflationRate').updateValueAndValidity();

      console.log('check IRR', this.incomeRangeSelectionForm.value.IncomeReplacementRatio);
      var irr = parseInt(this.incomeRangeSelectionForm.value.IncomeReplacementRatio.replace('%', ''));
      if(irr < 50 || irr > 200){
        this.incomeRangeSelectionForm.get('IncomeReplacementRatio').markAsTouched();
        this.expandIncomeSection = true;
      }
    }
  }

  toggleSpouseSameCoverage(origin){
    var premiumType = this.profileInfo.value.HealthCarePremiumType;
    if(origin == 'spouse' && this.spouseProfileInfo.value.IsSpouseSameHCSelection){
      this.profileInfo.controls['IsSpouseSameHCSelection'].setValue(true);
    } else if (origin == 'client' && !this.profileInfo.value.IsSpouseSameHCSelection) {
        this.spouseProfileInfo.controls['IsSpouseSameHCSelection'].setValue(false);
        //premiumType = this.spouseProfileInfo.value.HealthCarePremiumType;
    }

    this.coverageAdjustment(premiumType, true);
    this.oopAdjustment(true);
    //this.selectPremiumOrOOP(true, true);
  }

  formatNumber(amount) {
    return Math.round(amount);
  }

  formatNumber2(amount) {
    amount = amount.toFixed(0);
    return Utils.formatToCurrency(amount);
  }

  handleSavingHC(isAlt) {
    var reportTypeID = this.displaySS ? 11 : (this.displayMMT ? 12 :((this.displayHC && this.displayLTC)? 13 : ((!this.displayHC && this.displayLTC) ? 10 :9)))
    console.log('reportTypeID', reportTypeID)
    var Report = {
      ClientID: this.client.client.ID,
      AdvisorID: this.client.client.AdvisorID,
      CompanyCode: this.client.client.OrganizationID,
      ReportTypeID: reportTypeID,
    }

    var investmentItems = [];

    var investmentItem;

    var currentAge = this.calculateAge(this.client.client.DOB);
    var currentYear = new Date().getFullYear();

    if(this.currentScenario.householdIncomeBracket && this.responseMMTBracket){
      this.bracketChange(this.currentScenario.householdIncomeBracket)
    }

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        StartAmount: this.fundingItems[item].annContribution,
        Ends: this.fundingItems[item].endAge,
        Cola: this.fundingItems[item].inflationRate,
        // ContributionType: 0,
      }

      investmentItems.push(contribution);
    }

    this.hasAlternateScenario = (this.tabs.length > 0 && isAlt);
       
    //TODO: we need to figure out which PDF to download
    if(this.displaySS){ //Social Security
      if(isAlt){
        this.socialSecurityRetirementAgeForm.controls['clientClaimAge'].enable();
        this.socialSecurityRetirementAgeForm.controls['clientClaimMonths'].enable();
        if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
          this.socialSecurityRetirementAgeForm.controls['spouseClaimAge'].enable();
          this.socialSecurityRetirementAgeForm.controls['spouseClaimMonths'].enable();
        }
      }

      var investmentItems = [];
    
      for (var item in this.fundingItems) {

        var contribution = {
          Description: this.fundingItems[item].fundingSource,
          Begins: this.fundingItems[item].startAge,
          Ends: this.fundingItems[item].endAge,
          StartAmount: this.fundingItems[item].annContribution,
          Cola: this.fundingItems[item].inflationRate,
        }

        investmentItems.push(contribution);
      }
      let spouseGovtPension = Number(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g,"").replace("$","") || 0 : 0);
      let spousePIA = this.includeSpouse ? (((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') && this.client.clientProfile.Spouses[0].tenyears)?this.client.clientProfile.Spouses[0].pia: this.spousePIA.toString().replace(/,/g,"").replace("$","")) : 0;
      let spouseLifeExpectancy = this.includeSpouse? ((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')? (this.client.clientProfile.Spouses[0].exSpouseLifeExpectancy || 0):this.client.clientProfile.Spouses[0].LifeExpectancy) : 0;
      let spouseDOB = (this.includeSpouse || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')) ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '1/1/1960') : '1/1/1960';
      
      var spouseHasDOB = (this.includeSpouse || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')) ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? true : Date.parse(this.client.clientProfile.Spouses[0].dob) ? true : false) : false;

      let spouseAlreadyCollecting = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing ? true : false) : this.client.clientProfile.SpouseAlreadyCollecting ? this.client.clientProfile.SpouseAlreadyCollecting: false;

      var tempChildren = [];
      var tempChild = {};

    
      if (this.client.clientProfile.Children && this.client.clientProfile.Children.length) {
        for (var k in this.client.clientProfile.Children) {
          tempChild = {};
          tempChild["CurrentAge"] =  Number(this.client.clientProfile.Children[k].DependentChildAge);//this.getNumber(this.editClientModel.clientProfile.Spouses[k].currentIncome);
          tempChild['isDisabled'] = !!this.client.clientProfile.Children[k].isDisabled;
          tempChild['dacAnticipateEnd'] = !!this.client.clientProfile.Children[k].dacAnticipateEnd;
          tempChild['StopBenefitsAge'] = this.client.clientProfile.Children[k].dacEndAge || null;
          tempChild['IsStudentAt19'] = false;
          //tempChild['isDisabled'] = false;
          //tempChild['IsStudentAt19'] = false; //this.client.clientProfile.Children[k].DependentChildStudent == "Yes" ? true : false;
          tempChildren.push(tempChild);
        }
      }

      var ReportSS = {
                InvestmentItems: JSON.stringify({ investmentItems }),
                InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value): 0,
                InvestmentOption: this.investmentOption,
          
                FrmPhase1Rate: 6,
                FrmPhase1Periods: Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
                FrmPhase2Rate: 6,
                FrmPhase2Periods: 10,
                FrmPhase3Rate: 6,
          
                FrmName0: this.client.client.FirstName + "/" + this.client.client.LastName,
                // SelfCurrentMonthlyBenefit: this.clientMonthlyBenefitAmount,
                // SpouseAlreadyCollecting: this.client.clientProfile.SpouseAlreadyCollecting == 1 ? 'True': 'False', //'False',//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseClaimStatus : "False",
                SelfCurrentMonthlyBenefit: (this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 ? this.client.clientProfile.MonthlyBenefitAmount : this.clientMonthlyBenefitAmount,
                SpouseAlreadyCollecting: spouseAlreadyCollecting,//(this.client.clientProfile.Spouses) ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing : "False" : "False",
                SelfGovPensionAmount: this.client.clientProfile.Pension,// "", // --> Needs to be updated, but how is this calculated?
                Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? JSON.stringify(tempChildren) : '[]',
                SelfAlreadyCollecting: this.client.clientProfile.SelfAlreadyCollecting == 1 ? 'True': 'False', //'False',//this.clientClaimStatus,
                // SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 89 : 0, // make this part of ssData output
                FrmQDepChildren: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? 1 : 0,
                FrmQFormerSpouses: 0,
                FrmSpouseQFormerSpouses: 0, // TODO: add value
                FrmSpouseQDepChildren: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? 1 : 0,
          
                selfConditions: JSON.stringify({
                  HCHBP: this.client.clientProfile.HCHBP || 0,
                  HCHC: this.client.clientProfile.HCHC || 0,
                  HCT1D: this.client.clientProfile.HCT1D || 0,
                  HCT2D: this.client.clientProfile.HCT2D || 0,
                  HCCD: this.client.clientProfile.HCCD || 0,
                  HCC: this.client.clientProfile.HCC || 0,
                  HCT: this.client.clientProfile.HCT || 0,
                  HCMS: this.client.clientProfile.HCMS || 0,
                  HCDCW: this.client.clientProfile.HCDCW || 0,
                  HCFHDC: this.client.clientProfile.HCFHDC || 0,
      
                  HCALZ: this.client.clientProfile.HCALZ || 0,
                  HCPARK: this.client.clientProfile.HCPARK || 0,
                  HCAMP: this.client.clientProfile.HCAMP || 0,
                  HCPTSD: this.client.clientProfile.HCPTSD || 0,
                  HCOBS: this.client.clientProfile.HCOBS || 0,
                }),
                spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? JSON.stringify({
                  HCHBP: this.client.clientProfile.Spouses[0].HCHBP || 0,
                  HCHC: this.client.clientProfile.Spouses[0].HCHC || 0,
                  HCT1D: this.client.clientProfile.Spouses[0].HCT1D || 0,
                  HCT2D: this.client.clientProfile.Spouses[0].HCT2D || 0,
                  HCCD: this.client.clientProfile.Spouses[0].HCCD || 0,
                  HCC: this.client.clientProfile.Spouses[0].HCC || 0,
                  HCT: this.client.clientProfile.Spouses[0].HCT || 0,
                  HCMS: this.client.clientProfile.Spouses[0].HCMS || 0,
                  HCDCW: this.client.clientProfile.Spouses[0].HCDCW || 0,
                  HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC || 0,
      
                  HCALZ: this.client.clientProfile.Spouses[0].HCALZ || 0,
                  HCPARK: this.client.clientProfile.Spouses[0].HCPARK || 0,
                  HCAMP: this.client.clientProfile.Spouses[0].HCAMP || 0,
                  HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD || 0,
                  HCOBS: this.client.clientProfile.Spouses[0].HCOBS || 0,
                }) : "",
          
                includeSpouse: this.includeSpouse ? 1: 0,
          
                
          
                SelfGender: this.client.client.GenderID,
                SpouseGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].gender || 1 : 1,
                // Finish validating fields below this --------
          
                BendPointInflation: 2, // make this part of ssData ?
                SelfCurrentAge: this.calculateAge(this.client.client.DOB),
                SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) || 30 : 30,
                IsPresentValue: 0,//this.hasDurationBeenToggled ? 1 : 0,// == "True" ? true : false,
                SpouseCurrentMonthlyBenefit: (this.client.clientProfile.Spouses[0].monthlyBenefits) ? Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits) : this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g,"").replace("$","") || 0 : 0,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 0 : 0,
                // SpouseCurrentMonthlyBenefit: this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g,"").replace("$","") || 0 : 0,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 0 : 0,
                FrmIncome: "Ind1", // make this part of ssData output
                SelfPensionStartMonth: this.client.clientProfile.PensionMonths, // ??
                isSelfSuspendable: "False", // ??
                SpouseBenefitAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseRetirementYears : 0,
                selfCanRestrict: "False", // ??
                SpousePIA: spousePIA,
                /* SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0, //87, // make this part of ssData output
                SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0, */
                SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy,//this.socialSecurityForm.get('selfLifeExpectancy').value,
                SpouseLifeExpectancy: spouseLifeExpectancy || 0,
          
                StrategyDropDown: "AutoSelect",
                SelfPensionFrequency: "Monthly",
                SelfPensionStartYear: this.client.clientProfile.PensionYears, // ??
                SelfPensionInfl: (this.client.clientProfile.PensionInfl == null) ? 3.00 : this.client.clientProfile.PensionInfl, //default is null
                SelfPIA: this.clientPIA,
                COLA: JSON.stringify({ Colas: this.colas }),
                FrmColaXml:  JSON.stringify({ Colas: this.colas }),
                SpousePensionStartMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionMonth : "01",
                SpouseGovPensionAmount: spouseGovtPension,
                SpouseGovPension: spouseGovtPension > 0 ? true : false,
                SpousePensionInfl: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].PensionInfl == null) ? 3 : this.client.clientProfile.Spouses[0].PensionInfl : 3,
                PIAIncomeYears1: 0, // ??
                SelfAlreadyClaimedAge: 0, // ??
                spouseCanRestrict: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
                SelfSubstantialEarningsYears: this.client.clientProfile.SubstantialEarningYears ? this.client.clientProfile.SubstantialEarningYears : 0,
                SelfBenefitAge: this.clientRetirementYears,// 67,
                FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].firstName + "/" + this.client.clientProfile.Spouses[0].lastName : "",
                SpouseAlreadyClaimedAge: 0, // ??
          
                // MaritalState: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].maritalStatus : (this.client.clientProfile.Spouses.length > 1) ? this.client.clientProfile.Spouses[1].maritalStatus : "Single",
                MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,
                SpousePensionStartYear: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionYear : "",
                SpousePensionFrequency: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "Monthly" : "",
                RetirementStrategy: "FileForBenefits", // get in ssData ??
                PIAIncomeYears2: 0, // ??
                SpouseSubstantialEarningsYears: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && (this.client.clientProfile.Spouses[0].IncludePension == 1) && this.client.clientProfile.Spouses[0].substantialEarningYears ? this.client.clientProfile.Spouses[0].substantialEarningYears : 0,
                SelfGovPension: (Number(this.client.clientProfile.Pension) || 0) > 0 ? true : false,//"False",
                isSpouseSuspendable: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
          
                //TODO: this is an issue with saving for PDFs for clients that have not done an Alternate
                //these areas need to be saved for Optimal reports; right now they are empty
                /* selfRetirementYears: this.socialSecurityForm.get('selfRetirementYears').value,
                selfRetirementMonths: this.socialSecurityForm.get('selfRetirementMonths').value,
                spouseRetirementYears: this.socialSecurityForm.get('spouseRetirementYears').value,
                spouseRetirementMonths: this.socialSecurityForm.get('spouseRetirementMonths').value, */
          
                selfRetirementYears: (this.hasAlternateScenario) ? this.socialSecurityRetirementAgeForm.value.clientClaimAge :(this.ssObject.selfRetirementYears) ? this.ssObject.selfRetirementYears : this.clientRetirementYears,
                selfRetirementMonths: (this.hasAlternateScenario) ? (this.socialSecurityRetirementAgeForm.value.clientClaimMonths) ? this.socialSecurityRetirementAgeForm.value.clientClaimMonths : 0 :(this.ssObject.selfRetirementMonths >= 0) ? this.ssObject.selfRetirementMonths : (this.clientRetirementMonths) ? this.clientRetirementMonths : 0,
                spouseRetirementYears: (this.hasAlternateScenario) ? (this.socialSecurityRetirementAgeForm.value.spouseClaimAge) ? this.socialSecurityRetirementAgeForm.value.spouseClaimAge : (this.ssObject.spouseRetirementYears) ? this.ssObject.spouseRetirementYears : this.spouseRetirementYears : (this.ssObject.spouseRetirementYears) ? this.ssObject.spouseRetirementYears : this.spouseRetirementYears,
                spouseRetirementMonths: (this.hasAlternateScenario) ? (this.socialSecurityRetirementAgeForm.value.spouseClaimMonths) ? this.socialSecurityRetirementAgeForm.value.spouseClaimMonths : 0 :(this.ssObject.spouseRetirementMonths >= 0) ? this.ssObject.spouseRetirementMonths : this.spouseRetirementMonths || 0,
          
                clientSurvivorSwitchYears: (this.ssObject.clientSurvivorSwitchYears >= 0) ? this.ssObject.clientSurvivorSwitchYears : this.clientSurvivorSwitchYears,
                clientSurvivorSwitchMonths: (this.ssObject.clientSurvivorSwitchMonths >= 0) ? this.ssObject.clientSurvivorSwitchMonths : this.clientSurvivorSwitchMonths,
                SurvivorSwitchYears: (this.ssObject.clientSurvivorSwitchYears >= 0) ? this.ssObject.clientSurvivorSwitchYears : this.clientSurvivorSwitchYears,
                SurvivorSwitchMonths: (this.ssObject.clientSurvivorSwitchMonths >= 0) ? this.ssObject.clientSurvivorSwitchMonths : this.clientSurvivorSwitchMonths,
          
                SelfFilingRestrictedYear: (this.ssObject.SelfFilingRestrictedYear) ? this.ssObject.SelfFilingRestrictedYear : (this.client.clientProfile.SelfFilingRestrictedYear) ? this.client.clientProfile.SelfFilingRestrictedYear : 0,
                SelfFilingRestrictedMonth: (this.ssObject.SelfFilingRestrictedMonth) ? this.ssObject.SelfFilingRestrictedMonth : (this.client.clientProfile.SelfFilingRestrictedMonth) ? this.client.clientProfile.SelfFilingRestrictedMonth : 0,
                SpouseFilingRestrictedYear: (this.ssObject.SpouseFilingRestrictedYear) ? this.ssObject.SpouseFilingRestrictedYear : (this.client.clientProfile.Spouses[0].SpouseFilingRestrictedYear) ? this.client.clientProfile.Spouses[0].SpouseFilingRestrictedYear : 0,
                SpouseFilingRestrictedMonth: (this.ssObject.SpouseFilingRestrictedMonth) ? this.ssObject.SpouseFilingRestrictedMonth : (this.client.clientProfile.Spouses[0].SpouseFilingRestrictedMonth) ? this.client.clientProfile.Spouses[0].SpouseFilingRestrictedMonth : 0,
              
          
                /* selfRetirementYears: this.clientRetirementYears,
                selfRetirementMonths: this.clientRetirementMonths,
                spouseRetirementYears: this.spouseRetirementYears,
                spouseRetirementMonths: this.spouseRetirementMonths,
          
                clientSurvivorSwitchYears: this.clientSurvivorSwitchYears,
                clientSurvivorSwitchMonths: this.clientSurvivorSwitchMonths,
                SurvivorSwitchYears: this.clientSurvivorSwitchYears,
                SurvivorSwitchMonths: this.clientSurvivorSwitchMonths, */
          
                SelfDOB: this.client.client.DOB,
                SpouseDOB: spouseDOB,
                SpouseHasDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? true : Date.parse(this.client.clientProfile.Spouses[0].dob) ? true : false) : false,
                // SelfCurrentIncome: this.client.clientProfile.CurrentIncome,
                SelfCurrentIncome: (this.incomeRangeSelectionForm && this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 2 || this.incomeRangeSelectionForm && this.incomeRangeSelectionForm.value.IncomeOption == 3) 
                  ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) : ((this.client.clientProfile.HouseholdYearOneIncome) ? this.client.clientProfile.HouseholdYearOneIncome : (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0),
                //SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.incomeRangeSelectionForm && this.incomeRangeSelectionForm.value.IncomeOption != 1 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
                // SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].currentIncome : 0,
                SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].currentIncome) ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0 : 0,
                SelfIRR: this.client.clientProfile.IRR || 0,
                    
                FrmDiscountRate: 0.034,//this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100,
                SelfRetirementAge: this.client.clientProfile.RetirementAge,
                SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? 0 : this.client.clientProfile.Spouses[0].retirementAge : 0,
                SpousePreviousSpouses: JSON.stringify(this.previousSpouse),
                HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome,
                
                /* SelfFRA: (this.objAdjustedFRAScenario) ? this.objAdjustedFRAScenario.clientAgeYears : this.getFRAv2(this.client.client.DOB).age,
                SelfFRAMonth: (this.objAdjustedFRAScenario) ? this.objAdjustedFRAScenario.clientAgeMonths : this.getFRAv2(this.client.client.DOB).month,
                SpouseFRA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.objAdjustedFRAScenario) ? (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeYears : this.getFRAv2(this.client.clientProfile.Spouses[0].dob).age : 0 : 0,
                SpouseFRAMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.objAdjustedFRAScenario) ? (this.objAdjustedFRAScenario.spouseAgeMonths) ? this.objAdjustedFRAScenario.spouseAgeMonths : this.getFRAv2(this.client.clientProfile.Spouses[0].dob).month : 0 : 0, */
                SelfFRA: this.getFRAv2(this.client.client.DOB).age,
                SelfFRAMonth: this.getFRAv2(this.client.client.DOB).month,
                SpouseFRA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse 
                ? this.getFRAv2(spouseDOB).age : this.spouseRetirementYears || 0,
                SpouseFRAMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse 
                ? this.getFRAv2(spouseDOB).month : this.spouseRetirementMonths || 0,
                
                //ZSS 051024: removed reject bool check on the HasAlternateFRA - was causing issues in PDFs causing UI/PDF mismatch
                //Note: the issue above was because of widow maker (only tested where Spouse was widowed) => but thats what causes the issue
                HasAlternateFRA: (this.hasAdjustedFRAScenario),// || this.rejectOnPageLoad),//((this.rejectOnPageLoad) ? true : false)),
                HasAlternateScenario: (this.hasAlternateScenario),
          
                FrmState: this.client.clientProfile.RetirementState == 'NA' ? '  ': this.client.clientProfile.RetirementState,
                FrmState1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
                SelfWorkingInRetirement: this.client.clientProfile.InRetStopWorkAge > 0 && this.client.clientProfile.InRetFirstYearIncome != null ? this.client.clientProfile.InRetStopWorkAge : 0,
                SpouseWorkingInRetirement: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetStopWork : 0,
                SelfWorkingInRetirementIncome: this.client.clientProfile.InRetFirstYearIncome > 0 ? this.client.clientProfile.InRetFirstYearIncome : 0,
                SpouseWorkingInRetirementIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetFirstYearIncome : 0,
                InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 2.40 : this.client.clientProfile.InRetirementInflationRate, //default if null
                MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year || 0 : 0,
                MidRetRedDollar: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
                MidRetRedPer: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc: 0,
                MidRetIncomeInflationRate: this.client.midRetirementAdj ? this.client.midRetirementAdj.IncomeInflationRate: null,
                MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome, //default if null
                PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate, //default if null
          
                SelfKnownBenefitClaiming: (this.client.clientProfile.SelfKnownBenefitClaiming) ? this.client.clientProfile.SelfKnownBenefitClaiming : 0,
                SpouseKnownBenefitClaiming: (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : 0 : 0,
          
                SelfYearOfStatement: this.client.clientProfile.YearOfStatement || this.currentYear,
                SpouseYearOfStatement: this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : this.currentYear : this.currentYear,
          
                SelfDateOfClaimMonth: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimMonth || 0 : 0,
                SelfDateOfClaimYear: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimYear || 0 : 0,
                SpouseDateOfClaimMonth: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimMonth : 0,
                SpouseDateOfClaimYear: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimYear : 0,
                SelfSubEarningYears: this.client.clientProfile.SubstantialEarningYearsDetails ? this.client.clientProfile.SubstantialEarningYearsDetails : null,
                SpouseSubEarningYears: this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].SubstantialEarningYearsDetails ? JSON.stringify(this.client.clientProfile.Spouses[0].PIAYears) : null,
                InvertSurvivorSwitch: 0,//(this.hasAlternateScenario) ? this.swappedClaim ? 1 : 0 : 0,
                
                SelfWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
                SelfWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].yearAtTimeOfPassing : 0 : 0,
                SelfFRASurvivorSwitchYears: 0,
                SelfFRASurvivorSwitchMonths: 0,
                InvertSurvivorSwitchFRA: 0,
                //InvertSurvivorSwitchFRA: this.hasAdjustedFRAScenario ? this.ssObjectFRA.invertSurvivorSwitch : 0,
      
                //retro save
                hasRetro: false,//this.displayRetroTestMessage,
                clientRetroMonthsEarliest: 0,//((this.ssData.earlRetoFiling) ? this.ssData.cusSelfRetoNumMonths : 0),
                spouseRetroMonthsEarliest : 0,//((this.ssData.earlRetoFiling) ? this.ssData.cusSpouseRetoNumMonths : 0),
                
                clientRetroMonthsOptimal : 0,//((this.ssData.optRetoFiling) ? this.ssData.cusSelfRetoNumMonths : 0),
                spouseRetroMonthsOptimal : 0,//((this.ssData.optRetoFiling) ? this.ssData.cusSpouseRetoNumMonths : 0),
                
                clientRetroMonthsAlternate : 0,//((this.ssDataAlt) ? (this.ssDataAlt.cusRetoFiling) ? this.ssDataAlt.cusSelfRetoNumMonths : 0 : 0),
                spouseRetroMonthsAlternate : 0,//((this.ssDataAlt) ? (this.ssDataAlt.cusRetoFiling) ? this.ssDataAlt.cusSpouseRetoNumMonths : 0 : 0),
                
              }

      //TODO: add retro in here?
      //retro save
      /* if(ReportSS.hasRetro){
        if(this.ssData.earlRetoFiling){
          var retroMonthsPast = (((parseInt(this.socialSecurityIllustrationCards[0].clientAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[0].clientAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[0].clientFRA.age * 12) + this.socialSecurityIllustrationCards[0].clientFRA.month));
          ReportSS.clientRetroMonthsEarliest = ((retroMonthsPast > 0) ? retroMonthsPast >= 6 ? 6 : retroMonthsPast : 0);

          if(this.includeSpouse && this.socialSecurityIllustrationCards[0].partnerAge){
            console.log('partner SS card age', this.socialSecurityIllustrationCards[0].partnerAge);
            var retroMonthsPastPartner = (((parseInt(this.socialSecurityIllustrationCards[0].partnerAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[0].partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[0].partnerFRA.age * 12) + this.socialSecurityIllustrationCards[0].partnerFRA.month));
            ReportSS.spouseRetroMonthsEarliest = ((retroMonthsPastPartner > 0) ? retroMonthsPastPartner >= 6 ? 6 : retroMonthsPastPartner : 0);
          }
        }

        if(this.ssData.optRetoFiling){
          var retroMonthsPast = (((parseInt(this.socialSecurityIllustrationCards[2].clientAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[2].clientAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[2].clientFRA.age * 12) + this.socialSecurityIllustrationCards[2].clientFRA.month));
          ReportSS.clientRetroMonthsOptimal = ((retroMonthsPast > 0) ? retroMonthsPast >= 6 ? 6 : retroMonthsPast : 0);

          if(this.includeSpouse && this.socialSecurityIllustrationCards[2].partnerAge){
            var retroMonthsPastPartner = (((parseInt(this.socialSecurityIllustrationCards[2].partnerAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[2].partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[2].partnerFRA.age * 12) + this.socialSecurityIllustrationCards[2].partnerFRA.month));
            ReportSS.spouseRetroMonthsOptimal = ((retroMonthsPastPartner > 0) ? retroMonthsPastPartner >= 6 ? 6 : retroMonthsPastPartner : 0);
          }
        }
      } */

      if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) {
        if (this.client.clientProfile.Spouses.length > 1)
          ReportSS.FrmQFormerSpouses = 1;
        else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')
          ReportSS.FrmQFormerSpouses = 1;
        else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.client.clientProfile.Spouses[0].tenyears)
          ReportSS.FrmQFormerSpouses = 1;
        else 
          ReportSS.FrmQFormerSpouses = 0;
      } else {
        ReportSS.FrmQFormerSpouses = 0;
      }
      if (this.client.clientProfile.Spouses[0].spousesSpouse) {
        if (this.client.clientProfile.Spouses[0].spousesSpouse.length > 0) {
          ReportSS.FrmSpouseQFormerSpouses = 1;
        } else {
          ReportSS.FrmSpouseQFormerSpouses = 0;
        }
      }
                
      // console.log('this.client.clientProfile.Spouses', this.client.clientProfile.Spouses);
      if (ReportSS.MaritalState == 'Divorced') {
        ReportSS.SpouseBenefitAge = 62;
        //ReportSS.spouseRetirementYears = 62;
        //ReportSS.spouseRetirementMonths = 0;
  
        //ReportSS.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears : 62;
        //ReportSS.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths : 0;
   
        ReportSS.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears : 62;
        ReportSS.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths || 0 : 0;
      }

      if(isAlt){
        this.setSSDCAValidation(true);
        if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
          this.setSSDCAValidation(false);
        }
      }

      console.log('saving for PDF', ReportSS);
        console.log('this.clientRetirementMonths', this.clientRetirementMonths);
        // console.log('this.client.midRetirementAdj.Year', this.client.midRetirementAdj.Year)
        // need to pass: retirement age, retirement location, life expectancy, Healthcare Coverage, Medicare Coverage, Income, original Annual HC cost, orginial SS deduction.
        this.globalService.createReportSS(Report, ReportSS)
        .subscribe(
            resp => {
              if (resp) {
                this.snackBarService.add("Please wait while your social security report is being generated.", 0);
                //this.router.navigateByUrl('/reports/create?d=t');
                this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
              }
            },
            error => this.error = <any>error);
    } else if(this.displayMMT){ //Means Testing

      // const yearsUntilFirstRetire = this.partnerActive ? Math.max(0, this.currentScenario.clientRetirementAge - this.calculateAge(this.client.client.DOB)) 
      
      var ReportMMT = {
                ClientSSMonthlyBenefit: this.client.clientProfile.PIA,
                //this.client.clientProfile.InRetirementInflationRate
                InflationRate: (this.client.clientProfile.InflationRate) ? this.client.clientProfile.InflationRate / 100 : 0.03,  
                MagiIncomePercent: this.valueMAGISlider,//this.magi,
                IncludePartner: this.partnerActive,
                SurvivorIncomeReductionRate: 44,
                RetirementIncomeReduction: '',
                IncomeReductionAge: '',
                IncomeReductionInflationRate: '',
                ClientSocialSecurityAge: 65, //this.ssClientAge,
                ClientPensionSurvivorBenefitPercent: 0,
                ClientLifeExpectancy: this.currentScenario.clientLifeExpectancy,
                PartnerSocialSecurityAge: this.ssSpouseAge,
                PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' 
                  ? this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "") || 0 
                  : this.client.clientProfile.Spouses[0] ? this.client.clientProfile.Spouses[0].pia || 0 : 0,
                PartnerPensionSurvivorBenefitPercent: 0,
                PartnerLifeExpectancy: this.partnerActive ? this.currentScenario.spouseLifeExpectancy : 0,
                ClientCurrentAge: this.calculateAge(this.client.client.DOB),
                ClientCurrentIncome: this.client.clientProfile.CurrentIncome,
                // ClientCurrentIncome: this.client.clientProfile.CurrentIncome === null
                //   ? (this.client.clientProfile.HouseholdYearOneIncome / Math.pow(1.03, yearsUntilFirstRetire))
                //   / (this.client.clientProfile.IRR ? this.client.clientProfile.IRR : 0.75)
                //   / (this.valueMAGISlider / 100)
                //   : this.client.clientProfile.CurrentIncome,
                ClientGender: this.client.client.GenderID,
                ClientHealthRating: this.responseMMT.Client.HealthRating,
                ClientPensionAmount: (Number(this.client.clientProfile.Pension) || 0),//this.client.clientProfile.Pension,
                ClientRetirementAge: this.currentScenario.clientRetirementAge,
                FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
                FrmName1: this.partnerActive ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
                PartnerCurrentAge: this.partnerActive ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
                PartnerCurrentIncome: this.partnerActive ? this.client.clientProfile.Spouses[0].currentIncome : 0,//this.mmtData.Partner.CurrentIncome : 0,
                PartnerGender: this.partnerActive ? this.client.clientProfile.Spouses[0].gender : 0,
                PartnerHealthRating: this.partnerActive ? this.responseMMT.Partner.HealthRating : 0,
                PartnerPensionAmount: this.partnerActive ? this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g, "").replace("$", "") || 0 : 0 : 0,
                PartnerRetirementAge: this.partnerActive ? this.currentScenario.spouseRetirementAge : 0,
                ReplacementRate: this.client.clientProfile.IRR || 75,
                State: this.client.clientProfile.RetirementState,
                SurchargeSavings: Utils.removeCurrencyFormatting(this.totalSavings),
                //SurchargeSavings: Utils.removeCurrencyFormatting((isAlt) ? this.altScenario.clientLifetimeIRMAASurcharges : this.currentScenario.clientLifetimeIRMAASurcharges),
      
                MAGI: (isAlt) ? this.valueMAGISlider : (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,
                MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year : 0,
                MidRetRedPer:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,/// 100 : 0,
                MidRetRedDollar:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
                MidRetIncomeInflationRate: this.client.midRetirementAdj ? (this.client.midRetirementAdj.IncomeInflationRate) : 0,// / 100 : 0, 
      }
  
      this.globalService.createReport(Report, ReportMMT)
        .subscribe(
        resp => {
          this.snackBarService.add("Please wait while your medicare means testing report is being generated.", 0);
          this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
        },
        error => { console.log(error) });

    } else if(this.displayHC && this.displayLTC){ //Combined (HC and LTC)

      this.profileInfo.controls['MedicareAdvantageHMO'].enable();
      this.spouseProfileInfo.controls['MedicareAdvantageHMO'].enable();
      
      this.profileInfo.controls['MedicareAdvantagePPO'].enable();
      this.spouseProfileInfo.controls['MedicareAdvantagePPO'].enable();

      let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
      let isIncome = (this.client.clientProfile.CurrentIncome && this.client.clientProfile.InflationRate && this.client.clientProfile.IRR) || this.client.clientProfile.HouseholdYearOneIncome ? true : false;

      // need after NW release
      // this.isMedicareCoverageChange =  this.client.clientProfile.PremiumType == "TM" ? ((this.client.clientProfile.Premiums.MedicarePartB != this.profileInfo.value.MedicarePartB || this.client.clientProfile.Premiums.MedicarePartD != this.profileInfo.value.MedicarePartD || this.client.clientProfile.Premiums.SupplimentalInsurance != this.profileInfo.value.SupplimentalInsurance) ? true: this.isMedicareCoverageChange): this.isMedicareCoverageChange;
      // this.isMedicareCoverageChange = (this.client.clientProfile.Premiums.DentalInsurance != this.profileInfo.value.DentalInsurance || this.client.clientProfile.OOPCosts.HospitalAndTest != this.profileInfo.value.HospitalAndTest || this.client.clientProfile.OOPCosts.PrescriptionDrugs != this.profileInfo.value.PrescriptionDrugs || this.client.clientProfile.OOPCosts.HearingAndVisionCosts != this.profileInfo.value.HearingAndVisionCosts || this.client.clientProfile.OOPCosts.DentalCosts != this.profileInfo.value.DentalCosts) ? true: this.isMedicareCoverageChange;
      // this.isMedicareCoverageChange = this.client.clientProfile.PremiumType == "HMO" ? (this.client.clientProfile.Premiums.MedicareAdvantageHMO !=  this.profileInfo.value.MedicareAdvantageHMO || this.client.clientProfile.Premiums.MedicareAdvantagePPO !=  this.profileInfo.value.MedicareAdvantagePPO) ? true : this.isMedicareCoverageChange : this.isMedicareCoverageChange;
      // if (this.includeSpouse) {
      //   this.isMedicareCoverageChange =  this.client.clientProfile.SpousePremiumType == "TM" ? ((this.client.clientProfile.Premiums.SpouseMedicarePartB != this.spouseProfileInfo.value.MedicarePartB || this.client.clientProfile.Premiums.SpouseMedicarePartD != this.spouseProfileInfo.value.MedicarePartD || this.client.clientProfile.Premiums.SpouseSupplimentalInsurance != this.spouseProfileInfo.value.SupplimentalInsurance) ? true: this.isMedicareCoverageChange): this.isMedicareCoverageChange;
      //   this.isMedicareCoverageChange = (this.client.clientProfile.Premiums.SpouseDentalInsurance != this.spouseProfileInfo.value.DentalInsurance || this.client.clientProfile.OOPCosts.SpouseHospitalAndTest != this.spouseProfileInfo.value.HospitalAndTest || this.client.clientProfile.OOPCosts.SpousePrescriptionDrugs != this.spouseProfileInfo.value.PrescriptionDrugs || this.client.clientProfile.SpouseOOPCosts.HearingAndVisionCosts != this.spouseProfileInfo.value.HearingAndVisionCosts || this.client.clientProfile.OOPCosts.SpouseDentalCosts != this.spouseProfileInfo.value.DentalCosts) ? true: this.isMedicareCoverageChange;
      //   this.isMedicareCoverageChange = this.client.clientProfile.SpousePremiumType == "HMO" ? (this.client.clientProfile.Premiums.SpouseMedicareAdvantageHMO !=  this.spouseProfileInfo.value.MedicareAdvantageHMO || this.client.clientProfile.Premiums.SpouseMedicareAdvantagePPO !=  this.spouseProfileInfo.value.MedicareAdvantagePPO) ? true : this.isMedicareCoverageChange : this.isMedicareCoverageChange;
      // }
      var ReportCombined = {
        // ID: 0,
        InvestmentItems: JSON.stringify({ InvestmentItems: { Items: investmentItems } }),

        //client
        P_Part_A_And_B: this.client.clientProfile.PremiumType == "TM" && this.client.clientProfile.Premiums.MedicarePartB ? 1 : 0,//.profileInfo.value.MedicarePartB ? 1 : 0,//this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
        P_Part_D: this.client.clientProfile.PremiumType == "TM" && this.client.clientProfile.Premiums.MedicarePartD ? 1 : 0,//this.profileInfo.value.MedicarePartD ? 1 : 0,//this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
        P_MediGap: this.client.clientProfile.PremiumType == "TM" && this.client.clientProfile.Premiums.SupplimentalInsurance ? 1 : 0,//this.profileInfo.value.SupplimentalInsurance ? 1 : 0,//this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
        P_Dental: this.client.clientProfile.PremiumType && this.client.clientProfile.Premiums.DentalInsurance ? 1 : 0,//this.profileInfo.value.DentalInsurance ? 1 : 0,//this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
        //P_Advantage: ((this.profileInfo.value.MedicareAdvantageHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.MedicareAdvantagePPO && this.profileInfo.value.inRetirementCoverageType == 'PPO'))? 1 : 0,
        P_Advantage: ((this.client.clientProfile.PremiumType == 'HMO') || (this.client.clientProfile.PremiumType == 'PPO')) ? 1 : 0,
        OOP_Hosp_Docs: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.HospitalAndTest ? 1 : 0,//this.profileInfo.value.HospitalAndTest ? 1 : 0,//this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
        OOP_Presc_Drug: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.PrescriptionDrugs ? 1 : 0,//this.profileInfo.value.PrescriptionDrugs ? 1 : 0,//this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
        OOP_Hearing_Vision: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.HearingAndVisionCosts ? 1 : 0,//this.profileInfo.value.HearingAndVisionCosts ? 1 : 0,//this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
        OOP_Dental: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.DentalCosts ? 1 : 0,//this.profileInfo.value.DentalCosts ? 1 : 0,//this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,
        
        //spouse/partner
        P_Part_A_And_B1: this.partnerActive ? this.client.clientProfile.SpousePremiumType == "TM" && this.client.clientProfile.SpousePremiums.SpouseMedicarePartB ? 1 : 0 : 0,//this.spouseProfileInfo.value.MedicarePartB ? 1 : 0 : 0,
        P_Part_D1: this.partnerActive ? this.client.clientProfile.SpousePremiumType == "TM" && this.client.clientProfile.SpousePremiums.SpouseMedicarePartD ? 1 : 0 : 0,//this.spouseProfileInfo.value.MedicarePartD ? 1 : 0 : 0,
        P_MediGap1: this.partnerActive ? this.client.clientProfile.SpousePremiumType == "TM" && this.client.clientProfile.SpousePremiums.SpouseSupplimentalInsurance ? 1 : 0 : 0,//this.spouseProfileInfo.value.SupplimentalInsurance ? 1 : 0 : 0,
        P_Dental1: this.partnerActive ? this.client.clientProfile.SpousePremiums ? this.client.clientProfile.SpousePremiums.SpouseDentalInsurance ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.DentalInsurance ? 1 : 0 : 0,
        P_Advantage1: this.partnerActive ?  ((this.client.clientProfile.SpousePremiumType == 'HMO') || (this.client.clientProfile.SpousePremiumType == 'PPO')) ? 1 : 0 : 0,//((this.spouseProfileInfo.value.MedicareAdvantageHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.MedicareAdvantagePPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
        OOP_Hosp_Docs1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.HospitalAndTest ? 1 : 0 : 0,
        OOP_Presc_Drug1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.PrescriptionDrugs ? 1 : 0 : 0,
        OOP_Hearing_Vision1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.HearingAndVisionCosts ? 1 : 0 : 0,
        OOP_Dental1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseDentalCosts ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.DentalCosts ? 1 : 0 : 0,
          
        FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
        FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
        FrmHasPartner: this.partnerActive,
        FrmQType: this.client.clientProfile.HCT1D,
        FrmQExcercise: 1,
        FrmGender: this.client.client.GenderID,
        FrmQTypeII: this.client.clientProfile.HCT2D,
        FrmQTobacco: this.client.clientProfile.HCT,
        FrmQCancer: this.client.clientProfile.HCC,
        FrmQHistory: this.client.clientProfile.HCFHDC,
        FrmQCardio: this.client.clientProfile.HCCD,
        FrmQPhysical: 1,
        FrmQHighColesterol: this.client.clientProfile.HCHC,
        FrmQDiet: 1,
        FrmQHBP: this.client.clientProfile.HCHBP,
        FrmQDCW: this.client.clientProfile.HCDCW,
        FrmQMS: this.client.clientProfile.HCMS,
  
        FrmQAlzheimer: this.client.clientProfile.HCALZ,
        FrmQParkinson: this.client.clientProfile.HCPARK,
        FrmQPTSD: this.client.clientProfile.HCPTSD,
        FrmQAmputation: this.client.clientProfile.HCAMP,
        FrmQObesity: this.client.clientProfile.HCOBS,
  
        FrmCurrentAge: this.calculateAge(this.client.client.DOB),
  
        //FrmPlanUntil: this.hcDataV2.PlanUntilYear,
        //FrmPlanUntil0: this.hcDataV2.PlanUntilYear,
        //FrmPlanUntil1: this.hcDataV2.PlanUntil1,
        //SpouseFrmPlanUntil: this.hcDataV2.PlanUntil1,
        FrmPlanUntil: this.currentScenario.clientRetirementHorizon,//this.hcDataV2.PlanUntilYear,
        FrmPlanUntil0: this.currentScenario.clientRetirementHorizon,//this.hcDataV2.PlanUntilYear,
        FrmPlanUntil1: this.currentScenario.spouseRetirementHorizon,//this.hcDataV2.PlanUntil1,
        SpouseFrmPlanUntil: this.currentScenario.spouseRetirementHorizon,//this.hcDataV2.PlanUntil1,
  
        SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
        SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
        SpouseFrmQDiet: 1,
        SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
        SpouseFrmQPhysical: 1,
        SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
        SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
        SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
        SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
  
        SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
        SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
        SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
        SpouseQExcercise: 1,
        SpouseQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,
        SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,
  
        SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
        SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
        SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
        SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
        SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,
        SpouseFrmQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,
  
        PaymentTotal: 0,
        PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,
  
        // FrmIncome: this.hcDataV2.FrmIncome,
        FrmIncome: this.orgFrmIncome,
        FrmPhase1Rate: 6.0,
        FrmPhase1Periods: 65 - this.calculateAge(this.client.client.DOB),
        FrmPhase2Rate: 6.0,
        FrmPhase2Periods: (75 - 65),
        FrmPhase3Rate: 6.0,
  
        //FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.getRetirementYear(this.client.clientProfile.Spouses[0].retirementAge, this.client.clientProfile.Spouses[0].dob) : 0,
        //FrmPV: this.FrmPV,
        //FrmRetireYear0: this.getRetirementYear(this.client.clientProfile.RetirementAge, this.client.client.DOB),
        //FrmState: this.client.clientProfile.RetirementState,
        //FundCosts: this.futureTotalCost,
        FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 
        ? Math.max(currentYear,this.getRetirementYear(this.currentScenario.spouseRetirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
        FrmPV: this.FrmPV,
        // FrmRetireYear0: this.getRetirementYear(this.currentScenario.clientRetirementAge, this.client.client.DOB),
        FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.currentScenario.clientRetirementAge, this.client.client.DOB)),
        FrmState: this.currentScenario.clientRetirementState,//this.client.clientProfile.RetirementState,
        FundCosts: this.currentScenario.clientTotalHCC + this.currentScenario.spouseTotalHCC,//this.futureTotalCost,

  
        //SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0,
        //SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0,
        SelfLifeExpectancy: this.currentScenario.clientLifeExpectancy,//this.client.clientProfile.LifeExpectancy || 0,
        SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse
          ? this.currentScenario.spouseLifeExpectancy//this.client.clientProfile.Spouses[0].LifeExpectancy || 0 
          : 0,
        InvestmentOption: this.investmentOption || 1,
        UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
        
        MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,
        MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year : 0,
        MidRetRedPer:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,/// 100 : 0,
        MidRetRedDollar:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
        MidRetIncomeInflationRate: this.client.midRetirementAdj ? (this.client.midRetirementAdj.IncomeInflationRate) : 0,// / 100 : 0,

        SpouseDOB: spouseDOB,
        SelfDOB: this.client.client.DOB,

        SelfRetirementAge: this.currentScenario.clientRetirementAge,//this.client.clientProfile.RetirementAge,
        SpouseRetirementAge: this.currentScenario.spouseRetirementAge,//this.client.clientProfile.Spouses[0].retirementAge,

        //SelfRetirementAge: this.client.clientProfile.RetirementAge,
        //SpouseRetirementAge: this.client.clientProfile.Spouses[0].retirementAge,
        MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,
        // HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome,
        HouseholdYearOneIncome: this.currentScenario.householdYearOneIncome,
        // PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate,
        PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 0.03 : this.client.clientProfile.InflationRate / 100,
        InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 0.03 : this.client.clientProfile.InRetirementInflationRate / 100,  
        //FrmState1: this.client.clientProfile.Spouses[0].state || '',
        FrmState1: this.currentScenario.spouseRetirementState,
        SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,
        SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
        //PremiumType: this.profileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.profileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2,
        //PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
        //PrivateInsurance: (this.profileInfo.value.privateHealthInsurance == 'true' || this.profileInfo.value.privateHealthInsurance == true)  ? 1: 0,
        //PrivateInsurance1: (this.partnerActive) ? (this.spouseProfileInfo.value.privateHealthInsurance == 'true' || this.spouseProfileInfo.value.privateHealthInsurance == true)? 1 : 0: 0,
        //SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
        //SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && isIncome ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
        // P_Advantage: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO'))? 1 : 0,
        // P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
        //CoverageType: this.profileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.profileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2,
        //CoverageType1: (this.partnerActive) ? this.spouseProfileInfo.value.preRetirementCoverageType == 'PPO' ? 0 : this.spouseProfileInfo.value.preRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
        //PremiumType: this.profileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.profileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2,
        PremiumType: this.client.clientProfile.PremiumType == 'TM' ? 0 : this.client.clientProfile.PremiumType == 'HMO' ? 1 : 2,
        //PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
        PremiumType1: (this.partnerActive) ? this.client.clientProfile.SpousePremiumType == 'TM' ? 0 : this.client.clientProfile.SpousePremiumType == 'HMO' ? 1 : 2 : 0,
        //PrivateInsurance: (this.profileInfo.value.privateHealthInsurance == 'true' || this.profileInfo.value.privateHealthInsurance == true)  ? 1: 0,
        //PrivateInsurance1: (this.partnerActive) ? (this.spouseProfileInfo.value.privateHealthInsurance == 'true' || this.spouseProfileInfo.value.privateHealthInsurance == true)? 1 : 0: 0,
        PrivateInsurance: this.calculateAge(this.client.client.DOB) < 65 && this.client.clientProfile.IsPrivHealthIns ? 1 : 0,// this.client.clientProfile.SpousePremiumType == "TM"
        PrivateInsurance1: this.calculateAge(this.client.client.DOB) < 65 && this.client.clientProfile.SpouseCoverageType ? this.client.clientProfile.IsSpousePrivHealthIns ? 1 : 0 : (this.client.clientProfile.IsSpousePrivHealthIns ? 1 : 0),
        // PrivateInsurance1: this.client.clientProfile.SpouseCoverageType ? this.client.clientProfile.IsSpousePrivHealthIns ? 1 : 0 : (this.isSpousePre65 ? 1 : this.client.clientProfile.IsSpousePrivHealthIns ? 1 : 0),
        // SelfCurrentIncome: (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
        //SelfCurrentIncome: (this.client.clientProfile.HouseholdYearOneIncome) ? this.client.clientProfile.HouseholdYearOneIncome : (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
        // SelfCurrentIncome: (this.currentScenario.householdYearOneIncome) ? this.currentScenario.householdYearOneIncome : (this.currentScenario.clientCurrentIncome) ? this.currentScenario.clientCurrentIncome : 0,
        SelfCurrentIncome: (this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 2 || this.incomeRangeSelectionForm.value.IncomeOption == 3) ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) : ((this.client.clientProfile.HouseholdYearOneIncome) ? this.client.clientProfile.HouseholdYearOneIncome : (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0),
        SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.incomeRangeSelectionForm.value.IncomeOption != 1 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
        //SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
        // P_Advantage: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO'))? 1 : 0,
        // P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
        CoverageType: this.client.clientProfile.CoverageType == 'PPO' ? 0 : this.client.clientProfile.CoverageType == 'HMO' ? 1 : 2,
        CoverageType1: (this.partnerActive) ? this.client.clientProfile.SpouseCoverageType == 'PPO' ? 0 : this.client.clientProfile.SpouseCoverageType == 'HMO' ? 1 : 2 : 0,
        //CoverageType: this.client.clientProfile.CoverageType,
        //CoverageType1: (this.partnerActive) ? this.client.clientProfile.SpouseCoverageType : 0,

        //SelfSupplementalPlan: this.profileInfo.value.supplementalPlanType,
        //SpouseSupplementalPlan: (this.partnerActive) ? this.spouseProfileInfo.value.supplementalPlanType : "",
        SelfSupplementalPlan: this.client.clientProfile.SelfSupplementalPlan,//this.profileInfo.value.supplementalPlanType,
        SpouseSupplementalPlan: (this.partnerActive) ? this.client.clientProfile.SpouseSupplementalPlan : "",


        Bracket: this.currentScenario.householdIncomeBracket,//this.client.clientProfile.Bracket,       
        BracketRange: this.selectedIRMAABracketDisplay,
  
        //FrmPlanningAge0: this.client.clientProfile.LifeExpectancy,
        //FrmPlanningAge1: (this.partnerActive)  ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,
        //MetroRegion0: this.currentScenario.clientMetroArea,//this.client.clientProfile.ClientMetroArea,//this.selfRegion, // here
        //MetroRegion1: this.currentScenario.spouseMetroArea,//this.client.clientProfile.SpouseMetroArea,//this.spouseRegion,
        FrmPlanningAge0: this.currentScenario.clientLifeExpectancy,//this.client.clientProfile.LifeExpectancy,
        FrmPlanningAge1: this.includeSpouse ?  this.currentScenario.spouseLifeExpectancy : 0,//Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,
        //lifeExpectancy: this.client.clientProfile.LifeExpectancy,
        //spouseLifeExpectancy: this.includeSpouse ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,  
        MetroRegion0: this.currentScenario.clientMetroArea,//this.client.clientProfile.ClientMetroArea,//this.selfRegion, // here
        MetroRegion1: this.currentScenario.spouseMetroArea,//this.client.clientProfile.SpouseMetroArea,//this.spouseRegion,
  
        MetroRegionDesc0: this.currentScenario.clientMetroAreaName,//this.clientRegions.MetroRegion,//this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
        MetroRegionDesc1: (this.spouseRegions) ? this.currentScenario.spouseMetroAreaName : "",
  
        // MetroRegionDesc0: this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
        // MetroRegionDesc1: this.getRegionDescription((this.partnerActive)  ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false),

        //MetroRegionDesc0: this.clientRegions.MetroRegion,//this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
        //MetroRegionDesc1: (this.spouseRegions) ? this.spouseRegions.MetroRegion : "",
        InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value): 0,
        CareTypes: JSON.stringify(this.selfTypeList),
        CareTypes1: JSON.stringify(this.spouseTypeList),
        CareType: this.selfType,
        CareType1: this.spouseType,
        FrmLTCMonths0: this.selfPeriods,
        FrmLTCMonths1: this.spousePeriods,

        HasAlternateScenario: (isAlt) ? (this.hasAlternateScenario) : false,//(this.altScenario) ? 1 : 0,
        AlternateScenario: (isAlt) ? (this.hasAlternateScenario) ? JSON.stringify(this.altScenario) : null : null,
        AlternateProfile: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.profileInfo.value) : null : null,
        AlternateSpouseProfile: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.spouseProfileInfo.value) : null : null,
        AlternateIncomeRangeSelection: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.incomeRangeSelectionForm.value) : null : null,
        OriginalScenario: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.orgScenario) : null : null,
        // HasIncomeChange: this.isIncomeChange, // need after NW release
        // HasMedicareCoverageChange: this.isMedicareCoverageChange // need after NW release
        isQuickReport: true        
      }
      console.log('ReportCombined', ReportCombined);
      if(this.client.clientProfile.PremiumType != 'TM'){
        ReportCombined.P_Part_A_And_B = 1;
      }
  
      if (this.partnerActive) {
        if(this.client.clientProfile.SpousePremiumType != 'TM'){
          ReportCombined.P_Part_A_And_B1 = 1;
        }
      }
      this.globalService.createReportCombined(Report, ReportCombined)
        .subscribe(
          resp => {
            this.snackBarService.add("Please wait while your healthcare report is being generated.", 0);

            //HACK: since we save the form objs in DB and use the disable/enable to force a premiums to be selected
            //it causes issues to save a disabled form field - so, we need to enable and then disable again
            this.profileInfo.controls['MedicareAdvantageHMO'].disable();
            this.spouseProfileInfo.controls['MedicareAdvantageHMO'].disable();
            this.profileInfo.controls['MedicareAdvantagePPO'].disable();
            this.spouseProfileInfo.controls['MedicareAdvantagePPO'].disable();
  
            this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
          },
          error => this.error = <any>error);

      /* SelfSupplementalPlan: this.profileInfo.value.supplementalPlanType,
       SpouseSupplementalPlan: (this.partnerActive) ? this.spouseProfileInfo.value.supplementalPlanType : "" */
    } else if(!this.displayHC && this.displayLTC){ //Long Term
      let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');

      var ReportLTC = {
        investmentItems: JSON.stringify({ investmentItems }),
        FrmHasPartner: this.includeSpouse,
        FrmName0: this.client.client.FirstName + ' ' + this.client.client.LastName,
        FrmName1: this.includeSpouse ? this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.clientProfile.Spouses[0].lastName : '',
        FrmGender0: this.client.client.GenderID,
        FrmCurrentAge0: this.calculateAge(this.client.client.DOB),
        FrmGender1: this.includeSpouse ? Number(this.client.clientProfile.Spouses[0].gender) : 0,
        FrmCurrentAge1: this.includeSpouse ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
        //FrmLTCState0: this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.RetirementState,
        FrmHealth0: 0,
        FrmHealth1: 0,

        FrmQType: this.client.clientProfile.HCT1D,
        FrmQTypeII: this.client.clientProfile.HCT2D,
        FrmQTobacco: this.client.clientProfile.HCT,
        FrmQCancer: this.client.clientProfile.HCC,
        FrmQHistory: this.client.clientProfile.HCFHDC,
        FrmQMS: this.client.clientProfile.HCMS,
        FrmQCardio: this.client.clientProfile.HCCD,
        FrmQHighCholesterol: this.client.clientProfile.HCHC,
        FrmQHBP: this.client.clientProfile.HCHBP,
        FrmQAlzheimer: this.client.clientProfile.HCALZ,
        FrmQParkinson: this.client.clientProfile.HCPARK,
        FrmQPTSD: this.client.clientProfile.HCPTSD,
        FrmQAmputation: this.client.clientProfile.HCAMP,
        FrmQObesity: this.client.clientProfile.HCOBS,
        FrmQDCW: this.client.clientProfile.HCDCW,

        SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,
        SpouseFrmQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
        SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
        SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
        SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
        SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
        SpouseFrmQHighCholesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
        SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
        SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
        SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
        SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
        SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
        SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
        SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,
        SpouseFrmQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

        //FrmLTCState1: this.includeSpouse ? (this.client.clientProfile.UseNationalAverage ? '' : this.client.clientProfile.Spouses[0].state) : '',
        FrmLTCState0: this.currentScenario.clientRetirementState,//this.client.clientProfile.RetirementState,
        FrmLTCState1: this.currentScenario.spouseRetirementState,//this.client.clientProfile.RetirementState,

        FrmPhase1Rate: (this.p1Percent ? (Number(this.p1Percent.nativeElement.value)) : 6),
        FrmPhase1Periods: (this.p1EndAge ? Number(this.p1EndAge.nativeElement.value) - this.calculateAge(this.client.client.DOB) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB)))),
        FrmPhase2Rate: (this.p2Percent ? (Number(this.p2Percent.nativeElement.value)) : 6),
        FrmPhase2Periods: (this.p2EndAge ? (Number(this.p2EndAge.nativeElement.value) - (Number(this.p1EndAge.nativeElement.value))) : 10),
        FrmPhase3Rate: (this.p3Percent ? (Number(this.p3Percent.nativeElement.value)) : 6),
  
        FrmLTCMonths0: this.selfPeriods,
        FrmLTCMonths1: this.spousePeriods,
        
         FrmPlanningAge0: this.currentScenario.clientLifeExpectancy,//this.client.clientProfile.LifeExpectancy,
        FrmPlanningAge1: this.includeSpouse ?  this.currentScenario.spouseLifeExpectancy : 0,//Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,
        //lifeExpectancy: this.client.clientProfile.LifeExpectancy,
        //spouseLifeExpectancy: this.includeSpouse ?  Number(this.client.clientProfile.Spouses[0].LifeExpectancy) : 0,  
        MetroRegion0: this.currentScenario.clientMetroArea,//this.client.clientProfile.ClientMetroArea,//this.selfRegion, // here
        MetroRegion1: this.currentScenario.spouseMetroArea,//this.client.clientProfile.SpouseMetroArea,//this.spouseRegion,
  
        MetroRegionDesc0: this.currentScenario.clientMetroAreaName,//this.clientRegions.MetroRegion,//this.getRegionDescription(this.client.clientProfile.RetirementState, this.selfRegion, true),
        MetroRegionDesc1: (this.spouseRegions) ? this.currentScenario.spouseMetroAreaName : "",//this.spouseRegions.MetroRegion : "",//this.includeSpouse ? this.getRegionDescription(this.includeSpouse ? this.client.clientProfile.Spouses[0].state : '', this.spouseRegion, false) : '',
        UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,
  
        InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value): 0,
        InvestmentOption: this.investmentOption,
  
        CareType: this.selfType,
        CareType1: this.spouseType,
        MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,

       /*  HasAlternateScenario: (this.hasAlternateScenario),//(this.altScenario) ? 1 : 0,
        AlternateScenario: (this.hasAlternateScenario) ? JSON.stringify(this.altScenario) : null,
        AlternateProfile: (this.hasAlternateScenario) ? JSON.stringify(this.profileInfo.value) : null,
        AlternateSpouseProfile: (this.hasAlternateScenario) ? JSON.stringify(this.spouseProfileInfo.value) : null,
        AlternateIncomeRangeSelection: (this.hasAlternateScenario) ? JSON.stringify(this.incomeRangeSelectionForm.value) : null,
        OriginalScenario: (this.hasAlternateScenario) ? JSON.stringify(this.orgScenario) : null, */
        
        HasAlternateScenario: (isAlt) ? (this.hasAlternateScenario) : false,//(this.altScenario) ? 1 : 0,
        AlternateScenario: (isAlt) ? (this.hasAlternateScenario) ? JSON.stringify(this.altScenario) : null : null,
        AlternateProfile: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.profileInfo.value) : null : null,
        AlternateSpouseProfile: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.spouseProfileInfo.value) : null : null,
        AlternateIncomeRangeSelection: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.incomeRangeSelectionForm.value) : null : null,
        OriginalScenario: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.orgScenario) : null : null,
        
        CareTypes: JSON.stringify(this.selfTypeList),
        CareTypes1: JSON.stringify(this.spouseTypeList),
        SpouseDOB: spouseDOB,
        SelfDOB: this.client.client.DOB,
        isQuickReport: true
      }
      console.log('ReportLTC', ReportLTC);
      console.log('Report', Report);
      this.globalService.createReportLTC(Report, ReportLTC)
      .subscribe(
      resp => {
        this.snackBarService.add("Please wait while your long-term care report is being generated.", 0);
        // console.log('resp.ReportTypeID')
        //this.router.navigateByUrl('/reports/create?d=t');
        this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
      },
      error => this.error = <any>error);

    } else { //Healthcare
      let spouseDOB = this.client.clientProfile.Spouses[0].dobStr ? this.client.clientProfile.Spouses[0].dobStr : (new Date(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : '');
      console.log('this.profileInfo.value.medicarePartB', this.profileInfo.value.medicarePartB);
      this.profileInfo.controls['MedicareAdvantageHMO'].enable();
      this.spouseProfileInfo.controls['MedicareAdvantageHMO'].enable();
      
      this.profileInfo.controls['MedicareAdvantagePPO'].enable();
      this.spouseProfileInfo.controls['MedicareAdvantagePPO'].enable();
      // need after NW release
      // this.isMedicareCoverageChange =  this.client.clientProfile.PremiumType == "TM" ? ((this.client.clientProfile.Premiums.MedicarePartB != this.profileInfo.value.MedicarePartB || this.client.clientProfile.Premiums.MedicarePartD != this.profileInfo.value.MedicarePartD || this.client.clientProfile.Premiums.SupplimentalInsurance != this.profileInfo.value.SupplimentalInsurance) ? true: this.isMedicareCoverageChange): this.isMedicareCoverageChange;
      // this.isMedicareCoverageChange = (this.client.clientProfile.Premiums.DentalInsurance != this.profileInfo.value.DentalInsurance || this.client.clientProfile.OOPCosts.HospitalAndTest != this.profileInfo.value.HospitalAndTest || this.client.clientProfile.OOPCosts.PrescriptionDrugs != this.profileInfo.value.PrescriptionDrugs || this.client.clientProfile.OOPCosts.HearingAndVisionCosts != this.profileInfo.value.HearingAndVisionCosts || this.client.clientProfile.OOPCosts.DentalCosts != this.profileInfo.value.DentalCosts) ? true: this.isMedicareCoverageChange;
      // this.isMedicareCoverageChange = this.client.clientProfile.PremiumType == "HMO" ? (this.client.clientProfile.Premiums.MedicareAdvantageHMO !=  this.profileInfo.value.MedicareAdvantageHMO || this.client.clientProfile.Premiums.MedicareAdvantagePPO !=  this.profileInfo.value.MedicareAdvantagePPO) ? true : this.isMedicareCoverageChange : this.isMedicareCoverageChange;
      // if (this.includeSpouse) {
      //   this.isMedicareCoverageChange =  this.client.clientProfile.SpousePremiumType == "TM" ? ((this.client.clientProfile.Premiums.SpouseMedicarePartB != this.spouseProfileInfo.value.MedicarePartB || this.client.clientProfile.Premiums.SpouseMedicarePartD != this.spouseProfileInfo.value.MedicarePartD || this.client.clientProfile.Premiums.SpouseSupplimentalInsurance != this.spouseProfileInfo.value.SupplimentalInsurance) ? true: this.isMedicareCoverageChange): this.isMedicareCoverageChange;
      //   this.isMedicareCoverageChange = (this.client.clientProfile.Premiums.SpouseDentalInsurance != this.spouseProfileInfo.value.DentalInsurance || this.client.clientProfile.OOPCosts.SpouseHospitalAndTest != this.spouseProfileInfo.value.HospitalAndTest || this.client.clientProfile.OOPCosts.SpousePrescriptionDrugs != this.spouseProfileInfo.value.PrescriptionDrugs || this.client.clientProfile.SpouseOOPCosts.HearingAndVisionCosts != this.spouseProfileInfo.value.HearingAndVisionCosts || this.client.clientProfile.OOPCosts.SpouseDentalCosts != this.spouseProfileInfo.value.DentalCosts) ? true: this.isMedicareCoverageChange;
      //   this.isMedicareCoverageChange = this.client.clientProfile.SpousePremiumType == "HMO" ? (this.client.clientProfile.Premiums.SpouseMedicareAdvantageHMO !=  this.spouseProfileInfo.value.MedicareAdvantageHMO || this.client.clientProfile.Premiums.SpouseMedicareAdvantagePPO !=  this.spouseProfileInfo.value.MedicareAdvantagePPO) ? true : this.isMedicareCoverageChange : this.isMedicareCoverageChange;
      // }
      console.log('this.client.clientProfile.IsPrivHealthIns', this.client.clientProfile.IsPrivHealthIns);
      console.log('this.isPre65', this.isPre65)      
      var ReportHC = {
        //NOTE: removed the 'nativeElement' functionality since this is going to be driven by the new client object
         //pull data from the client 
      
       // ID: 0,
       InvestmentItems: JSON.stringify({ InvestmentItems: { Items: investmentItems } }),
 /*    P_Part_A_And_B: this.hdt.nativeElement.checked ? 1 : 0,
       P_Part_D: this.pd.nativeElement.checked ? 1 : 0,
       P_MediGap: this.si.nativeElement.checked ? 1 : 0,
       P_Dental: this.di.nativeElement.checked ? 1 : 0,
       OOP_Hosp_Docs: this.hd.nativeElement.checked ? 1 : 0,
       OOP_Presc_Drug: this.pdrg.nativeElement.checked ? 1 : 0,
       OOP_Hearing_Vision: this.hvc.nativeElement.checked ? 1 : 0,
       OOP_Dental: this.dins.nativeElement.checked ? 1 : 0, */
      //  P_Part_A_And_B: 1,
      //  P_Part_D: 1,
      //  P_MediGap: 0,
      //  P_Dental: 0,
      //  OOP_Hosp_Docs: 0,
      //  OOP_Presc_Drug: 0,
      //  OOP_Hearing_Vision: 0,
      //  OOP_Dental: 0,

      //client
      P_Part_A_And_B: this.client.clientProfile.PremiumType == "TM" && this.client.clientProfile.Premiums.MedicarePartB ? 1 : 0,//.profileInfo.value.MedicarePartB ? 1 : 0,//this.hdt ? this.hdt.nativeElement.checked ? 1 : 0 : 1,
      P_Part_D: this.client.clientProfile.PremiumType == "TM" && this.client.clientProfile.Premiums.MedicarePartD ? 1 : 0,//this.profileInfo.value.MedicarePartD ? 1 : 0,//this.pd ? this.pd.nativeElement.checked ? 1 : 0 : 1,
      P_MediGap: this.client.clientProfile.PremiumType == "TM" && this.client.clientProfile.Premiums.SupplimentalInsurance ? 1 : 0,//this.profileInfo.value.SupplimentalInsurance ? 1 : 0,//this.si ? this.si.nativeElement.checked ? 1 : 0 : 0,
      P_Dental: this.client.clientProfile.PremiumType && this.client.clientProfile.Premiums.DentalInsurance ? 1 : 0,//this.profileInfo.value.DentalInsurance ? 1 : 0,//this.di ? this.di.nativeElement.checked ? 1 : 0 : 0,
      P_Advantage: ((this.client.clientProfile.PremiumType == 'HMO') || (this.client.clientProfile.PremiumType == 'PPO')) ? 1 : 0,
      OOP_Hosp_Docs: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.HospitalAndTest ? 1 : 0,//this.profileInfo.value.HospitalAndTest ? 1 : 0,//this.hd ? this.hd.nativeElement.checked ? 1 : 0 : 0,
      OOP_Presc_Drug: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.PrescriptionDrugs ? 1 : 0,//this.profileInfo.value.PrescriptionDrugs ? 1 : 0,//this.pdrg ? this.pdrg.nativeElement.checked ? 1 : 0 : 0,
      OOP_Hearing_Vision: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.HearingAndVisionCosts ? 1 : 0,//this.profileInfo.value.HearingAndVisionCosts ? 1 : 0,//this.hvc ? this.hvc.nativeElement.checked ? 1 : 0 : 0,
      OOP_Dental: this.client.clientProfile.PremiumType && this.client.clientProfile.OOPCosts.DentalCosts ? 1 : 0,//this.profileInfo.value.DentalCosts ? 1 : 0,//this.dins ? this.dins.nativeElement.checked ? 1 : 0 : 0,
      
      //spouse/partner
      P_Part_A_And_B1: this.partnerActive ? this.client.clientProfile.SpousePremiumType == "TM" && this.client.clientProfile.SpousePremiums.SpouseMedicarePartB ? 1 : 0 : 0,//this.spouseProfileInfo.value.MedicarePartB ? 1 : 0 : 0,
      P_Part_D1: this.partnerActive ? this.client.clientProfile.SpousePremiumType == "TM" && this.client.clientProfile.SpousePremiums.SpouseMedicarePartD ? 1 : 0 : 0,//this.spouseProfileInfo.value.MedicarePartD ? 1 : 0 : 0,
      P_MediGap1: this.partnerActive ? this.client.clientProfile.SpousePremiumType == "TM" && this.client.clientProfile.SpousePremiums.SpouseSupplimentalInsurance ? 1 : 0 : 0,//this.spouseProfileInfo.value.SupplimentalInsurance ? 1 : 0 : 0,
      P_Dental1: this.partnerActive ? this.client.clientProfile.SpousePremiums ? this.client.clientProfile.SpousePremiums.SpouseDentalInsurance ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.DentalInsurance ? 1 : 0 : 0,
      P_Advantage1: this.partnerActive ?  ((this.client.clientProfile.SpousePremiumType == 'HMO') || (this.client.clientProfile.SpousePremiumType == 'PPO')) ? 1 : 0 : 0,//((this.spouseProfileInfo.value.MedicareAdvantageHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.MedicareAdvantagePPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
      OOP_Hosp_Docs1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHospitalAndTest ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.HospitalAndTest ? 1 : 0 : 0,
      OOP_Presc_Drug1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpousePrescriptionDrugs ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.PrescriptionDrugs ? 1 : 0 : 0,
      OOP_Hearing_Vision1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseHearingAndVisionCosts ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.HearingAndVisionCosts ? 1 : 0 : 0,
      OOP_Dental1: this.partnerActive ? this.client.clientProfile.SpouseOOPCosts? this.client.clientProfile.SpouseOOPCosts.SpouseDentalCosts ? 1 : 0 : 0 : 0,//this.spouseProfileInfo.value.DentalCosts ? 1 : 0 : 0,

       FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
       FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
       FrmHasPartner: this.partnerActive,
       FrmQType: this.client.clientProfile.HCT1D,
       FrmQExcercise: 1,
       FrmGender: this.client.client.GenderID,
       FrmQTypeII: this.client.clientProfile.HCT2D,
       FrmQTobacco: this.client.clientProfile.HCT,
       FrmQCancer: this.client.clientProfile.HCC,
       FrmQHistory: this.client.clientProfile.HCFHDC,
       FrmQCardio: this.client.clientProfile.HCCD,
       FrmQPhysical: 1,
       FrmQHighColesterol: this.client.clientProfile.HCHC,
       FrmQDiet: 1,
       FrmQHBP: this.client.clientProfile.HCHBP,
       FrmQDCW: this.client.clientProfile.HCDCW,
       FrmQMS: this.client.clientProfile.HCMS,

       FrmQAlzheimer: this.client.clientProfile.HCALZ,
      FrmQParkinson: this.client.clientProfile.HCPARK,
      FrmQPTSD: this.client.clientProfile.HCPTSD,
      FrmQAmputation: this.client.clientProfile.HCAMP,
      FrmQObesity: this.client.clientProfile.HCOBS,

       FrmCurrentAge: this.calculateAge(this.client.client.DOB),
 
       FrmPlanUntil: this.currentScenario.clientRetirementHorizon,//this.hcDataV2.PlanUntilYear,
       FrmPlanUntil0: this.currentScenario.clientRetirementHorizon,//this.hcDataV2.PlanUntilYear,
       FrmPlanUntil1: this.currentScenario.spouseRetirementHorizon,//this.hcDataV2.PlanUntil1,
       SpouseFrmPlanUntil: this.currentScenario.spouseRetirementHorizon,//this.hcDataV2.PlanUntil1,
 
       SpouseFrmQTobacco: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT ? 1 : 0 : 0,
       SpouseFrmQCancer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCC ? 1 : 0 : 0,
       SpouseFrmQDiet: 1,
       SpouseFrmQCardio: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCCD ? 1 : 0 : 0,
       SpouseFrmQPhysical: 1,
       SpouseFrmGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].gender : 0,
       SpouseQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
       SpouseFrmQHBP: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHBP ? 1 : 0 : 0,
       
       SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) : 0,
       SpouseFrmQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
       SpouseQHighColesterol: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCHC ? 1 : 0 : 0,
       SpouseQTypeII: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT2D ? 1 : 0 : 0,
       SpouseFrmQDCW: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCDCW ? 1 : 0 : 0,
       SpouseFrmQMS: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCMS ? 1 : 0 : 0,
       SpouseFrmQType: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCT1D ? 1 : 0 : 0,

       SpouseFrmQAlzheimer: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCALZ ? 1 : 0 : 0,
        SpouseFrmQParkinson: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPARK ? 1 : 0 : 0,
        SpouseFrmQPTSD: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCPTSD ? 1 : 0 : 0,
        SpouseFrmQAmputation: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCAMP ? 1 : 0 : 0,
        SpouseFrmQObesity: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCOBS ? 1 : 0 : 0,
        SpouseFrmQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,

       
       SpouseQExcercise: 1,
       SpouseQHistory: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].HCFHDC ? 1 : 0 : 0,
 
       PaymentTotal: 0,
       //PaymentYears: 10,
       PaymentYears: this.annualEl && this.annualEl.nativeElement ? this.annualEl.nativeElement.value : 10,
         
       FrmPhase1Rate: 6.0,
       FrmPhase1Periods: 65 - this.calculateAge(this.client.client.DOB),
       FrmPhase2Rate: 6.0,
       FrmPhase2Periods: (75 - 65),
       FrmPhase3Rate: 6.0,
 
       FrmRetireYear1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 
        ? Math.max(currentYear,this.getRetirementYear(this.currentScenario.spouseRetirementAge, this.client.clientProfile.Spouses[0].dob)) : 0,
       FrmPV: this.FrmPV,
      //  FrmRetireYear0: this.getRetirementYear(this.currentScenario.clientRetirementAge, this.client.client.DOB),
       FrmRetireYear0: Math.max(currentYear, this.getRetirementYear(this.currentScenario.clientRetirementAge, this.client.client.DOB)),
       
       FrmState: this.currentScenario.clientRetirementState,//this.client.clientProfile.RetirementState,
       FundCosts: this.currentScenario.clientTotalHCC + this.currentScenario.spouseTotalHCC,//this.futureTotalCost,
 
       SelfLifeExpectancy: this.currentScenario.clientLifeExpectancy,//this.client.clientProfile.LifeExpectancy || 0,
       SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse 
        ? this.currentScenario.spouseLifeExpectancy//this.client.clientProfile.Spouses[0].LifeExpectancy || 0 
        : 0,
       InvestmentOption: this.investmentOption || 1,
       UseNationalAverage: this.client.clientProfile.UseNationalAverage ? 1 : 0,

       SpouseDOB: spouseDOB,//this.client.clientProfile.Spouses[0].dobStr,
       SelfDOB: this.client.client.DOB,

       SelfRetirementAge: this.currentScenario.clientRetirementAge,//this.client.clientProfile.RetirementAge,
       SpouseRetirementAge: this.currentScenario.spouseRetirementAge,//this.client.clientProfile.Spouses[0].retirementAge,
       MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,
       Bracket: this.currentScenario.householdIncomeBracket,//this.client.clientProfile.Bracket,       
       BracketRange: this.selectedIRMAABracketDisplay,
       // FrmIncome: (this.currentScenario.householdIncomeBracket) ? (this.includeSpouse) ? "Mfj" + this.currentScenario.householdIncomeBracket : "Ind" + this.currentScenario.householdIncomeBracket : this.hcDataV2.FrmIncome,
       // FrmIncome: this.hcDataV2.FrmIncome,
       FrmIncome: this.orgFrmIncome,
       // HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome,
       HouseholdYearOneIncome: this.currentScenario.householdYearOneIncome,

       // PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate,
       PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 0.03 : this.client.clientProfile.InflationRate / 100,
       InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 0.03 : this.client.clientProfile.InRetirementInflationRate / 100,  
       FrmState1: this.currentScenario.spouseRetirementState,//this.client.clientProfile.Spouses[0].state || '',

       SelfIRR: (this.client.clientProfile.IRR != null && this.client.clientProfile.IRR != undefined) ? this.client.clientProfile.IRR : 0,
       SpousePIA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
       //PremiumType: this.profileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.profileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2,
       PremiumType: this.client.clientProfile.PremiumType == 'TM' ? 0 : this.client.clientProfile.PremiumType == 'HMO' ? 1 : 2,
       //PremiumType1: (this.partnerActive) ? this.spouseProfileInfo.value.inRetirementCoverageType == 'TM' ? 0 : this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO' ? 1 : 2 : 0,
       PremiumType1: (this.partnerActive) ? this.client.clientProfile.SpousePremiumType == 'TM' ? 0 : this.client.clientProfile.SpousePremiumType == 'HMO' ? 1 : 2 : 0,
       PrivateInsurance: this.calculateAge(this.client.client.DOB) < 65 && this.client.clientProfile.IsPrivHealthIns ? 1 : 0,// this.client.clientProfile.SpousePremiumType == "TM"
       PrivateInsurance1: this.client.clientProfile.SpouseCoverageType ? this.client.clientProfile.IsSpousePrivHealthIns ? 1 : 0 : ((this.partnerActive) && this.calculateAge(this.client.clientProfile.Spouses[0].dob) < 65 && (this.client.clientProfile.IsSpousePrivHealthIns ? 1 : 0)? 1 : this.client.clientProfile.IsSpousePrivHealthIns ? 1 : 0),
       
       //SelfCurrentIncome: (this.currentScenario.householdYearOneIncome) ? this.currentScenario.householdYearOneIncome : (this.client.clientProfile.CurrentIncome != null && this.client.clientProfile.CurrentIncome != undefined) ? this.client.clientProfile.CurrentIncome : 0,
       SelfCurrentIncome: (this.currentScenario.householdYearOneIncome) ? this.currentScenario.householdYearOneIncome : (this.currentScenario.clientCurrentIncome) ? this.currentScenario.clientCurrentIncome : 0,
       //SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
       SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.incomeRangeSelectionForm.value.IncomeOption != 1 ? Number(this.client.clientProfile.Spouses[0].currentIncome) || 0 : 0,
       // P_Advantage: ((this.profileInfo.value.medicareAdvHMO && this.profileInfo.value.inRetirementCoverageType == 'HMO') || (this.profileInfo.value.medicareAdvPPO && this.profileInfo.value.inRetirementCoverageType == 'PPO'))? 1 : 0,
       // P_Advantage1: this.partnerActive ? ((this.spouseProfileInfo.value.medicareAdvHMO && this.spouseProfileInfo.value.inRetirementCoverageType == 'HMO') || (this.spouseProfileInfo.value.medicareAdvPPO && this.spouseProfileInfo.value.inRetirementCoverageType == 'PPO')) ? 1 : 0 : 0,
       CoverageType: this.client.clientProfile.CoverageType == 'PPO' ? 0 : this.client.clientProfile.CoverageType == 'HMO' ? 1 : 2,
       CoverageType1: (this.partnerActive) ? this.client.clientProfile.SpouseCoverageType == 'PPO' ? 0 : this.client.clientProfile.SpouseCoverageType == 'HMO' ? 1 : 2 : 0,
       //CoverageType: this.client.clientProfile.CoverageType,
       //CoverageType1: (this.partnerActive) ? this.client.clientProfile.SpouseCoverageType : 0,
       MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,
       MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year : 0,
       MidRetRedPer:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,/// 100 : 0,
       MidRetRedDollar:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
       MidRetIncomeInflationRate: this.client.midRetirementAdj ? (this.client.midRetirementAdj.IncomeInflationRate) : 0,// / 100 : 0,
       
       SelfSupplementalPlan: this.client.clientProfile.SelfSupplementalPlan,//this.profileInfo.value.supplementalPlanType,
       SpouseSupplementalPlan: (this.partnerActive) ? this.client.clientProfile.SpouseSupplementalPlan : "",//this.spouseProfileInfo.value.supplementalPlanType : "",

       /* HasAlternateScenario: (this.hasAlternateScenario),//(this.altScenario) ? 1 : 0,
       AlternateScenario: (this.hasAlternateScenario) ? JSON.stringify(this.altScenario) : null,
       AlternateProfile: (this.hasAlternateScenario) ? JSON.stringify(this.profileInfo.value) : null,
       AlternateSpouseProfile: (this.hasAlternateScenario) ? JSON.stringify(this.spouseProfileInfo.value) : null,
       AlternateIncomeRangeSelection: (this.hasAlternateScenario) ? JSON.stringify(this.incomeRangeSelectionForm.value) : null,
       OriginalScenario: (this.hasAlternateScenario) ? JSON.stringify(this.orgScenario) : null, */

      HasAlternateScenario: (isAlt) ? (this.hasAlternateScenario) : false,//(this.altScenario) ? 1 : 0,
      AlternateScenario: (isAlt) ? (this.hasAlternateScenario) ? JSON.stringify(this.altScenario) : null : null,
      AlternateProfile: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.profileInfo.value) : null : null,
      AlternateSpouseProfile: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.spouseProfileInfo.value) : null : null,
      AlternateIncomeRangeSelection: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.incomeRangeSelectionForm.value) : null : null,
      OriginalScenario: (isAlt) ?  (this.hasAlternateScenario) ? JSON.stringify(this.orgScenario) : null : null,
      // HasIncomeChange: this.isIncomeChange, // need after NW release
      // HasMedicareCoverageChange: this.isMedicareCoverageChange // need after NW release
     }

     if(this.client.clientProfile.PremiumType != 'TM'){
      ReportHC.P_Part_A_And_B = 1;
    }

    if (this.partnerActive) {
      if(this.client.clientProfile.SpousePremiumType != 'TM'){
        ReportHC.P_Part_A_And_B1 = 1;
      }
    }

     console.log('ReportHC', ReportHC);
     console.log('Report', Report)
      this.globalService.createReportHC(Report, ReportHC)
        .subscribe(
          resp => {
            this.snackBarService.add("Please wait while your healthcare report is being generated.", 0);
            // this.router.navigate(['/reports/create']);
            //this.router.navigateByUrl('/reports/create?d=t');

            //HACK: since we save the form objs in DB and use the disable/enable to force a premiums to be selected
            //it causes issues to save a disabled form field - so, we need to enable and then disable again
            this.profileInfo.controls['MedicareAdvantageHMO'].disable();
            this.spouseProfileInfo.controls['MedicareAdvantageHMO'].disable();
            this.profileInfo.controls['MedicareAdvantagePPO'].disable();
            this.spouseProfileInfo.controls['MedicareAdvantagePPO'].disable();

            this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
            /* if (this.altScenario.clientTotalHCC) {
              console.log('this.clientModelV2.generalInformation', this.clientModelV2.generalInformation);
              console.log('this.orgScenario', this.orgScenario);
              console.log('this.altScenario', this.altScenario);
              console.log('this.tabs', this.tabs);
              let retirementAge = this.clientModelV2.generalInformation.retirementAge;
              let retirementLocation = this.clientModelV2.generalInformation.retirementState;;
              let lifeExpectancy = this.clientModelV2.healthInformation.lifeExpectancy;
              let pre65HCCoverage = (this.profileInfo.value.privateHealthInsurance == 'true' ||  this.profileInfo.value.privateHealthInsurance == true)? this.profileInfo.value.preRetirementCoverageType: null;
              let medicareCoverage = this.profileInfo.value.MedicarePartB ? 'Part B': '';
              medicareCoverage += this.profileInfo.value.MedicarePartD ? medicareCoverage ? ' ,':''+ 'Part D': '';
              medicareCoverage += this.profileInfo.value.SupplimentalInsurance ? medicareCoverage ? ' ,':'' + 'Supplimental Insurance': '';
              medicareCoverage += this.profileInfo.value.MedicareAdvantagePPO ? medicareCoverage ? ' ,':'' + 'Med. Adv. PPO': '';
              medicareCoverage += this.profileInfo.value.MedicareAdvantageHMO ? medicareCoverage ? ' ,':'' + 'Med. Adv. HMO': '';
              medicareCoverage += this.profileInfo.value.DentalInsurance ? (medicareCoverage != '' ? ', ':'') + 'Dental': '';
              let oOPCost = this.profileInfo.value.HospitalAndTest ? 'Hosp/Docs/Tests' : '';
              oOPCost += this.profileInfo.value.PrescriptionDrugs ? (oOPCost != '' ? ', ':'') + 'Rx' : '';
              oOPCost += this.profileInfo.value.HearingAndVisionCosts ? (oOPCost != '' ? ', ':'') + 'Hearing/Vision' : '';
              oOPCost += this.profileInfo.value.DentalCosts ? (oOPCost != '' ? ', ':'') + 'Dental' : '';
              let orgTotalCombinedHCCosts = this.orgScenario.totalCombinedHCC;
              let orgTotalCombinedHCYears = this.orgScenario.totalCombinedHCYears;
              let orgSSDeduction = this.orgScenario.socialSecurityInvestment;
              // passing empty string if not altScenario
              let altTotalCombinedHCCosts = this.tabs.length > 0 ? this.altScenario.totalCombinedHCC : '';
              let altTotalCombinedHCYears = this.altScenario.totalCombinedHCYears;
              let altSSDeduction = this.altScenario.socialSecurityInvestment;
              let orgAvgAnnualHCCosts = Math.round(Number(orgTotalCombinedHCCosts)/Number(orgTotalCombinedHCYears));
              let altAvgAnnualHCCosts = Math.round(Number(altTotalCombinedHCCosts)/Number(altTotalCombinedHCYears));
              this.bracketChange(Number(this.incomeRangeSelectionForm.value.BracketValue || '0')) ;
              let income = this.responseMMTBracket && this.incomeRangeSelectionForm.value.IncomeOption == 1 ? this.selectedIRMAABracketDisplay: (this.incomeRangeSelectionForm.value.IncomeOption == 2 || this.incomeRangeSelectionForm.value.IncomeOption == 3 ? this.profileInfo.value.IncomeValue : null);
              if (this.clientModelV2.maritalStatus.maritalStatus === 'Married') {
                let spouseRetirementAge = this.clientModelV2.maritalStatus.retirementAge;
                let spouseRetirementLocation = this.clientModelV2.maritalStatus.retirementState;
                let spouseLifeExpectancy = this.clientModelV2.maritalStatus.lifeExpectancy;
                let spousePre65HCCoverage = (this.spouseProfileInfo.value.privateHealthInsurance == 'true' ||  this.spouseProfileInfo.value.privateHealthInsurance == true)? this.spouseProfileInfo.value.preRetirementCoverageType: null;;
                let spouseMedicareCoverage = null;
                let spouseoOPCost = null;
                if (!this.profileInfo.value.IsSpouseSameHCSelection) {
                  spouseMedicareCoverage = this.spouseProfileInfo.value.MedicarePartB ? 'Part B': '';
                  spouseMedicareCoverage += this.spouseProfileInfo.value.MedicarePartD ? (spouseMedicareCoverage != '' ? ', ':'') + 'Part D': '';
                  spouseMedicareCoverage += this.spouseProfileInfo.value.SupplimentalInsurance ? (spouseMedicareCoverage != '' ? ', ':'') +'Supplimental Insurance': '';
                  spouseMedicareCoverage += this.spouseProfileInfo.value.MedicareAdvantageHMO ? (spouseMedicareCoverage != '' ? ', ':'') +'Med. Adv. HMO': '';
                  spouseMedicareCoverage += this.spouseProfileInfo.value.MedicareAdvantagePPO ? (spouseMedicareCoverage != '' ? ', ':'') +'Med. Adv. PPO': '';
                  spouseMedicareCoverage += this.spouseProfileInfo.value.DentalInsurance ? (spouseMedicareCoverage != '' ? ', ':'') +'Dental': '';
                  spouseoOPCost =  this.spouseProfileInfo.value.HospitalAndTest ? 'Hosp/Docs/Tests' : '';
                  spouseoOPCost += this.spouseProfileInfo.value.PrescriptionDrugs ? (spouseoOPCost != '' ? ', ':'') +'Rx' : '';
                  spouseoOPCost += this.spouseProfileInfo.value.HearingAndVisionCosts ? (spouseoOPCost != '' ? ', ':'') +'Hearing/Vision' : '';
                  spouseoOPCost += this.spouseProfileInfo.value.DentalCosts ? (spouseoOPCost != '' ? ', ':'') +'Dental' : '';
                }

                this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID, 
                  income, retirementAge, retirementLocation, lifeExpectancy, pre65HCCoverage, medicareCoverage, oOPCost, orgTotalCombinedHCCosts, orgAvgAnnualHCCosts, orgSSDeduction, altTotalCombinedHCCosts, altAvgAnnualHCCosts, altSSDeduction, spouseRetirementAge, spouseRetirementLocation, spouseLifeExpectancy, spousePre65HCCoverage, spouseMedicareCoverage, spouseoOPCost);
              } else {
                this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID, 
                  income, retirementAge, retirementLocation, lifeExpectancy, pre65HCCoverage, medicareCoverage, oOPCost, orgTotalCombinedHCCosts, orgAvgAnnualHCCosts, orgSSDeduction, altTotalCombinedHCCosts, altAvgAnnualHCCosts, altSSDeduction);
              }

              

            } else {
              this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
            } */
          },
          error => this.error = <any>error);
      }
  }

  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {//, 
    //income = null, retirementAge = null, retirementLocation = null, lifeExpectancy = null, pre65HCCoverage = null, 
    //medicareCoverage = null, oOPCost = null, orgTotalCombinedHCCosts = null, orgAvgAnnualHCCosts = null, orgSSDeduction = null, altTotalCombinedHCCosts = null, 
    //altAvgAnnualHCCosts = null, altSSDeduction = null, spouseRetirementAge = null, spouseRetirementLocation = null, spouseLifeExpectancy = 0, 
    //spousePre65HCCoverage = null, spouseMedicareCoverage = null, spouseoOPCost = null) {
    this.loadingService.isLoading(true);
    console.log(this.orgScenario.totalCombinedHCC, this.orgScenario.totalCombinedHCYears, this.altScenario.totalCombinedHCC, this.altScenario.totalCombinedHCYears);//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.futureTotalCost + this.futureTotalCost : this.futureTotalCost,
    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, isQuickReport: 'true', token: localStorage.getItem("bearer"), 
      //income, retirementAge, retirementLocation, lifeExpectancy, pre65HCCoverage, medicareCoverage, oOPCost, orgTotalCombinedHCCosts, 
      //orgAvgAnnualHCCosts, orgSSDeduction, altTotalCombinedHCCosts, altAvgAnnualHCCosts, altSSDeduction, spouseRetirementAge, 
      //spouseRetirementLocation, spouseLifeExpectancy, spousePre65HCCoverage, spouseMedicareCoverage, spouseoOPCost 
    };

    console.log ('ReportFields', ReportFields)
    this.globalService.generateReport(ReportFields, this.client.client, ReportFields, this.hasAlternateScenario)
      .subscribe(
        resp => {;
          this.loadingService.isLoading(false);
        },
        error => {
          this.error = <any>error;
          this.loadingService.isLoading(false);
        });
  }

  stateChange(state, isClient){
    //console.log('state selected', value);
    //set to State Average when state is adjusted
    if(isClient){
      this.retirementAreaForm.controls['clientMetroRegion'].setValue('0');
      this.clientLTCMetroRegions = null;
    } else {
      this.retirementAreaForm.controls['spouseMetroRegion'].setValue('0');
      this.spouseLTCMetroRegions = null;
    }
    
    if(this.retirementAreaForm.value.clientRetirementState != "NA" && isClient
      || this.retirementAreaForm.value.spouseRetirementState != "NA" && !isClient
    ){
      this.getLTCStateRegions(state, isClient);
    }
  }

  getLTCStateRegions(state, isClient){    
    this.globalService.getLTCStateRegions(state)
      .subscribe(
          data => {
            console.log('metro regions', data);
            if(isClient){
              this.clientLTCMetroRegions = data;  
            } else {
              this.spouseLTCMetroRegions = data;  
            }
            
            //we need to do a check to make this backwards compatible for already existing clients
            /* if(client.clientProfile.ClientMetroArea == ''){
              if(this.responseLTCMetroRegions.Rows.some(item => item.MetroRegionCode != client.clientProfile.ClientMetroArea)){
                //if in here, we need to set metro region to 'State Average'
                this.retireInfo.controls['retirementStateMetroArea'].setValue('0');
              }
            } */
          },
          error => console.log(error));
  }

  getRegionDescription(state, code, isClient) {
    console.log('is client', isClient);
    let description = "";
    let region = isClient ? this.clientRegions : this.spouseRegions;
    console.log('region', region);
    region.forEach((row) => {
      if (row.MetroRegionCode == code && row.StateCode == state)
        description = row.MetroRegion;
    });

    description = description.length ? description : "State Average";
    return description;
  }

  getRetirementYear(retirementAge, dob) {
    console.log('retirementAge', retirementAge);
    console.log('dob', dob);
    var currentAge = this.calculateAge(dob);
    var diff = retirementAge - currentAge;
    var year = new Date().getFullYear();
    console.log('year + diff;', year + diff)
    return year + diff;
  }

  formatPercent(percentage) {
    return (percentage * 100).toFixed(0);
  }

  addFunds: boolean;
  //rateControl = new FormControl("", [Validators.max(100), Validators.min(0)])
  handleNewFundingItem(fundingSource: string, annContribution: any, startAge: number, endAge: number, inflationRate: number) {

    this.addFunds = true;

    //check year here
    if (startAge < this.currentYear) {
      startAge = this.currentYear;
    }

    if (endAge < startAge || endAge > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear) {
      endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
    }

    annContribution = Utils.formatToNumber(annContribution)
    var contributionAmount = this.getFutureContributionAmountV2(annContribution, endAge - startAge, inflationRate, startAge, null);

    this.fundingItems.push({
      fundingSource,
      annContribution,
      startAge,
      endAge,
      inflationRate,
      contributionAmount: this.formatNumber(contributionAmount),
      remainingUnfunded: this.formatNumber(this.totalRemainingGap)
    });


    this.fundingSourceInput.nativeElement.value = '';
    this.annContributionInput.nativeElement.value = '';
    this.startAgeInput.nativeElement.value = '';
    this.endAgeInput.nativeElement.value = '';
    this.inflationRateInput.nativeElement.value = '';


    this.getHCData(this.client, this.partnerActive);

  }

  getFutureValue(startAmount, years, inflation) {
    inflation = inflation / 100;
    var total = 0;


    for (var i = 0; i <= years; i++) {
      total = total + startAmount * Math.pow(1 + inflation, i);
    }

    return total;
  }

  getFutureValueOfCost(startAmount, years, inflation) {
    return startAmount * Math.pow(1 + inflation, years);
  }

  getFutureContributionAmountV2(startAmount, years, inflation, startAge, idx) {
    var result = 0;

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
    }

    return result;
  }

  getFutureContributionAmount(startAmount, years, inflation, startAge, idx) {
    var startingBalance = 0;
    var interestEarned = 0;
    var contribution = Number(startAmount);
    var endingBalance = Number(startAmount);
    startAge = Number(startAge);

    for (let i = 0; i < years; i++) {
      if (startAge + i <= this.p1EndAge.nativeElement.value) {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p1Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      } else if (startAge + i <= this.p2EndAge.nativeElement.value) {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p2Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      } else {
        startingBalance = endingBalance;
        interestEarned = startingBalance * (Number(this.p3Percent.nativeElement.value) / 100);
        contribution = contribution * (1 + (inflation / 100));
        endingBalance = startingBalance + interestEarned + contribution;
      }
    }

    if (idx != null) {
      // this.fundingItems[idx].annContribution = endingBalance;
      this.fundingItems[idx].remainingUnfunded = Number(this.totalRemainingGap - endingBalance).toFixed(0);
      this.fundingItems[idx].contributionAmount = Number(endingBalance).toFixed(0);
    }

    return Number(endingBalance).toFixed(0);
  }

  onRateChange(percentValue) {

    //get HC data
    this.getHCData(this.client, this.partnerActive);

    //check value
    if (percentValue != undefined) {
      if (percentValue.value > 12) {
        //percentValue.id 
        return percentValue.value = 12;
      }
    }
  }

  public visible: boolean = true;

  calculateCoverageTotal(el?: any, amount?: number, isPremium?: boolean, coverageKeyName?: string[]) {


    this.premiumExpenses = {
      partB: this.hdt.nativeElement.checked,
      partD: this.pd.nativeElement.checked,
      medigap: this.si.nativeElement.checked,
      dental: this.di.nativeElement.checked
    };

    this.outOfPocketExpenses = {
      hospitalization: this.hd.nativeElement.checked,
      docsTests: this.hd.nativeElement.checked,
      rx: this.pdrg.nativeElement.checked,
      dental: this.dins.nativeElement.checked,
      hearingServices: this.hvc.nativeElement.checked,
      vision: this.hvc.nativeElement.checked,
      commercial: true
    };



    if (
      !this.premiumExpenses.partB &&
      !this.premiumExpenses.partD &&
      !this.premiumExpenses.medigap &&
      !this.premiumExpenses.dental &&
      !this.outOfPocketExpenses.hospitalization &&
      !this.outOfPocketExpenses.docsTests &&
      !this.outOfPocketExpenses.rx &&
      !this.outOfPocketExpenses.dental &&
      !this.outOfPocketExpenses.hearingServices &&
      !this.outOfPocketExpenses.vision
    ) {
      this.visible = false;
      this.hcDataV2 = this.sample;

    } else {
      this.visible = true;
      this.getHCData(this.client, this.partnerActive);

      this.coverageTotal = el.checked ? this.coverageTotal + this.formatNumber(amount) : this.coverageTotal - this.formatNumber(amount);

      if (isPremium)
        this.premiumCoverageTotal = el.checked ? this.premiumCoverageTotal + this.formatNumber(amount) : this.premiumCoverageTotal - this.formatNumber(amount);
      else
        this.outOfPocketCoverageTotal = el.checked ? this.outOfPocketCoverageTotal + this.formatNumber(amount) : this.outOfPocketCoverageTotal - this.formatNumber(amount);

      this.generateLineChartData({});
    }


  }

  animateValue(el, start, formattedNumber): void {
    var end = parseFloat(formattedNumber.shortValue);
    var current = start;
    var increment = start < 0 ? -1 : 1;
    var stepTime = Math.abs(1);

    if (formattedNumber.shortValue > 0) {
      el.nativeElement.innerHTML = `$${end.toFixed(2)}${formattedNumber.suffix || ''}`;

    } else {
      el.nativeElement.innerHTML = `$0`;
    }
  }

  roundAndFormat(num, fixed) {
    if (num === null) { return null; }
    if (num === 0) { return '0'; }
    fixed = (!fixed || fixed < 0) ? 0 : fixed;
    var b = (num).toPrecision(2).split("e"),
      k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
      c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
      d = c < 0 ? c : Math.abs(c),
      e = d + ['', 'K', 'M', 'B', 'T'][k];

    return { shortValue: e.split(/[A-z]/)[0], suffix: e.substring(e.length - 1, e.length) };
  }

  public weeklyCost: Number = 0;
  public yearlyCost: Number = 0;

  public futureYearlyCost: Number = 0;
  public futureWeeklyCost: Number = 0;

  calcAnnualSavings(el, el2) {

    el2.value = el.value;
    // el.value = el2.value;

    this.getHCData(this.client, this.partnerActive);

  }

  calcWeeklySavings(isAnnual) {
    if (isAnnual)
      this.weeklyEl.nativeElement.value = this.annualEl.nativeElement.value;
    else
      this.annualEl.nativeElement.value = this.weeklyEl.nativeElement.value;
    this.getHCData(this.client, this.partnerActive);

  }

  handleIllustrationModal(e) {
    var projectedYears = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
      return {
        Year: this.currentYear,
        BeginningBalance: Utils.formatToCurrency(entry.BeginningBalance ? entry.BeginningBalance.toFixed(0) : 0),
        ExpectedRateReturn: (entry.CashFlowEntry.ExpectedRor ? entry.CashFlowEntry.ExpectedRor * 100 + '%' : 0),
        // Premiums: '$' + 0,
        Contribution: Utils.formatToCurrency(entry.CashFlowEntry.Contribution > 0 ? entry.CashFlowEntry.Contribution.toFixed(0) : (entry.CashFlowEntry.TotalIncome + entry.CashFlowEntry.Contribution).toFixed(0)),
        // AdditionalCosts: '$' + 0,
        Total: Utils.formatToCurrency(entry.CashFlowEntry.Expense ? entry.CashFlowEntry.Expense.toFixed(0) : 0),
        NetOfSSDeductions: Utils.formatToCurrency(entry.CashFlowEntry.Expense.toFixed(0) - entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0)),
        EngingBalance: Utils.formatToCurrency(Math.abs((entry.EndingBalance ? entry.EndingBalance.toFixed(0) : 0))),
      }
    });


    this.modalService.add('hc-projections', { Data: projectedYears });
  }

  
  // calculatTotalNetHCAmount() {
  //   var netHCCosts = this.hcDataV2.IllustrationEntriesWithFunding.map(entry => {
  //     return {
  //       NetHCCost: entry.CashFlowEntry.Expense.toFixed(0) - entry.CashFlowEntry.HealthAllocatedIncome.toFixed(0),
  //     }
  //   });
  //   let totalNetHCCost: number = netHCCosts.map(a => a.NetHCCost).reduce(function(a, b)
  //   {
  //     return a + b;
  //   });
  //   this.totalNetHCCost = totalNetHCCost.toString();

  // console.log('netOfSSDeductions', this.totalNetHCCost)
  // }

  checkAllPremiums() {
    var enabled = this.pcheck.nativeElement.checked;

    this.hdt.nativeElement.checked = enabled;
    this.pd.nativeElement.checked = enabled;
    this.si.nativeElement.checked = enabled;
    this.di.nativeElement.checked = enabled;

    this.calculateCoverageTotal();

    //this.getHCData(this.client);
  }

  checkAllOOP() {
    var enabled = this.oopcheck.nativeElement.checked;

    this.hd.nativeElement.checked = enabled;
    this.hvc.nativeElement.checked = enabled;
    this.dins.nativeElement.checked = enabled;
    this.pdrg.nativeElement.checked = enabled;

    this.calculateCoverageTotal();
    //this.getHCData(this.client);
  }

  onRateSelected(rate) {
    if (rate === 1)
      this.investmentOption = 1;
    else if (rate === 2)
      this.investmentOption = 2;
    else if (rate === 3)
      this.investmentOption = 3;

    this.getHCData(this.client, this.partnerActive);
  }

  valueToggle(e) {
    this.FrmPV = e;//Number(e.target.value);
    this.getHCData(this.client, this.partnerActive);
  }

  spouseToggle(e) {    
    this.spouseHC = e;
  }

  formatPercentage(event, target, precision = 2){
    const key = event.keyCode || event.charCode;
    var value = event.target.value.replace('%', '');
    var values = value.split('.');
    const isNegative = value.substring(0, 1) === '-'

    if (!(/\d/.test(value)) && !isNegative) {
      value = ''
    } else {
      if(value.includes('.')) {
        values[0] = isNegative ? values[0].replace(/\D+/g, '') * -1 : values[0].replace(/\D+/g, '');
        values[1] = values[1].replace(/\D+/g, '');
        value = `${values[0]}.${values[1].substring(0, precision)}`
      } else {
        if (value < 0)
          value = value;
        else
          value = value === '-' ? '-' : value.replace(/\D+/g, '');
      }
    }
    
    var isDeleting = false;
    if (key === 8 || key === 46) {
      isDeleting = true;
    }

    //return value;
    if(target == 'IncomeReplacementRatio'){
      // this.isIncomeChange = true; // need after NW release
      this.incomeRangeSelectionForm.controls['IncomeReplacementRatio'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
    } else if(target == 'IncomeInflationRate'){
      // this.isIncomeChange = true; // need after NW release
      this.incomeRangeSelectionForm.controls['IncomeInflationRate'].patchValue((isDeleting) ? value : Utils.formatToPercentage(value));
    }
  }

  formatCurrency(val, target = "") {
    //return Utils.formatToCurrency(Utils.formatToNumber(val));
    if (target == '') {
      return Utils.formatToCurrency(val)
    } else {
      val = val.replace(/\D/g, '');
      if (val != '') {
        this.incomeRangeSelectionForm.controls['IncomeValue'].patchValue(Utils.formatToCurrency(val));
      } else {
        this.incomeRangeSelectionForm.controls['IncomeValue'].patchValue(Utils.formatToCurrency(''));
      }
    }
    // need after NW release
    // if (target == 'IncomeValue') {
    //   this.isIncomeChange = true;
    // }
  }

  formatNumber3(val) {

    return Utils.formatToNumber(val);
  }

  formatNumber4(val1) {

    return Utils.formatToNumber(val1);
  }


  textCheck() {
    if (this.fundingSource) {
      this.showFundingBorder = false;
    } else {
      this.showFundingBorder = true;
    }

    if ((this.annContribution) && (this.annContribution >= 100 && this.annContribution <= 1000000)) {
      this.showAnnContrBorder = false;
    } else {
      this.showAnnContrBorder = true;
    }

    if (this.startAge) {
      this.showStartAgeBorder = false;
    } else {
      this.showStartAgeBorder = true;
    }

    if (this.endAge) {
      this.showEndAgeBorder = false;
    } else {
      this.showEndAgeBorder = true;
    }

    if (this.inflationRate) {
      this.showInflationBorder = false;
    } else {
      this.showInflationBorder = true;
    }
    if (!this.fundingSource && !this.annContribution && !this.startAge && !this.endAge && !this.inflationRate) {
      this.showFundingBorder = false;
      this.showAnnContrBorder = false;
      this.showStartAgeBorder = false;
      this.showEndAgeBorder = false;
      this.showInflationBorder = false;
    }
  }

  fundingTableCount() {
    this.fundingItems;
    let count = this.fundingItems.length 
    if (count >= 1) {
      this.showTable = true;
    } else {
      this.showTable = false;      
    }
  }

  fundingSourceModal(modalName): void {
    const dialogRef = this.dialog.open(FundingSourceComponent, {
      width: '1000px',
      height: '700px',
      data: { client: this.client, hcDataV2: this.hcDataV2, modalName: modalName }
    });

    dialogRef.afterClosed().subscribe(result => {

      this.fundingItems.push(result.data);
      this.fundingTableCount();

    });
  }

  formatName() {
    if (this.client) {
      return this.client.clientProfile && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName ?
        this.client.client.FirstName + ' and ' + this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.client.LastName
        : this.client.client.FirstName + ' ' + this.client.client.LastName
    }
  }

  AddFundingSource() {
    
  }

  toggleSpouseHC() {
    this.spouseHCOptionsVisible = !this.spouseHCOptionsVisible;
  }

  toggleDuration() {
    this.FrmPV = this.FrmPV == 0 ? 1 : 0;
    this.getHCData(this.client, this.partnerActive);
  }

  handleEditClientModal(e) {
    //this.modalService.add('add-edit-client', { ID: this.client.client.ID });
    this.router.navigate(['/clients/edit']);
  }

  selectInvestmentOption(option) {
    this.investmentOptionValue = option;
  }

  altNum = 0;
  addTab(selectAfterAdding: boolean) {
    this.altNum += 1;
    //Alternate
    this.tabs.push('What If ' + this.altNum); //add number to it?

    if (selectAfterAdding) {
      this.selected.setValue(this.tabs.length - 1);
    }
  }

  //can only remove all other Alts - not the first; force user to change the first Alt
  removeTab(index: number) {
    console.log('index for tab', index);
    if(this.altNum >= 1){
      this.altNum -= 1;
    } 

    this.tabs.splice(index, 1);

    //reset the alt to be like current
    //this.altScenario = this.currentScenario;
    this.loadingService.isLoading(true);
    this.hasAlternateScenario = false;
    this.getClient();
  }

  addAltScenario(){
    this.editingScenario = 'Alternate';
    this.tabs.push('What If'); //add number to it?

    //add another button to add multiple tabs
    //this.tabs.push(' + ');
  }

  editingScenario;
  panelOpenState = false;
  editAltScenario(scenario){
    this.editingScenario = scenario;
  }

  cancelEditAltScenario(tab){
    if(this.hasClickedAltSaveButton){
      this.editingScenario = '';
    } else {
      //this should only be hit on first tab the first time (i.e. if add alt was clicked and then canceled before saving)
      //this.editingScenario = '';
      //this.removeTab(1);
      this.tabs = [];
    }
  }

  displayPrimaryScenarioPopup(scenario){
    console.log('when primary is set Spouse obj', this.copyOfClientProfile);
    console.log('when primary is set Orig Spouse obj', this.client.clientProfile);
    const dialogRef = this.dialog.open(BasicQuestionComponent, {     
      data: { title: 'Notification!',
      btnNoTitle: 'No, do not change the client profile',
      btnYesTitle: 'Yes, update the client profile',
      question: "The “Set As Primary” option will update client profile(s) with the information<br/>currently selected in the What If scenario. Do you want to proceed?" + 
        ((this.displayHC && !this.displayLTC 
          && (this.copyOfClientProfile.RetirementState != this.client.clientProfile.RetirementState || ((this.partnerActive) ? this.copyOfSpouseProfile.state != this.client.clientProfile.Spouses[0].state : false))) 
          ? "<br/><br/>Note: By changing state of residence in retirement, the metro region is defaulted to State Average.<br/>To select a specific metro region, select a location in the LTC or Combined questionnaire." : "")
    }
    });

    //NOTE: do we limit how many times its show to the user?
    dialogRef.afterClosed().subscribe(result => {
      //console.log('result', result);  
      if(result){
        this.setScenarioAsPrimary(scenario);
      }
    }); 
  }

  setAltScenarioAsPrimary = false;
  ssOrginal;
  setScenarioAsPrimary(scenario){
    this.loadingService.isLoading(true);
    //TODO: take this scenario and convert it into the Primary
    //TODO: should we prompt them? Are you sure you wanna do this: Yes | No ?
    this.setAltScenarioAsPrimary = true;

    if(this.displaySS){
      this.ssOrginal = this.ssData;
      this.ssData = this.ssDataAlt;
    }

    //TODO: scenario = the tab this is clicked on; right now we only have one scenario
    this.currentScenario = {
      clientRetirementAge: this.clientModelV2.generalInformation.retirementAge,
      clientRetirementState: this.retirementAreaForm.value.clientRetirementState,
      clientLifeExpectancy: this.clientModelV2.healthInformation.lifeExpectancy,
      clientMedicareCoverage: this.medicareTitle,
      clientTotalHCC: this.altScenario.clientTotalHCC,//this.futureTotalCost,
      clientTotalNetHCC: (this.displayHC) ? this.hcDataV2.P1NetRetirementHCCost : 0,
      clientTotalAvgHCC: this.altScenario.clientTotalAvgHCC,
      clientTotalNetAvgHCC: this.altScenario.clientTotalNetAvgHCC,
      clientRetirementHorizon: this.altScenario.clientRetirementHorizon,//this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge),
      clientRetirementYears: this.altScenario.clientRetirementYears,//(this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - this.hcDataV2.RetirementYear),
      clientRetirementStartYear: (this.displayHC) ? this.hcDataV2.RetirementYear : 0,
      clientLTCBeginYear: this.altScenario.clientLTCBeginYear,//this.responseLTC.LTCYear,
      clientLTCAnnualHHC: this.altScenario.clientLTCAnnualHHC,//Utils.formatToNumber(this.responseLTC.FutureCostTotal),
      clientLTCAnnualALF: this.altScenario.clientLTCAnnualALF,//Utils.formatToNumber(this.responseLTC.FutureCostTotal),
      clientLTCAnnualNHC: this.altScenario.clientLTCAnnualNHC,//Utils.formatToNumber(this.responseLTC.FutureCostTotal),
      clientLTCAnnualIC: this.altScenario.clientLTCAnnualIC,
      clientMetroArea: this.altScenario.clientMetroArea,
      clientMetroAreaName: this.altScenario.clientMetroAreaName,

      spouseRetirementAge: this.clientModelV2.maritalStatus.retirementAge,
      spouseRetirementState: this.retirementAreaForm.value.spouseRetirementState,
      spouseLifeExpectancy: this.clientModelV2.maritalStatus.lifeExpectancy,
      sposeMedicareCoverage: this.spouseMedicareTitle,
      spouseTotalHCC: this.altScenario.spouseTotalHCC,//this.futureTotalCost,
      spouseTotalAvgHCC: this.altScenario.spouseTotalAvgHCC,
      spouseTotalNetAvgHCC: this.altScenario.spouseTotalNetAvgHCC,
      spouseRetirementHorizon: this.altScenario.spouseRetirementHorizon,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) + ' to ' + (this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
      spouseRetirementYears: this.altScenario.spouseRetirementYears,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
      spouseRetirementStartYear: (this.displayHC) ? this.hcDataV2.SpouseRetirementYear : 0,
      spouseLTCBeginYear: this.altScenario.spouseLTCBeginYear,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.responseLTC.LTCYear1 : 0,
      spouseLTCAnnualHHC: this.altScenario.spouseLTCAnnualHHC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseLTCAnnualALF: this.altScenario.spouseLTCAnnualALF,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseLTCAnnualNHC: this.altScenario.spouseLTCAnnualNHC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseLTCAnnualIC: this.altScenario.spouseLTCAnnualIC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseMetroArea: this.altScenario.spouseMetroArea,
      spouseMetroAreaName: this.altScenario.spouseMetroAreaName,

      //totalCombinedHCC: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.currentScenario.spouseTotalHCC + this.currentScenario.clientTotalHCC : this.currentScenario.clientTotalHCC,
      totalCombinedHCC: this.altScenario.totalCombinedHCC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.futureTotalCost + this.futureTotalCost : this.futureTotalCost,
      totalCombinedHCYears: this.altScenario.totalCombinedHCYears,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) + (this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - this.hcDataV2.RetirementYear) : (this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - this.hcDataV2.RetirementYear)
    
      clientMedicarePartBAndPremiums: this.altScenario.clientMedicarePartBAndPremiums,
      clientLifetimeIRMAASurcharges: this.altScenario.clientLifetimeIRMAASurcharges,
      clientLifetimeIRMAASurchargesAvgPerYear: this.altScenario.clientLifetimeIRMAASurchargesAvgPerYear,

      spouseMedicarePartBAndPremiums: this.altScenario.spouseMedicarePartBAndPremiums,
      spouseLifetimeIRMAASurcharges: this.altScenario.spouseLifetimeIRMAASurcharges,
      spouseLifetimeIRMAASurchargesAvgPerYear: this.altScenario.spouseLifetimeIRMAASurchargesAvgPerYear,

      householdIncomeBracket: this.altScenario.householdIncomeBracket,
      socialSecurityInvestment: this.altScenario.socialSecurityInvestment
    };

    if(this.displayHC){
      this.altScenario.clientTotalNetAvgHCC = Math.round(this.altScenario.clientTotalNetHCC/this.altScenario.clientRetirementYears);
    }
        
    //save to client profile
    this.saveToClientProfile(false);
  }

  copyOfClientProfile;
  copyOfSpouseProfile;
  saveToClientProfile(isRevert = false){
    //this.loadingService.isLoading(true);
    
    //create copy for reverting save/update of client
    /* if(!this.copyOfClientProfile && !isRevert){
      this.copyOfClientProfile = { ...this.client.clientProfile };
    } */

    console.log('clientProfile before save', this.client.clientProfile);

    var ClientProfile = {};

    if(isRevert){
      
      ClientProfile = {
        //basic client info here...
        ClientID: this.copyOfClientProfile.ClientID,
        MaritalStatus: this.copyOfClientProfile.MaritalStatus,
        CurrentIncome: this.copyOfClientProfile.CurrentIncome,
        IRR: this.copyOfClientProfile.IRR,//iRR,
        InflationRate: this.copyOfClientProfile.InflationRate,
        RetirementAge: this.copyOfClientProfile.RetirementAge,
        Pension: this.copyOfClientProfile.Pension,
        RetirementState: this.copyOfClientProfile.RetirementState,
        SpouseID: this.copyOfClientProfile.SpouseID,
        LifeExpectancy: this.copyOfClientProfile.LifeExpectancy,
        HCHBP: this.copyOfClientProfile.HCHBP ? 1 : 0,
        HCHC: this.copyOfClientProfile.HCHC ? 1 : 0,
        HCT2D: this.copyOfClientProfile.HCT2D ? 1 : 0,
        HCCD: this.copyOfClientProfile.HCCD ? 1 : 0,
        HCC: this.copyOfClientProfile.HCC ? 1 : 0,
        HCT: this.copyOfClientProfile.HCT ? 1 : 0,

        HCALZ: this.copyOfClientProfile.HCALZ ? 1 : 0,
        HCPARK: this.copyOfClientProfile.HCPARK ? 1 : 0,
        HCAMP: this.copyOfClientProfile.HCAMP ? 1 : 0,
        HCPTSD: this.copyOfClientProfile.HCPTSD ? 1 : 0,
        HCOBS: this.copyOfClientProfile.HCOBS ? 1 : 0,

        HCCDYrsDiag: this.copyOfClientProfile.HCCDYrsDiag || 0,
        HCCYrsDiag: this.copyOfClientProfile.HCCYrsDiag || 0,
        Spouses: JSON.stringify(this.copyOfClientProfile.Spouses),
        // if we add ss data then Children will be save as '[]'
        Children: this.copyOfClientProfile.Children && this.copyOfClientProfile.Children.length > 0 ? this.copyOfClientProfile.Children : null,
        IncludePension: this.copyOfClientProfile.IncludePension,
        HouseholdYearOneIncome: this.copyOfClientProfile.HouseholdYearOneIncome,
        HouseholdYearOneIncomeChangeYear: null,
        UseNationalAverage: this.copyOfClientProfile.UseNationalAverage,
        IsRunReportWithSpouse: this.copyOfClientProfile.IsRunReportWithSpouse,
        IsLegalSpouse: this.copyOfClientProfile.IsLegalSpouse,
        HCT1D: this.copyOfClientProfile.HCT1D ? 1 : 0,
        HCMS: this.copyOfClientProfile.HCMS ? 1 : 0,
        HCDCW: this.copyOfClientProfile.HCDCW ? 1 : 0,
        HCFHDC: this.copyOfClientProfile.HCFHDC ? 1 : 0,

        IsHSApplySpouse: this.copyOfClientProfile.IsHSApplySpouse,

        //healthcare/MMT...
        IsPrivHealthIns: this.copyOfClientProfile.IsPrivHealthIns,
        CoverageType: this.copyOfClientProfile.CoverageType,        
        PremiumType: this.copyOfClientProfile.PremiumType,

        Premiums: JSON.stringify(this.copyOfClientProfile.Premiums),
                
        IsSpousePrivHealthIns: this.copyOfClientProfile.IsSpousePrivHealthIns,
        SpouseCoverageType: this.copyOfClientProfile.SpouseCoverageType,
        
        SpousePremiumType: this.copyOfClientProfile.SpousePremiumType,
        SpousePremiums: (this.copyOfClientProfile.SpousePremiums) ? JSON.stringify(this.copyOfClientProfile.SpousePremiums) : null,
        
        Bracket: this.copyOfClientProfile.Bracket,
        
        InRetirementInflationRate: this.copyOfClientProfile.InRetirementInflationRate,
        MAGIPercentIncome: this.copyOfClientProfile.MAGIPercentIncome,
        OOPCosts: JSON.stringify(this.copyOfClientProfile.OOPCosts),
        SpouseOOPCosts: (this.copyOfClientProfile.SpouseOOPCosts && this.copyOfClientProfile.SpouseOOPCosts != 'null') ? JSON.stringify(this.copyOfClientProfile.SpouseOOPCosts) : null,
        
        //Long term care...
        ClientMetroArea: this.copyOfClientProfile.ClientMetroArea,
        SpouseMetroArea: this.copyOfClientProfile.SpouseMetroArea,
        
        //Social Security stuff here...
        PensionMonths: this.copyOfClientProfile.PensionMonths,
        PensionYears: this.copyOfClientProfile.PensionYears,
        SubstantialEarningYears: this.copyOfClientProfile.SubstantialEarningYears,
        PIA: this.copyOfClientProfile.PIA,
        PIAYears: (!this.copyOfClientProfile.PIAYears || this.copyOfClientProfile.PIAYears == 'null') ? null : JSON.stringify(this.copyOfClientProfile.PIAYears),
        YearOfStatement: this.copyOfClientProfile.YearOfStatement,

        SelfSupplementalPlan: this.copyOfClientProfile.SelfSupplementalPlan,
        SpouseSupplementalPlan: this.copyOfClientProfile.SpouseSupplementalPlan
       }

       console.log('resetting back', ClientProfile);

    } else {

      let premiums = null;
      console.log('this.medicareCoverageForm', this.profileInfo)
      if(this.profileInfo.value.HealthCarePremiumType == 'TM'){
        premiums = {
          "MedicarePartB": this.profileInfo.value.MedicarePartB,
          "MedicarePartD": this.profileInfo.value.MedicarePartD,
          "SupplimentalInsurance": this.profileInfo.value.SupplimentalInsurance,
          "DentalInsurance": this.profileInfo.value.DentalInsurance
        }
        console.log('premiumns', premiums)
      } else if(this.profileInfo.value.HealthCarePremiumType == 'HMO'){
        premiums = {
          "MedicareAdvantageHMO": true,
          "DentalInsurance": this.profileInfo.value.DentalInsurance
        }
      } else if(this.profileInfo.value.HealthCarePremiumType == 'PPO'){
        premiums = { 
          "MedicareAdvantagePPO": true,
          "DentalInsurance": this.profileInfo.value.DentalInsurance
        }
      }
  
      let oopCosts = {
        "HospitalAndTest": this.profileInfo.value.HospitalAndTest,
        "PrescriptionDrugs": this.profileInfo.value.PrescriptionDrugs,
        "HearingAndVisionCosts": this.profileInfo.value.HearingAndVisionCosts,
        "DentalCosts": this.profileInfo.value.DentalCosts
      }
  
      let spousePremiums = null;
      let spouseOOPCosts = null;

      if (this.partnerActive) {
        if(this.incomeRangeSelectionForm.value.IncomeValue){
          this.client.clientProfile.CurrentIncome = Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) / 2;
          this.client.clientProfile.Spouses[0].currentIncome = parseInt(Math.round(Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) / 2).toString());

          if (this.client.clientProfile.CurrentIncome && !this.client.clientProfile.HouseholdYearOneIncome) {
            this.incomeSubTitle = 'Household Income:'
            this.client.clientProfile.CurrentIncome = this.client.clientProfile.HouseholdYearOneIncome;
          } else {
            this.incomeSubTitle = 'Household Income at Year 1 of Retirement:';
          }

          this.displayClientBracketText = this.incomeRangeSelectionForm.value.IncomeValue;
        } else {
          if (this.responseMMTBracket) {
            this.displayClientBracket(this.client.clientProfile.Bracket);
          }
        }

        if(this.profileInfo.value.IsSpouseSameHCSelection){
          this.spouseProfileInfo.controls['HealthCarePremiumType'].setValue(this.profileInfo.value.HealthCarePremiumType);
        }
  
        if(this.spouseProfileInfo.value.HealthCarePremiumType == 'TM'){
          console.log('this.spouseProfileInfo.value.MedicarePartB', this.spouseProfileInfo.value.MedicarePartB)
          spousePremiums = {
            "SpouseMedicarePartB": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.MedicarePartB : this.spouseProfileInfo.value.MedicarePartB,
            "SpouseMedicarePartD": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.MedicarePartD : this.spouseProfileInfo.value.MedicarePartD,
            "SpouseSupplimentalInsurance": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.SupplimentalInsurance : this.spouseProfileInfo.value.SupplimentalInsurance,
            "SpouseDentalInsurance": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.DentalInsurance : this.spouseProfileInfo.value.DentalInsurance
          } 
        } else if(this.spouseProfileInfo.value.HealthCarePremiumType == 'HMO'){
          this.spouseProfileInfo.controls['MedicareAdvantageHMO'].enable();
          this.profileInfo.controls['MedicareAdvantageHMO'].enable();
          spousePremiums = {
            "SpouseMedicareAdvantageHMO": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.MedicareAdvantageHMO : this.spouseProfileInfo.value.MedicareAdvantageHMO,
            "SpouseDentalInsurance": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.DentalInsurance : this.spouseProfileInfo.value.DentalInsurance
          }

          this.spouseProfileInfo.controls['MedicareAdvantageHMO'].disable();
          this.profileInfo.controls['MedicareAdvantageHMO'].disable();
        } else if(this.spouseProfileInfo.value.HealthCarePremiumType == 'PPO'){
          this.spouseProfileInfo.controls['MedicareAdvantagePPO'].enable();
          this.profileInfo.controls['MedicareAdvantagePPO'].enable();
          spousePremiums = { 
            "SpouseMedicareAdvantagePPO": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.MedicareAdvantagePPO : this.spouseProfileInfo.value.MedicareAdvantagePPO,
            "SpouseDentalInsurance": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.DentalInsurance : this.spouseProfileInfo.value.DentalInsurance
          }

          this.spouseProfileInfo.controls['MedicareAdvantagePPO'].disable();
          this.profileInfo.controls['MedicareAdvantagePPO'].disable();
        }
  
        spouseOOPCosts = {
          "SpouseHospitalAndTest": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.HospitalAndTest : this.spouseProfileInfo.value.HospitalAndTest,
          "SpousePrescriptionDrugs": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.PrescriptionDrugs : this.spouseProfileInfo.value.PrescriptionDrugs,
          "SpouseHearingAndVisionCosts": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.HearingAndVisionCosts : this.spouseProfileInfo.value.HearingAndVisionCosts,
          "SpouseDentalCosts": (this.profileInfo.value.IsSpouseSameHCSelection) ? this.profileInfo.value.DentalCosts : this.spouseProfileInfo.value.DentalCosts
        }

        console.log('the spouse premiums obj', spousePremiums);
      }
    
      this.client.clientProfile.Children = JSON.stringify(this.client.clientProfile.Children);

      ClientProfile = {
        //basic client info here...
        ClientID: this.client.clientProfile.ClientID,
        MaritalStatus: this.client.clientProfile.MaritalStatus,
        CurrentIncome: (this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 2) 
          ? (this.partnerActive) ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) / 2 : Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) 
          : this.client.clientProfile.CurrentIncome,//(this.incomeRangeSelectionForm.value.BracketValue ? null : this.client.clientProfile.CurrentIncome),
        IRR: (this.incomeRangeSelectionForm.value.IncomeReplacementRatio && this.incomeRangeSelectionForm.value.IncomeOption == 2) ? Utils.removePercentageFormatting(this.incomeRangeSelectionForm.value.IncomeReplacementRatio) : this.client.clientProfile.IRR,//iRR,
        InflationRate: (this.incomeRangeSelectionForm.value.IncomeInflationRate && this.incomeRangeSelectionForm.value.IncomeOption == 2) ? Utils.removePercentageFormatting(this.incomeRangeSelectionForm.value.IncomeInflationRate) : this.client.clientProfile.InflationRate,//(this.incomeRangeSelectionForm.value.BracketValue ? null : this.client.clientProfile.InflationRate),
        RetirementAge: this.client.clientProfile.RetirementAge,
        Pension: this.client.clientProfile.Pension,
        RetirementState: this.client.clientProfile.RetirementState,
        SpouseID: this.client.clientProfile.SpouseID,
        LifeExpectancy: this.client.clientProfile.LifeExpectancy,
        HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
        HCHC: this.client.clientProfile.HCHC ? 1 : 0,
        HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
        HCCD: this.client.clientProfile.HCCD ? 1 : 0,
        HCC: this.client.clientProfile.HCC ? 1 : 0,
        HCT: this.client.clientProfile.HCT ? 1 : 0,

        HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
        HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
        HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
        HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
        HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,

        HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag || 0,
        HCCYrsDiag: this.client.clientProfile.HCCYrsDiag || 0,
        Spouses: JSON.stringify(this.client.clientProfile.Spouses),
        // if we add ss data then Children will be save as '[]'
        Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? this.client.clientProfile.Children : null,//JSON.stringify(this.client.clientProfile.Children),
        IncludePension: this.client.clientProfile.IncludePension,
        HouseholdYearOneIncome: (this.incomeRangeSelectionForm.value.IncomeValue && this.incomeRangeSelectionForm.value.IncomeOption == 3) ? Utils.removeCurrencyFormatting(this.incomeRangeSelectionForm.value.IncomeValue) : this.client.clientProfile.HouseholdYearOneIncome,//(this.incomeRangeSelectionForm.value.BracketValue ? null : this.client.clientProfile.HouseholdYearOneIncome),
        HouseholdYearOneIncomeChangeYear: null,
        UseNationalAverage: this.client.clientProfile.UseNationalAverage,
        IsRunReportWithSpouse: this.client.clientProfile.IsRunReportWithSpouse,
        IsLegalSpouse: this.client.clientProfile.IsLegalSpouse,
        HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
        HCMS: this.client.clientProfile.HCMS ? 1 : 0,
        HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
        HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,

        IsHSApplySpouse: this.profileInfo.value.IsSpouseSameHCSelection != null ? this.profileInfo.value.IsSpouseSameHCSelection: this.client.clientProfile.IsHSApplySpouse,

        //healthcare/MMT...
        // IsPrivHealthIns: this.profileInfo.value.privateHealthInsurance ? (this.profileInfo.value.privateHealthInsurance == 'true'? true: false):this.client.clientProfile.IsPrivHealthIns,
        IsPrivHealthIns: this.profileInfo.value.privateHealthInsurance,//this.profileInfo.value.privateHealthInsurance ? (this.profileInfo.value.privateHealthInsurance == 'true'? true: false):this.client.clientProfile.IsPrivHealthIns,
        CoverageType: this.profileInfo.value.preRetirementCoverageType ? this.profileInfo.value.preRetirementCoverageType: this.client.clientProfile.CoverageType,        
        PremiumType: this.profileInfo.value.HealthCarePremiumType ? this.profileInfo.value.HealthCarePremiumType: this.client.clientProfile.PremiumType,
        Premiums:  this.profileInfo.value.HealthCarePremiumType ? JSON.stringify(premiums): JSON.stringify(JSON.parse(this.client.clientProfile.Premiums)),
                
        IsSpousePrivHealthIns: this.spouseProfileInfo.value.privateHealthInsurance,// ? (this.spouseProfileInfo.value.privateHealthInsurance == 'true'? true: false): this.client.clientProfile.IsSpousePrivHealthIns,
        SpouseCoverageType: this.spouseProfileInfo.value.preRetirementCoverageType ? this.spouseProfileInfo.value.preRetirementCoverageType: this.client.clientProfile.SpouseCoverageType,
        
        SpousePremiumType: this.spouseProfileInfo.value.HealthCarePremiumType ? this.spouseProfileInfo.value.HealthCarePremiumType : this.client.clientProfile.SpousePremiumType,
        SpousePremiums: this.spouseProfileInfo.value.HealthCarePremiumType ? JSON.stringify(spousePremiums): (this.client.clientProfile.SpousePremiums) ? JSON.stringify(this.client.clientProfile.SpousePremiums) : null,
        
        Bracket: (this.displayHC) ? this.selectedIRMAABracket : this.client.clientProfile.Bracket,//this.incomeRangeSelectionForm.value.BracketValue ? this.incomeRangeSelectionForm.value.BracketValue : null,
        
        InRetirementInflationRate: this.client.clientProfile.InRetirementInflationRate,//(this.incomeRangeSelectionForm.value.BracketValue ? null : this.client.clientProfile.InRetirementInflationRate),
        MAGIPercentIncome: (this.displayMMT) ? this.valueMAGISlider : (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,
        //MAGIPercentIncome: this.client.clientProfile.MAGIPercentIncome,//this.isOptionEnter && this.additinalIncomeForm.value.MAGIPerc ? Utils.removePercentageFormatting(this.additinalIncomeForm.value.MAGIPerc): null,
        OOPCosts: this.profileInfo.value.HealthCarePremiumType ? JSON.stringify(oopCosts): JSON.stringify(JSON.parse(this.client.clientProfile.OOPCosts)),
        SpouseOOPCosts: (this.partnerActive) ? this.spouseProfileInfo.value.HealthCarePremiumType ? JSON.stringify(spouseOOPCosts): JSON.stringify(this.client.clientProfile.SpouseOOPCosts) : this.client.clientProfile.SpouseOOPCosts,
        
        //Long term care...
        //default to state average if state was changed on the HC QR
        ClientMetroArea: (this.displayHC && !this.displayLTC && this.copyOfClientProfile.RetirementState != this.client.clientProfile.RetirementState && this.client.clientProfile.ClientMetroArea) ? 0 : this.client.clientProfile.ClientMetroArea,
        SpouseMetroArea: (this.displayHC && !this.displayLTC && this.copyOfSpouseProfile.state != this.client.clientProfile.Spouses[0].state && this.client.clientProfile.SpouseMetroArea) ? 0 : this.client.clientProfile.SpouseMetroArea,
        
        //Social Security stuff here...
        PensionMonths: this.client.clientProfile.PensionMonths,
        PensionYears: this.client.clientProfile.PensionYears,
        SubstantialEarningYears: this.client.clientProfile.SubstantialEarningYears,
        PIA: this.client.clientProfile.PIA,
        PIAYears: (!this.client.clientProfile.PIAYears || this.client.clientProfile.PIAYears == 'null') ? null : JSON.stringify(this.client.clientProfile.PIAYears),
        YearOfStatement: this.client.clientProfile.YearOfStatement,

        SelfSupplementalPlan: this.profileInfo.value.supplementalPlanType,
        SpouseSupplementalPlan: this.spouseProfileInfo.value.supplementalPlanType
       }

       console.log('setting as primary', ClientProfile);
       
       this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
      }
           
      var UserModel = {
        ID: this.client.client ? this.client.client.ID : 0,
        FirstName: this.client.client.FirstName,
        LastName: this.client.client.LastName,
        AdvisorID: this.client.client.AdvisorID,
        OrganizationID: this.client.client.OrganizationID,
        Username: this.client.client.Username,
        GenderID: this.client.client.GenderID,
        DOB: this.client.client.DOB,
        Email: this.client.client.Email,
        Phone: this.client.client.Phone,
        Address: this.client.client.Address,
        City: this.client.client.City,
        State: this.client.client.State,
        Zip: this.client.client.Zip,
      }

      var RiskTolerance = null;

      //NOTE: do we need this on Quick?
      //looks like the service ignores them if null/undefined and doesnt effect updating a client
      var AdditionalQuestion = null;
      var MidRetirementAdj = null;
      let LstMAGIProj = [];
      
      this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion, MidRetirementAdj, LstMAGIProj)
      .subscribe(
        resp => {
          //saved to profile

          //after setting to primary, the original obj is still in play and wont update when downloading a PDF after Set to Primary is invoked
          this.getClient();
         /*  if(this.setAltScenarioAsPrimary){
            this.getClient();
          } else {
            this.loadingService.isLoading(false);
          } */

          //need to push changes to the sidenav for display purposes
          this.sidebarService.ignorePageRefresh = true;
          this.sidebarService.pushUpdatesToClient(true);
        },
        error => {
  
        });
  }

  selectMetro(){
    /* if(this.metroAreaForm.value.applySameMetroRegionForSpouse){
      this.metroAreaForm.controls['spouseMetroRegion'].setValue(this.metroAreaForm.value.clientMetroRegion);
    } */
  }

  setPrimaryScenarioBackToOriginal(){
    this.loadingService.isLoading(true);
    console.log('setPrimaryScenarioBackToOriginal');
    this.setAltScenarioAsPrimary = false;

    if(this.displaySS){
      this.ssData = this.ssOrginal;
    }

    //TODO: set main card back to original client profile values
    //this.orgScenario
    console.log('clientRetirementYears 01', this.orgScenario.spouseRetirementAge)
    this.currentScenario = {
      clientRetirementAge: this.orgScenario.clientRetirementAge,
      clientRetirementState: this.orgScenario.clientRetirementState,
      clientLifeExpectancy: this.orgScenario.clientLifeExpectancy,
      clientMedicareCoverage: this.orgScenario.medicareCoverage,
      clientTotalHCC:  this.orgScenario.clientTotalHCC,//this.futureTotalCost,
      clientTotalNetHCC: this.orgScenario.clientTotalNetHCC,
      clientTotalAvgHCC: this.orgScenario.clientTotalAvgHCC,
      clientTotalNetAvgHCC: this.orgScenario.clientTotalNetAvgHCC,
      clientRetirementHorizon: this.orgScenario.clientRetirementHorizon,//this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge),
      clientRetirementYears: this.orgScenario.clientRetirementYears,//(this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - this.hcDataV2.RetirementYear),
      clientRetirementStartYear:  (this.displayHC) ? this.hcDataV2.RetirementYear : 0,
      clientLTCBeginYear: this.orgScenario.clientLTCBeginYear,//this.responseLTC.LTCYear,
      clientLTCAnnualHHC: this.orgScenario.clientLTCAnnualHHC,//Utils.formatToNumber(this.responseLTC.FutureCostTotal),
      clientLTCAnnualALF: this.orgScenario.clientLTCAnnualALF,//Utils.formatToNumber(this.responseLTC.FutureCostTotal),
      clientLTCAnnualNHC: this.orgScenario.clientLTCAnnualNHC,//Utils.formatToNumber(this.responseLTC.FutureCostTotal),
      clientLTCAnnualIC: this.orgScenario.clientLTCAnnualIC,//Utils.formatToNumber(this.responseLTC.FutureCostTotal),
      clientLTCTotal: 0,

      spouseRetirementAge: this.orgScenario.spouseRetirementAge,
      spouseRetirementState: this.orgScenario.spouseRetirementState,
      spouseLifeExpectancy: this.orgScenario.spouseLifeExpectancy,
      sposeMedicareCoverage: this.orgScenario.spouseMedicareCoverage,
      spouseTotalHCC: this.orgScenario.spouseTotalHCC,//this.futureTotalCost,
      spouseTotalAvgHCC: this.orgScenario.spouseTotalAvgHCC,
      spouseTotalNetAvgHCC: this.orgScenario.spouseTotalNetAvgHCC,
      spouseRetirementHorizon: this.orgScenario.spouseRetirementHorizon,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) + ' to ' + (this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
      spouseRetirementYears: this.orgScenario.spouseRetirementYears,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) : 0,
      spouseRetirementStartYear:  (this.displayHC) ? this.hcDataV2.SpouseRetirementYear : 0,
      spouseLTCBeginYear: this.orgScenario.spouseLTCBeginYear,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.responseLTC.LTCYear1 : 0,
      spouseLTCAnnualHHC: this.orgScenario.spouseLTCAnnualHHC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseLTCAnnualALF: this.orgScenario.spouseLTCAnnualALF,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseLTCAnnualNHC: this.orgScenario.spouseLTCAnnualNHC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseLTCAnnualIC: this.orgScenario.spouseLTCAnnualIC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? Utils.formatToNumber(this.responseLTC.FutureCostTotal1) : 0,
      spouseLTCTotal: 0,

      clientMedicarePartBAndPremiums: this.orgScenario.clientMedicarePartBAndPremiums,
      clientLifetimeIRMAASurcharges: this.orgScenario.clientLifetimeIRMAASurcharges,
      clientLifetimeIRMAASurchargesAvgPerYear: this.orgScenario.clientLifetimeIRMAASurchargesAvgPerYear,

      spouseMedicarePartBAndPremiums: this.orgScenario.spouseMedicarePartBAndPremiums,
      spouseLifetimeIRMAASurcharges: this.orgScenario.spouseLifetimeIRMAASurcharges,
      spouseLifetimeIRMAASurchargesAvgPerYear: this.orgScenario.spouseLifetimeIRMAASurchargesAvgPerYear,

      householdIncomeBracket: this.orgScenario.householdIncomeBracket,
      socialSecurityInvestment: this.orgScenario.socialSecurityInvestment,

      //totalCombinedHCC: (this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.currentScenario.spouseTotalHCC + this.currentScenario.clientTotalHCC : this.currentScenario.clientTotalHCC,
      totalCombinedHCC: this.orgScenario.totalCombinedHCC,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? this.futureTotalCost + this.futureTotalCost : this.futureTotalCost,
      totalCombinedHCYears: this.orgScenario.totalCombinedHCYears,//(this.clientModelV2.maritalStatus.maritalStatus === 'Married') ? ((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear) - (this.client.clientProfile.Spouses[0].retirementAge - this.calculateAge(this.client.clientProfile.Spouses[0].dob) + this.currentYear)) + (this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - this.hcDataV2.RetirementYear) : (this.hcDataV2.RetirementYear + (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge) - this.hcDataV2.RetirementYear)
      remainingUnfunded: 0,
    };

    if(this.displayHC){
      this.currentScenario.clientTotalNetAvgHCC = Math.round(this.currentScenario.clientTotalNetHCC/this.currentScenario.clientRetirementYears);
    }

    //save reverted client profile back to database
    this.saveToClientProfile(true);
  }

  validateNumber(val, min, max, isRequired) {
    val = val ? val.toString() : '';
    var numbers = val ? val.match(/\d/g).join('') : '';
    return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
  }

  validateString(val, isRequired) {
    var regex = /^[a-zA-Z ]{2,30}$/;
    return val ? regex.test(val) : !isRequired;
  }

  public clientModelV2: any = {
    generalInformation: {
      firstName: '',
      lastName: '',
      gender: '',
      dob: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      email: '',
      retirementAge: '',
      retirementState: '',
      maritalStatus: false
    },
    financialInformation: {
      currentIncome: '',
      irr: '',
      irrDollar:'',
      pia: '',
      PIAYears: {},
      pensionAmount: 0,
      pensionStartMonth: '',
      pensionStartYear: '',
      pensionSubEarnings: '',
      hasPension: '',
    },
    healthInformation: {
      HCC: false,
      HCCD: false,
      HCHBP: false,
      HCHC: false,
      HCT: false,
      HCT2D: false,
      
      HCALZ: false,
      HCPARK: false,
      HCAMP: false,
      HCPTSD: false,
      HCOBS: false,
      
      lifeExpectancy: '',
    },
    maritalStatus: {
      maritalStatus: 'Single',
      firstName: '',
      lastName: '',
      gender: '',
      lifeExpectancy: '',
      currentIncome: '',
      pia: '',
      PIAYears: {
        includePIA: '',
        startYear: '',
        endYear: '',
        years: [],
      },
    },
    spouses: [
      { maritalStatus: 'Single' }
    ],
    maritalHistory: {
      previousSpouseCount: 0,
      previouslyMarried: false,
    },
    dependentChildren: {
      children: [],
      hasKids: false,
    }
  };
  dateofBirth;
  yob;
  endOfPIAStartYear;
  endYear1;
  endYear2;
  endOfPIAEndYear;
  showAge;
  min;
  minAge;
  maxAge;
  spouseDateofBirth;
  spouseYob;
  spouseEndOfPIAStartYear;
  spouseEndYear1;
  spouseEndYear2;
  spouseEndOfPIAEndYear;
  spouseShowAge;
  SpouseMin;
  spouseMinAge;
  spouseMaxAge;
  mapToClientObject(client) {
    if (client.client && client.client.FirstName) {
      // General Information
      this.clientModelV2.generalInformation.firstName = client.client.FirstName;
      this.clientModelV2.generalInformation.lastName = client.client.LastName;
      this.clientModelV2.generalInformation.gender = client.client.GenderID;
      this.clientModelV2.generalInformation.dob = {
        date: {
          year: new Date(client.client.DOB).getFullYear(),
          month: new Date(client.client.DOB).getMonth() + 1,
          day: new Date(client.client.DOB).getDate()
        }
      };

      this.currentYear = new Date().getFullYear();
      this.dateofBirth = new Date(client.client.DOB).getFullYear();
      this.yob = this.dateofBirth + 14;
      this.endOfPIAStartYear = this.currentYear - this.yob + 1;      
      this.endYear1 = this.dateofBirth + 30;
      this.endYear2 = this.dateofBirth + 80;               
      this.endOfPIAEndYear = this.endYear2 - this.endYear1 + 1;   

      this.clientModelV2.generalInformation.dobStr = client.client.DOB;    

      if (this.clientModelV2.generalInformation.dobStr) {
        const convertAge = new Date(this.clientModelV2.generalInformation.dobStr);
        const timeDiff = Math.abs(Date.now() - convertAge.getTime());
        this.showAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365); 
       }  

      this.clientModelV2.generalInformation.address = client.client.Address;
      this.clientModelV2.generalInformation.city = client.client.City;
      this.clientModelV2.generalInformation.state = client.client.State;
      this.clientModelV2.generalInformation.zip = client.client.Zip;
      this.clientModelV2.generalInformation.phone = client.client.Phone;
      this.clientModelV2.generalInformation.email = client.client.Email;
      this.clientModelV2.generalInformation.useNationalAverage = client.clientProfile.UseNationalAverage || 0; // BP -> Add national average flag
      this.clientModelV2.generalInformation.retirementAge = client.clientProfile.RetirementAge;
      this.clientModelV2.generalInformation.retirementState = client.clientProfile.RetirementState;
      // Financial Information
      this.clientModelV2.financialInformation.currentIncome = (client.clientProfile.CurrentIncome != null) ? this.formatCurrencyV2(client.clientProfile.CurrentIncome) : 0;
      this.clientModelV2.financialInformation.irr = client.clientProfile.IRR + '%';
      this.clientModelV2.financialInformation.pia = this.formatCurrencyV2(client.clientProfile.PIA || 0);
      this.clientModelV2.financialInformation.PIAYears = JSON.parse(client.clientProfile.PIAYears) || {};
      this.clientModelV2.financialInformation.pensionAmount = this.formatCurrencyV2(client.clientProfile.Pension);
      this.clientModelV2.financialInformation.pensionStartMonth = client.clientProfile.PensionMonths;
      this.clientModelV2.financialInformation.pensionStartYear = client.clientProfile.PensionYears;
      this.clientModelV2.financialInformation.pensionSubEarnings = client.clientProfile.SubstantialEarningYears;
      this.clientModelV2.financialInformation.hasPension = client.clientProfile.IncludePension == 1 ? true : false;

      // Health Conditions
      this.clientModelV2.healthInformation.HCC = client.clientProfile.HCC == 1 ? true : false;
      this.clientModelV2.healthInformation.HCCD = client.clientProfile.HCCD == 1 ? true : false;
      this.clientModelV2.healthInformation.HCHBP = client.clientProfile.HCHBP == 1 ? true : false;
      this.clientModelV2.healthInformation.HCHC = client.clientProfile.HCHC == 1 ? true : false;
      this.clientModelV2.healthInformation.HCT = client.clientProfile.HCT == 1 ? true : false;
      this.clientModelV2.healthInformation.HCT2D = client.clientProfile.HCT2D == 1 ? true : false;

      this.clientModelV2.healthInformation.HCALZ = client.clientProfile.HCALZ == 1 ? true : false;
      this.clientModelV2.healthInformation.HCPARK = client.clientProfile.HCPARK == 1 ? true : false;
      this.clientModelV2.healthInformation.HCAMP = client.clientProfile.HCAMP == 1 ? true : false;
      this.clientModelV2.healthInformation.HCPTSD = client.clientProfile.HCPTSD == 1 ? true : false;
      this.clientModelV2.healthInformation.HCOBS = client.clientProfile.HCOBS == 1 ? true : false;

      this.clientModelV2.healthInformation.lifeExpectancy = client.clientProfile.LifeExpectancy;
     
      this.min = Math.min(this.clientModelV2.healthInformation.lifeExpectancy, this.clientModelV2.generalInformation.retirementAge + 1); 
      this.minAge = this.min
      this.maxAge = 100 - this.minAge + 1;

      //this.clientModelV2.spouses = JSON.parse(client.clientProfile.Spouses);
      console.log('Comb spouse', this.clientModelV2.spouses);

      if (this.clientModelV2.spouses[0] && this.clientModelV2.spouses[0].maritalStatus != "Single") {
        // Marital Status
        this.clientModelV2.maritalStatus.maritalStatus = typeof this.clientModelV2.spouses[0].maritalStatus === 'undefined' || typeof this.clientModelV2.spouses[0] === 'undefined' ? 'Single' : this.clientModelV2.spouses[0].maritalStatus;
        this.clientModelV2.maritalStatus.firstName = this.clientModelV2.spouses[0].firstName;
        this.clientModelV2.maritalStatus.lastName = this.clientModelV2.spouses[0].lastName;
        this.clientModelV2.maritalStatus.gender = this.clientModelV2.spouses[0].gender;
        this.clientModelV2.maritalStatus.lifeExpectancy = this.clientModelV2.spouses[0].LifeExpectancy;
        this.clientModelV2.maritalStatus.currentIncome = this.clientModelV2.spouses[0].currentIncome ? Utils.formatToCurrency(this.clientModelV2.spouses[0].currentIncome): null;


        this.clientModelV2.maritalStatus.anniversary = this.clientModelV2.spouses[0].anniversary ? {
          date: {
            year: new Date(this.clientModelV2.spouses[0].anniversary).getFullYear(),
            month: new Date(this.clientModelV2.spouses[0].anniversary).getMonth() + 1,
            day: new Date(this.clientModelV2.spouses[0].anniversary).getDate()
          }
        } : {};

      this.spouseDateofBirth = new Date(this.clientModelV2.spouses[0].anniversary).getFullYear();
      this.spouseYob = this.spouseDateofBirth + 14;
      this.spouseEndOfPIAStartYear = this.currentYear - this.spouseYob + 1;      
      this.spouseEndYear1 = this.spouseDateofBirth + 30;
      this.spouseEndYear2 = this.spouseDateofBirth + 80;               
      this.spouseEndOfPIAEndYear = this.spouseEndYear1 - this.spouseEndYear2 + 1; 

        this.clientModelV2.maritalStatus.anniversaryStr = this.clientModelV2.spouses[0].anniversary;

        this.clientModelV2.maritalStatus.dob = this.clientModelV2.spouses[0].dob ? {
          date: {
            year: new Date(this.clientModelV2.spouses[0].dob).getFullYear() || 0,
            month: new Date(this.clientModelV2.spouses[0].dob).getMonth() + 1 || 0,
            day: new Date(this.clientModelV2.spouses[0].dob).getDate() || 0
          }
        } : {};

        this.clientModelV2.maritalStatus.dobStr = this.clientModelV2.spouses[0].dob;


        if (this.clientModelV2.maritalStatus.dobStr) {
          const convertAge = new Date(this.clientModelV2.maritalStatus.dobStr);
          const timeDiff = Math.abs(Date.now() - convertAge.getTime());
          this.spouseShowAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365);           
         } 

         this.SpouseMin = Math.min(this.clientModelV2.maritalStatus.lifeExpectancy, this.clientModelV2.spouses[0].retirementAge);      
         this.spouseMinAge = this.SpouseMin
         this.spouseMaxAge = 100 - this.spouseMinAge + 1;  


        //this.clientModelV2.maritalStatus.pia = this.clientModelV2.spouses[0].pia ? this.formatCurrencyV2(this.clientModelV2.spouses[0].pia.replace(/,/g, '').replace('$', '')) : this.formatCurrencyV2(0);
        this.clientModelV2.maritalStatus.pia = this.clientModelV2.spouses[0].pia ? Utils.formatToCurrency(this.clientModelV2.spouses[0].pia) : this.formatCurrencyV2(0);
        this.clientModelV2.maritalStatus.PIAYears = this.clientModelV2.spouses[0].PIAYears || {};
        this.clientModelV2.maritalStatus.PIAYears.includePIA = this.clientModelV2.maritalStatus.PIAYears.IncludePIA;
        this.clientModelV2.maritalStatus.PIAYears.startYear = this.clientModelV2.maritalStatus.PIAYears.StartYear;
        this.clientModelV2.maritalStatus.PIAYears.endYear = this.clientModelV2.maritalStatus.PIAYears.EndYear;
        this.clientModelV2.maritalStatus.PIAYears.years = this.clientModelV2.maritalStatus.PIAYears.Years;
        this.clientModelV2.maritalStatus.includePension = this.clientModelV2.spouses[0].includePension;
        this.clientModelV2.maritalStatus.pensionAmount = this.formatCurrencyV2(this.clientModelV2.spouses[0].pension || this.clientModelV2.spouses[0].pensionAmount || 0);
        this.clientModelV2.maritalStatus.pensionMonths = this.clientModelV2.spouses[0].pensionMonth;
        this.clientModelV2.maritalStatus.pensionYears = this.clientModelV2.spouses[0].pensionYear;
        this.clientModelV2.maritalStatus.subEarnings = this.clientModelV2.spouses[0].substantialEarningYears;
        this.clientModelV2.maritalStatus.retirementAge = this.clientModelV2.spouses[0].retirementAge;
        this.clientModelV2.maritalStatus.retirementState = this.clientModelV2.spouses[0].state;
        this.clientModelV2.maritalStatus.HCC = this.clientModelV2.spouses[0].HCC == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCCD = this.clientModelV2.spouses[0].HCCD == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCHBP = this.clientModelV2.spouses[0].HCHBP == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCHC = this.clientModelV2.spouses[0].HCHC == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCT = this.clientModelV2.spouses[0].HCT == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCT2D = this.clientModelV2.spouses[0].HCT2D == 1 ? true : false;

        this.clientModelV2.maritalStatus.HCALZ = this.clientModelV2.spouses[0].HCALZ == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCPARK = this.clientModelV2.spouses[0].HCPARK == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCAMP = this.clientModelV2.spouses[0].HCAMP == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCPTSD = this.clientModelV2.spouses[0].HCPTSD == 1 ? true : false;
        this.clientModelV2.maritalStatus.HCOBS = this.clientModelV2.spouses[0].HCOBS == 1 ? true : false;
      } else {
        this.clientModelV2.maritalStatus.maritalStatus = 'Single';
      }


      if (this.clientModelV2.maritalStatus.maritalStatus === 'Single') {
        // Marital History
        this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
        this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; //this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
        this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;

        this.clientModelV2.maritalHistory.spousePreviouslyMarried = false;
        this.clientModelV2.maritalHistory.spousesSpouseCount = 0;
        this.clientModelV2.maritalHistory.spousesSpouse = [];
      } else {
        // Marital History
        this.clientModelV2.maritalHistory.previousSpouseCount = this.clientModelV2.spouses.length > 1 ? this.clientModelV2.spouses.length - 1 : 0;
        this.clientModelV2.maritalHistory.previouslyMarried = this.clientModelV2.spouses.length <= 1 ? false : true; // this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].previouslyMarried === 'boolean' ? this.clientModelV2.spouses[0].previouslyMarried : this.clientModelV2.spouses.length > 1;
        this.clientModelV2.maritalHistory.alive = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].alive === 'undefined' ? true : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].alive : false;
        this.clientModelV2.maritalHistory.tenyears = this.clientModelV2.spouses[0] && typeof this.clientModelV2.spouses[0].tenyears === 'undefined' ? false : this.clientModelV2.spouses[0] ? this.clientModelV2.spouses[0].tenyears : false;

        this.clientModelV2.spouses[0].maritalHistory = this.clientModelV2.spouses[0].maritalHistory || {};
        this.clientModelV2.maritalHistory.spousePreviouslyMarried = this.clientModelV2.spouses[0].maritalHistory.spousePreviouslyMarried || false;
        this.clientModelV2.maritalHistory.spousesSpouseCount = this.clientModelV2.spouses[0].maritalHistory.spousesSpouseCount || 0;
        this.clientModelV2.maritalHistory.spousesSpouse = this.clientModelV2.spouses[0].spousesSpouse || [];
      }

      if (!client.clientProfile.LifeExpectancy || client.clientProfile.LifeExpectancy == null) {
        if (this.clientModelV2.generalInformation.dobStr && this.clientModelV2.generalInformation.gender && this.clientModelV2.generalInformation.dobStr) {
          var leModel = this.clientModelV2.healthInformation;
          leModel.gender = this.clientModelV2.generalInformation.gender;
          leModel.dob = this.clientModelV2.generalInformation.dobStr;
          this.recalcLEV2(this.clientModelV2, 0, true);
        }
      }

      // Dependent Children
      var children = JSON.parse(client.clientProfile.Children) || [];

      this.clientModelV2.dependentChildren.children = children.children || children;
      this.clientModelV2.dependentChildren.hasKids = children.hasKids || children.length > 0;
      this.clientModelV2.dependentChildren.childrenCount = children.childrenCount || children.length;


      //basic missed mappings to the actual client object      
      this.client.clientProfile.HCCDYrsDiag = (this.client.clientProfile.HCCDYrsDiag) ? this.client.clientProfile.HCCDYrsDiag : 0;
      this.client.clientProfile.HCCYrsDiag = (this.client.clientProfile.HCCYrsDiag) ? this.client.clientProfile.HCCYrsDiag : 0;
    }
  }

  bracketChange(value: any, isBracketChange = false) {
    //Utils.formatToCurrency(
    //this.selectedIRMAABracket = value;
    console.log('bracket selected', this.selectedIRMAABracket);
    console.log('responseMMTBracket', this.responseMMTBracket);
    if(value <= 1){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket1) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket2 - 1);
    } else if(value == 2){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket2) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket3 - 1);
    } else if(value == 3){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket3) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket4 - 1);
    } else if(value == 4){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket4) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket5 - 1);
    } else if(value == 5){
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket5) + " to " + Utils.formatToCurrency(this.responseMMTBracket.Bracket6 - 1);
    } else {
      this.selectedIRMAABracketDisplay = Utils.formatToCurrency(this.responseMMTBracket.Bracket6) + " or more";
    }
    // this.isIncomeChange = isBracketChange ? true: this.isIncomeChange; // need after NW release
  }

  formatCurrencyV2(amount) {
    if(amount != null){
      amount = amount.toString().replace(/,/g, "").replace("$", "");
      return Utils.formatToCurrency(amount);
    } else {
      return Utils.formatToCurrency(0);
    }
  }

  recalcLEV2(model, index, firstLoad = false) {
    var LEObject;

    if (index === 0) {
      if (model.generalInformation.dobStr && model.generalInformation.gender) {
        LEObject = {
          gender: Number(model.generalInformation.gender),
          age: this.calculateAge(model.generalInformation.dobStr),
          healthConditions: {
            HCC: model.healthInformation.HCC ? 1 : 0,
            HCCD: model.healthInformation.HCCD ? 1 : 0,
            HCHBP: model.healthInformation.HCHBP ? 1 : 0,
            HCHC: model.healthInformation.HCHC ? 1 : 0,
            HCT: model.healthInformation.HCT ? 1 : 0,
            HCT2D: model.healthInformation.HCT2D ? 1 : 0,

            HCALZ: model.healthInformation.HCALZ ? 1 : 0,
            HCPARK: model.healthInformation.HCPARK ? 1 : 0,
            HCAMP: model.healthInformation.HCAMP ? 1 : 0,
            HCPTSD: model.healthInformation.HCPTSD ? 1 : 0,
            HCOBS: model.healthInformation.HCOBS ? 1 : 0,
          }
        }
      }
    } else if (index === 3) {
      if (model.maritalStatus.dobStr && model.maritalStatus.gender) {
        LEObject = {
          gender: Number(model.maritalStatus.gender),
          age: this.calculateAge(model.maritalStatus.dobStr),
          healthConditions: {
            HCC: model.maritalStatus.HCC ? 1 : 0,
            HCCD: model.maritalStatus.HCCD ? 1 : 0,
            HCHBP: model.maritalStatus.HCHBP ? 1 : 0,
            HCHC: model.maritalStatus.HCHC ? 1 : 0,
            HCT: model.maritalStatus.HCT ? 1 : 0,
            HCT2D: model.maritalStatus.HCT2D ? 1 : 0,

            HCALZ: model.maritalStatus.HCALZ ? 1 : 0,
            HCPARK: model.maritalStatus.HCPARK ? 1 : 0,
            HCAMP: model.maritalStatus.HCAMP ? 1 : 0,
            HCPTSD: model.maritalStatus.HCPTSD ? 1 : 0,
            HCOBS: model.maritalStatus.HCOBS ? 1 : 0,
          }
        }
      }
    }

    this.globalService.getLE(LEObject)
      .subscribe(
        le => {
          if (index === 0) {
            model.healthInformation.lifeExpectancy = le;
            this.clientModelV2.healthInformation.lifeExpectancy = le;
            this.min = Math.min(le, this.showAge);
            this.minAge = this.min;
            this.maxAge = 100 - this.minAge + 1;
          } else if (index === 3) {
            model.maritalStatus.lifeExpectancy = le;
            this.SpouseMin = Math.min(le, this.spouseShowAge);
            this.spouseMinAge = this.SpouseMin;
            this.spouseMaxAge = 100 - this.spouseMinAge + 1;
          }

        },
        error => { this.error = <any>error; });


  }

  clientHubRedirect(){
    this.router.navigate(['/clients/edit']);
  }

  isRetirementAgePanelOpen: boolean = false;
  retirementAgePanel(isPanelOpen){
    this.isRetirementAgePanelOpen = isPanelOpen;
  }

  pre65Panel(isPanelOpen: boolean){
    //console.log('triggered by auto opening via retirement age');
    if(this.isPre65 && (this.profileInfo.value.privateHealthInsurance == true || this.profileInfo.value.privateHealthInsurance == 'true')){
      //console.log('setting validation on preretirement coverage');
      //console.log('preretirement coverage', this.profileInfo.value.preRetirementCoverageType);
      if(this.profileInfo.value.preRetirementCoverageType == null){
        this.profileInfo.controls['preRetirementCoverageType'].setValue("");
      }

      this.profileInfo.get('preRetirementCoverageType').setValidators([Validators.required]);
    } else {
      this.profileInfo.get('preRetirementCoverageType').reset();
      this.profileInfo.get('preRetirementCoverageType').clearValidators();      
      this.profileInfo.get('preRetirementCoverageType').updateValueAndValidity();
    }

    if(this.partnerActive){
      if(this.isSpousePre65 && (this.spouseProfileInfo.value.privateHealthInsurance == true || this.spouseProfileInfo.value.privateHealthInsurance == 'true')){
        if(this.spouseProfileInfo.value.preRetirementCoverageType == null){
          this.spouseProfileInfo.controls['preRetirementCoverageType'].setValue("");
        }
  
        this.spouseProfileInfo.get('preRetirementCoverageType').setValidators([Validators.required]);
      } else {
        this.spouseProfileInfo.get('preRetirementCoverageType').reset();
        this.spouseProfileInfo.get('preRetirementCoverageType').clearValidators();      
        this.spouseProfileInfo.get('preRetirementCoverageType').updateValueAndValidity();
      }
    }
  }

  checkCheckBoxes(isClient: boolean){
    if(isClient){
      if(!this.profileInfo.value.MedicarePartB){
        this.profileInfo.controls['SupplimentalInsurance'].setValue(0);
        this.profileInfo.controls['SupplimentalInsurance'].disable();
        this.isSelectAllPremiums = false; 
        if(!this.profileInfo.value.MedicarePartD && !this.profileInfo.value.DentalInsurance){
          //this.profileInfo.controls['MedicarePartD'].setValue(1);
          //this.profileInfo.controls['MedicarePartD'].enable();     
        }
      } else {
        this.profileInfo.controls['SupplimentalInsurance'].enable();
      }
    } else {
      if(!this.spouseProfileInfo.value.MedicarePartB){
        this.spouseProfileInfo.controls['SupplimentalInsurance'].setValue(0);
        this.spouseProfileInfo.controls['SupplimentalInsurance'].disable();
        this.isSpouseSelectAllPremiums = false; 
        if(!this.spouseProfileInfo.value.MedicarePartD && !this.spouseProfileInfo.value.DentalInsurance){
          //this.spouseProfileInfo.controls['MedicarePartD'].setValue(1);
          //this.spouseProfileInfo.controls['MedicarePartD'].enable();     
        }
      } else {
        this.spouseProfileInfo.controls['SupplimentalInsurance'].enable();
      }
    }

    this.selectPremiumOrOOP(true, isClient);
  }

  selectPremiumOrOOP(premiums, isClient){
    var profileInfo = this.profileInfo;
    if(!isClient){
      profileInfo = this.spouseProfileInfo;
    }

    //if(premiums){
      if(premiums && ((profileInfo.value.MedicareAdvantageHMO || profileInfo.value.HealthCarePremiumType == 'HMO')
        || (profileInfo.value.MedicareAdvantagePPO || profileInfo.value.HealthCarePremiumType == 'PPO')
        || (profileInfo.value.MedicarePartB 
          && profileInfo.value.MedicarePartD 
          && profileInfo.value.SupplimentalInsurance))
          && profileInfo.value.DentalInsurance){
            if(isClient){
              this.isSelectAllPremiums = true; 
            } else {
              this.isSpouseSelectAllPremiums = true;
            }
        } else if (!premiums && profileInfo.value.HospitalAndTest
          && profileInfo.value.PrescriptionDrugs
          && profileInfo.value.HearingAndVisionCosts
          && profileInfo.value.DentalCosts){
            if(isClient){
              this.isSelectAllOOP = true; 
            } else {
              this.isSpouseSelectAllOOP = true;
            }
          } else if (profileInfo.value.HealthCarePremiumType == 'TM'){
          // at least one need to be selected
          console.log('profileInfo.value', profileInfo.value);
          if(isClient){
            this.isSelectAllPremiums = false; 
            this.isSelectAllOOP = false; 
          } else {
            this.isSpouseSelectAllPremiums = false; 
            this.isSpouseSelectAllOOP = false; 
          }

          profileInfo.controls['MedicarePartB'].enable();
          profileInfo.controls['MedicarePartD'].enable();
          //profileInfo.controls['SupplimentalInsurance'].enable();
          profileInfo.controls['DentalInsurance'].enable();
          
          profileInfo.controls['HospitalAndTest'].enable();
          profileInfo.controls['PrescriptionDrugs'].enable(); 
          profileInfo.controls['HearingAndVisionCosts'].enable(); 
          profileInfo.controls['DentalCosts'].enable();  

          if(profileInfo.value.MedicarePartB 
            && !profileInfo.value.MedicarePartD 
            //&& !profileInfo.value.SupplimentalInsurance
            && !profileInfo.value.DentalInsurance
            
            && !profileInfo.value.HospitalAndTest
            && !profileInfo.value.PrescriptionDrugs
            && !profileInfo.value.HearingAndVisionCosts
            && !profileInfo.value.DentalCosts){
              profileInfo.controls['MedicarePartB'].disable();  
              
              profileInfo.controls['DentalInsurance'].enable(); 
              profileInfo.controls['MedicarePartD'].enable(); 
              profileInfo.controls['SupplimentalInsurance'].enable();   

              profileInfo.controls['HospitalAndTest'].enable();
              profileInfo.controls['PrescriptionDrugs'].enable(); 
              profileInfo.controls['HearingAndVisionCosts'].enable(); 
              profileInfo.controls['DentalCosts'].enable();  
          } else if(!profileInfo.value.MedicarePartB 
            && profileInfo.value.MedicarePartD 
            //&& !profileInfo.value.SupplimentalInsurance
            && !profileInfo.value.DentalInsurance
            
            && !profileInfo.value.HospitalAndTest
            && !profileInfo.value.PrescriptionDrugs
            && !profileInfo.value.HearingAndVisionCosts
            && !profileInfo.value.DentalCosts){
              profileInfo.controls['MedicarePartD'].disable();   

              profileInfo.controls['MedicarePartB'].enable(); 
              profileInfo.controls['DentalInsurance'].enable(); 
              profileInfo.controls['SupplimentalInsurance'].enable();   

              profileInfo.controls['HospitalAndTest'].enable();
              profileInfo.controls['PrescriptionDrugs'].enable(); 
              profileInfo.controls['HearingAndVisionCosts'].enable(); 
              profileInfo.controls['DentalCosts'].enable();  
          /* } else if(!profileInfo.value.MedicarePartB 
            && !profileInfo.value.MedicarePartD 
            && profileInfo.value.SupplimentalInsurance
            && !profileInfo.value.DentalInsurance
            
            && !profileInfo.value.HospitalAndTest
            && !profileInfo.value.PrescriptionDrugs
            && !profileInfo.value.HearingAndVisionCosts
            && !profileInfo.value.DentalCosts){
              profileInfo.controls['SupplimentalInsurance'].disable();  
              
              profileInfo.controls['MedicarePartB'].enable(); 
              profileInfo.controls['MedicarePartD'].enable(); 
              profileInfo.controls['DentalInsurance'].enable();  
              
              profileInfo.controls['HospitalAndTest'].enable();
              profileInfo.controls['PrescriptionDrugs'].enable(); 
              profileInfo.controls['HearingAndVisionCosts'].enable(); 
              profileInfo.controls['DentalCosts'].enable();  */ 
          } else if(!profileInfo.value.MedicarePartB 
            && !profileInfo.value.MedicarePartD 
            //&& !profileInfo.value.SupplimentalInsurance
            && profileInfo.value.DentalInsurance
            
            && !profileInfo.value.HospitalAndTest
            && !profileInfo.value.PrescriptionDrugs
            && !profileInfo.value.HearingAndVisionCosts
            && !profileInfo.value.DentalCosts){
              profileInfo.controls['DentalInsurance'].disable();

              profileInfo.controls['MedicarePartB'].enable(); 
              profileInfo.controls['MedicarePartD'].enable(); 
              profileInfo.controls['SupplimentalInsurance'].enable();   

              profileInfo.controls['HospitalAndTest'].enable();
              profileInfo.controls['PrescriptionDrugs'].enable(); 
              profileInfo.controls['HearingAndVisionCosts'].enable(); 
              profileInfo.controls['DentalCosts'].enable();  
          } else if (!profileInfo.value.MedicarePartB 
            && !profileInfo.value.MedicarePartD 
            //&& !profileInfo.value.SupplimentalInsurance
            && !profileInfo.value.DentalInsurance

            && profileInfo.value.HospitalAndTest
            && !profileInfo.value.PrescriptionDrugs
            && !profileInfo.value.HearingAndVisionCosts
            && !profileInfo.value.DentalCosts){
              profileInfo.controls['HospitalAndTest'].disable();

              profileInfo.controls['PrescriptionDrugs'].enable(); 
              profileInfo.controls['HearingAndVisionCosts'].enable(); 
              profileInfo.controls['DentalCosts'].enable();   

              profileInfo.controls['DentalInsurance'].enable();
              profileInfo.controls['MedicarePartB'].enable(); 
              profileInfo.controls['MedicarePartD'].enable(); 
              profileInfo.controls['SupplimentalInsurance'].enable();   
          } else if (!profileInfo.value.MedicarePartB 
            && !profileInfo.value.MedicarePartD 
            //&& !profileInfo.value.SupplimentalInsurance
            && !profileInfo.value.DentalInsurance

            && !profileInfo.value.HospitalAndTest
            && profileInfo.value.PrescriptionDrugs
            && !profileInfo.value.HearingAndVisionCosts
            && !profileInfo.value.DentalCosts){
              profileInfo.controls['HospitalAndTest'].enable();

              profileInfo.controls['PrescriptionDrugs'].disable(); 
              profileInfo.controls['HearingAndVisionCosts'].enable(); 
              profileInfo.controls['DentalCosts'].enable();   

              profileInfo.controls['DentalInsurance'].enable();
              profileInfo.controls['MedicarePartB'].enable(); 
              profileInfo.controls['MedicarePartD'].enable(); 
              profileInfo.controls['SupplimentalInsurance'].enable();   
          } else if (!profileInfo.value.MedicarePartB 
            && !profileInfo.value.MedicarePartD 
            //&& !profileInfo.value.SupplimentalInsurance
            && !profileInfo.value.DentalInsurance

            && !profileInfo.value.HospitalAndTest
            && !profileInfo.value.PrescriptionDrugs
            && profileInfo.value.HearingAndVisionCosts
            && !profileInfo.value.DentalCosts){
              profileInfo.controls['HospitalAndTest'].enable();

              profileInfo.controls['PrescriptionDrugs'].enable(); 
              profileInfo.controls['HearingAndVisionCosts'].disable(); 
              profileInfo.controls['DentalCosts'].enable();   

              profileInfo.controls['DentalInsurance'].enable();
              profileInfo.controls['MedicarePartB'].enable(); 
              profileInfo.controls['MedicarePartD'].enable(); 
              profileInfo.controls['SupplimentalInsurance'].enable();   
          } else if (!profileInfo.value.MedicarePartB 
            && !profileInfo.value.MedicarePartD 
            //&& !profileInfo.value.SupplimentalInsurance
            && !profileInfo.value.DentalInsurance

            && !profileInfo.value.HospitalAndTest
            && !profileInfo.value.PrescriptionDrugs
            && !profileInfo.value.HearingAndVisionCosts
            && profileInfo.value.DentalCosts){
              profileInfo.controls['HospitalAndTest'].enable();

              profileInfo.controls['PrescriptionDrugs'].enable(); 
              profileInfo.controls['HearingAndVisionCosts'].enable(); 
              profileInfo.controls['DentalCosts'].disable();   

              profileInfo.controls['DentalInsurance'].enable();
              profileInfo.controls['MedicarePartB'].enable(); 
              profileInfo.controls['MedicarePartD'].enable(); 
              profileInfo.controls['SupplimentalInsurance'].enable();   
          }             
          
          if(!profileInfo.value.MedicarePartB && !profileInfo.controls['MedicarePartB'].disabled){
            profileInfo.controls['SupplimentalInsurance'].setValue(false); 
            profileInfo.controls['SupplimentalInsurance'].disable(); 
          } else {
            profileInfo.controls['SupplimentalInsurance'].enable(); 
          }
        }    
  }

  oopAdjustment(isClient){
    if(isClient && this.includeSpouse && this.profileInfo.value.IsSpouseSameHCSelection){
   
      this.spouseProfileInfo.controls['DentalInsurance'].setValue(this.profileInfo.value.DentalInsurance);
      this.spouseProfileInfo.controls['HospitalAndTest'].setValue(this.profileInfo.value.HospitalAndTest);
      this.spouseProfileInfo.controls['HearingAndVisionCosts'].setValue(this.profileInfo.value.HearingAndVisionCosts);
      this.spouseProfileInfo.controls['PrescriptionDrugs'].setValue(this.profileInfo.value.PrescriptionDrugs);
      this.spouseProfileInfo.controls['DentalCosts'].setValue(this.profileInfo.value.DentalCosts);
    }
  }

  navigateTo(page){
    if(page == "SS"){
      this.router.navigate(['/clients/edit/social-security/options/ss']);
    }
  }

  generatePIAObject(income) {
    let result = [];
    const totalYears = 30;
    const currentYear = new Date().getFullYear();

    for (let i = 0; i < totalYears; i++) {
        result.push({
            Year: currentYear - totalYears + i,
            ActualEarnings: income,
            MaxEarnings: 0,
            WeightedEarnings: 0,
            Age: totalYears + i
        })
    }

    return {
        currentAge: 62,
        earningYear: result
    }
}

/*   public surcharges: string = '$0';
  public medicarePremiums: string = '$0';
  public totalMedicareCost: string = '$0';
  public totalSavings: string = '$0';
  public incomeReductionAmount: string = '$0';
  
  public startingSurchargeAmount: number = -1;
  public startingIllustration: any[];
  public changedSSAge:boolean = false;

  calculateMMTSurchargeTotals(data: any) {
    var ts = 0, tp = 0, tm = 0, tss = 0;
    var savings = 0;

    for (var ageRange in data.MagiAdjustedAgeRangeCosts) {
        tp += data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount;
        ts += (data.MagiAdjustedAgeRangeCosts[ageRange].Amount - data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount);
        tm += data.MagiAdjustedAgeRangeCosts[ageRange].Amount;
    }

    if (this.startingSurchargeAmount === -1 || this.changedSSAge) {
        this.startingSurchargeAmount = ts;
        this.startingIllustration = data.IllustrationEntries;
        this.changedSSAge = false;
    } else {
        savings = Math.max(0, this.startingSurchargeAmount - ts);
    }
    
    this.medicarePremiums = this.formatCurrency(tp);
    this.surcharges = this.formatCurrency(ts);
    this.totalMedicareCost = this.formatCurrency(tm);

    this.totalSavings = this.formatCurrency(savings);
} */
}
